import { useMemo, useEffect, useContext, createContext, useState } from 'react';
import { Map, List, Set, fromJS } from 'immutable';
import { assertRelationIsNullOrListOfObject, assertRelationIsListOfObject, assertRelationIsObject, assertRelationIsString, assertRelationIsDefined, assertRelationIsNullOrObject, COUPON_USAGE, SELLING_DEVICE_ORIGIN_TYPE, CartItem as CartItem$1, CART_TYPE, TicketPrice, StockContingent, CART_STATUS, Cart, SEAT_TYPE, OfferRule, SellingDevice } from '@mapado/ticketing-js-sdk';
import { useSelector, useDispatch } from 'react-redux';
import { getErrorDescription, usePrevious, formatPrice, useTicketingSdkContext, FieldInput, required, formatDate, BaseModal, getEntityId, FormattedDateForStartAndEndDate, FORMATTED_DATE_FORMAT, CouponApplied, OfferPicker, CouponOfferStatusRow, getShortId } from '@mapado/js-component';
import { useMpdToast, TOAST_TYPE, MpdCard, MpdIcon, MpdInput, MpdCheckbox, MpdEventHeader, MpdDropDown, MpdDropDownContent, MpdOfferHeader } from '@mapado/makeup';
import { createI18nPack } from '@mapado/i18next-pack';
import { jsxs, jsx, Fragment } from 'react/jsx-runtime';
import cn from 'classnames';
import { createPortal } from 'react-dom';
import { Form } from 'react-final-form';
import { buildUrl } from '@mapado/image-url-builder';
import moment from 'moment';
import localforage from 'localforage';
import moment$1 from 'moment-timezone';
import { ofType } from 'redux-observable';
import { EMPTY, concat, of, from as from$1 } from 'rxjs';

var getCartItemWithOfferFacialValue = function getCartItemWithOfferFacialValue(ciwoList) {
  var unit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return ciwoList.reduce(function (carry, ciwo) {
    var facialValue = ciwo.get('facialValue') || 0;
    var quantity = ciwo.get('quantity') || 1;
    return carry + facialValue * (unit ? 1 : quantity);
  }, 0);
};
function getOfferApplicationList(cart) {
  assertRelationIsNullOrListOfObject(cart.cartItemWithOfferList, 'cart.cartItemWithOfferList');
  if (!cart.cartItemWithOfferList) {
    return null;
  }
  var ciwoListGroupedByApplicationId = cart.cartItemWithOfferList.filter(function (ciwo) {
    return ciwo.applicationId;
  }) // keep only cartItemWithOffer that have applicationId
  .groupBy(function (ciwo) {
    return ciwo.get('applicationId');
  });

  // shape ciwoListGroupedByApplicationId as OfferApplication
  var offerApplicationList = ciwoListGroupedByApplicationId.keySeq().map(function (id) {
    var _ciwoList$first;
    var ciwoList = ciwoListGroupedByApplicationId.get(id);
    var offer = ciwoList === null || ciwoList === void 0 || (_ciwoList$first = ciwoList.first()) === null || _ciwoList$first === void 0 ? void 0 : _ciwoList$first.get('offer');

    // @ts-expect-error -- This should be an offer application
    return Map({
      applicationId: id,
      cartItemWithOfferList: ciwoList,
      offer: offer
    });
  });
  return offerApplicationList.toList();
}
function getNoOfferCartItemWithOfferList(cart) {
  assertRelationIsNullOrListOfObject(cart.cartItemWithOfferList, 'cart.cartItemWithOfferList');
  if (!cart.cartItemWithOfferList) {
    return null;
  }
  return cart.cartItemWithOfferList.filter(function (ciwo) {
    return !ciwo.applicationId;
  });
}

/** @deprecated -- we don't want cluster anymore
 * use `getOfferApplicationList` to get equivalent of `offerClusterList.offerApplicationList` but without cluster grouping
 * and `getNoOfferCartItemWithOfferList` get equivalent of `noOfferCartItemWithOfferList`
 * */
function generateOfferClusterMap(cart) {
  // @ts-expect-error -- This is the right object
  var tmpOfferClusterMap = Map();
  if (cart.cartItemWithOfferList) {
    assertRelationIsListOfObject(cart.cartItemWithOfferList, 'cart.cartItemWithOfferList');
    cart.cartItemWithOfferList.forEach(function (ciwo) {
      var clusterId = ciwo.clusterId || 'no-offer';
      if (!tmpOfferClusterMap.get(clusterId)) {
        var tmp = Map({
          offerApplicationMap: Map(),
          offerApplicationList: List(),
          offer: ciwo.offer,
          clusterId: clusterId
        });
        tmpOfferClusterMap = tmpOfferClusterMap.set(clusterId, tmp);
      }
      var offerApplicationMap = tmpOfferClusterMap.getIn([clusterId, 'offerApplicationMap']);
      var applicationId = ciwo.get('applicationId') || 'no-application';
      if (!offerApplicationMap.get(applicationId)) {
        // @ts-expect-error -- This is an offer application
        var offerApplication = Map({
          cartItemWithOfferList: List(),
          applicationId: applicationId,
          offer: ciwo.offer
        });
        offerApplicationMap = offerApplicationMap.set(applicationId, offerApplication);
      }
      var cartItemWithOfferList = offerApplicationMap.getIn([applicationId, 'cartItemWithOfferList']).push(ciwo);
      offerApplicationMap = offerApplicationMap.setIn([applicationId, 'cartItemWithOfferList'], cartItemWithOfferList);
      tmpOfferClusterMap = tmpOfferClusterMap.setIn([clusterId, 'offerApplicationMap'], offerApplicationMap).setIn([clusterId, 'offerApplicationList'], offerApplicationMap.toList());
    });
  }
  var noApplicationMapOfferClusterMap = Map();
  tmpOfferClusterMap.forEach(function (cluster, key) {
    var newCluster = cluster["delete"]('offerApplicationMap');
    newCluster.get('offerApplicationList').forEach(function (application, idx) {
      newCluster = newCluster.setIn(['offerApplicationList', idx, 'cartItemWithOfferList'], application.get('cartItemWithOfferList'));
    });
    noApplicationMapOfferClusterMap = noApplicationMapOfferClusterMap.set(key, newCluster);
  });
  var offerClusterList = noApplicationMapOfferClusterMap.toList().filter(function (offerCluster) {
    return offerCluster.get('clusterId') !== 'no-offer';
  });
  var noOfferCartItemWithOfferList = noApplicationMapOfferClusterMap.toList().filter(function (offerCluster) {
    return offerCluster.get('clusterId') === 'no-offer';
  }).getIn([0, 'offerApplicationList', 0, 'cartItemWithOfferList']) || List();
  var offerClusterMap = Map({
    offerClusterList: offerClusterList,
    noOfferCartItemWithOfferList: noOfferCartItemWithOfferList
  });
  return offerClusterMap;
}

var useCartDispatch = useDispatch;
var useCartSelector = useSelector;

var SHOPPING_CART = 'shoppingCart';

function getCurrentCartState(state) {
  return state.booking[state.booking.currentCartAtomId];
}
function getCurrentCartAtomId(state) {
  return state.booking.currentCartAtomId;
}
function getAtomCartState(state, cartAtomId) {
  return state.booking[cartAtomId];
}
var getCurrentCartUpdating = function getCurrentCartUpdating(state) {
  return getCurrentCartState(state).get('currentCartUpdating');
};
function getCurrentCart(state) {
  var innerState = getCurrentCartState(state);
  return innerState.get('currentCart');
}
function getAtomCart(state, cartAtomId) {
  var innerState = getAtomCartState(state, cartAtomId);
  return (innerState === null || innerState === void 0 ? void 0 : innerState.get('currentCart')) || null;
}

/**
 * current shopping cart
 */
var getShoppingCart = function getShoppingCart(state) {
  return state.booking[SHOPPING_CART].get('currentCart');
};
var useShoppingCart = function useShoppingCart() {
  return useCartSelector(getShoppingCart);
};
var useShoppingCartTicketPriceQuantities = function useShoppingCartTicketPriceQuantities() {
  return useCartSelector(function (state) {
    return state.booking[SHOPPING_CART].get('currentTicketPriceQuantities');
  });
};
var getHasCartIdInStorage = function getHasCartIdInStorage(state) {
  return state.booking[SHOPPING_CART].get('hasCartIdInStorage');
};
var getOriginTypeEnv = function getOriginTypeEnv(state) {
  return state.booking.originTypeEnv;
};
var getCartType = function getCartType(state) {
  return getCurrentCartState(state).get('cartType');
};
var getCartStatus = function getCartStatus(state) {
  return getCurrentCartState(state).get('cartStatus');
};
var getAtomCartType = function getAtomCartType(state, cartAtomId) {
  var _getAtomCartState;
  return (_getAtomCartState = getAtomCartState(state, cartAtomId)) === null || _getAtomCartState === void 0 ? void 0 : _getAtomCartState.get('cartType');
};
var getAtomCartStatus = function getAtomCartStatus(state, cartAtomId) {
  var _getAtomCartState2;
  return (_getAtomCartState2 = getAtomCartState(state, cartAtomId)) === null || _getAtomCartState2 === void 0 ? void 0 : _getAtomCartState2.get('cartStatus');
};
var getSellingDevice = function getSellingDevice(state) {
  return state.booking.sellingDevice;
};
var getCurrentTicketPriceQuantities = function getCurrentTicketPriceQuantities(state) {
  return getCurrentCartState(state).get('currentTicketPriceQuantities');
};
var getAtomTicketPriceQuantities = function getAtomTicketPriceQuantities(state, cartAtomId) {
  var _getAtomCartState$get, _getAtomCartState3;
  return (_getAtomCartState$get = (_getAtomCartState3 = getAtomCartState(state, cartAtomId)) === null || _getAtomCartState3 === void 0 ? void 0 : _getAtomCartState3.get('currentTicketPriceQuantities')) !== null && _getAtomCartState$get !== void 0 ? _getAtomCartState$get : List();
};
var getAtomOfferClusterList = function getAtomOfferClusterList(state, cartAtomId) {
  var _getAtomCartState$get2, _getAtomCartState4;
  return (_getAtomCartState$get2 = (_getAtomCartState4 = getAtomCartState(state, cartAtomId)) === null || _getAtomCartState4 === void 0 ? void 0 : _getAtomCartState4.get('offerClusterList')) !== null && _getAtomCartState$get2 !== void 0 ? _getAtomCartState$get2 : List();
};
var getAtomPendingTicketPriceQuantities = function getAtomPendingTicketPriceQuantities(state, cartAtomId) {
  var _getAtomCartState$get3, _getAtomCartState5;
  return (_getAtomCartState$get3 = (_getAtomCartState5 = getAtomCartState(state, cartAtomId)) === null || _getAtomCartState5 === void 0 ? void 0 : _getAtomCartState5.get('pendingTicketPriceQuantities')) !== null && _getAtomCartState$get3 !== void 0 ? _getAtomCartState$get3 : List();
};
var getCurrentBookingError = function getCurrentBookingError(state) {
  return getCurrentCartState(state).get('bookingError');
};
var getCurrentMapadoError = function getCurrentMapadoError(state) {
  return getCurrentCartState(state).get('mapado:error');
};

/**
 * Get the "current" cart from the store.
 * The current cart is an alias to the cart identified by the currentCartAtomId in the store.
 * Beware that if you get the current cart before triggering the "loadCart" action,
 * you will get the "previous" cart, which can point to the current shipping cart.
 */
function useCurrentCart() {
  return useCartSelector(getCurrentCart);
}

/**
 * Get a specific cart from the store.
 * This hook require more parameter than useCurrentCart, but it allows to get any
 * cart in the store and avoid the confusion of not knowing what is the current cart.
 *
 * @param cartAtomId the cart atom to load. It can be either the shopping cart or a cart IRI.
 * @returns the cart associated with the given cart atom id, or null if not found.
 */
function useAtomCart(cartAtomId) {
  return useCartSelector(function (state) {
    return getAtomCart(state, cartAtomId);
  });
}
function useHasCartIdInStorage() {
  return useCartSelector(getHasCartIdInStorage);
}

/**
 * Check if the current cart is being updated.
 *
 * @returns true if the current cart is being updated (loading, adding/removing items, etc.), false otherwise.
 */
function useCurrentCartUpdating() {
  return useCartSelector(getCurrentCartUpdating);
}

/**
 * @returns true if the current cart has at least one offer, false otherwise.
 */
function useCurrentCartHasOffers() {
  var _offerClusterMap$get;
  var cart = useCurrentCart();
  var offerClusterMap = useMemo(function () {
    return cart ? generateOfferClusterMap(cart) : null;
  }, [cart]);
  if (!offerClusterMap) {
    return false;
  }
  return ((_offerClusterMap$get = offerClusterMap.get('offerClusterList')) === null || _offerClusterMap$get === void 0 ? void 0 : _offerClusterMap$get.size) > 0;
}
function useCurrentCartBookingError() {
  return useCartSelector(getCurrentBookingError);
}
function useCurrentCartMapadoError() {
  return useCartSelector(getCurrentMapadoError);
}

/**
 * Get the current cart atom id from the store.
 *
 * @returns the current cart atom id. It can be either the shopping cart or a cart IRI.
 */
function useCurrentCartAtomId() {
  return useCartSelector(getCurrentCartAtomId);
}
function useTicketPriceQuantityInCart(ticketPrice) {
  var counter = useCartSelector(function (state) {
    var currentTicketPriceQuantities = getCurrentTicketPriceQuantities(state);
    return currentTicketPriceQuantities.filter(function (currentTicketPriceQuantity) {
      return (
        // we do not want the ticket prices with an offer
        !currentTicketPriceQuantity.get('groupKey') &&
        // and we want only the current ticket price
        currentTicketPriceQuantity.get('ticketPrice').get('@id') === ticketPrice['@id']
      );
    })
    // sum the quantities of the ticket prices
    .reduce(function (sum, currentTicketPriceQuantity) {
      return sum + currentTicketPriceQuantity.get('quantity');
    }, 0);
  });
  return counter;
}

/**
 * Get the selling device from the store. The value should be the same on the same application per user.
 * It is not related to the current cart.
 *
 */
var useSellingDevice = function useSellingDevice() {
  return useCartSelector(getSellingDevice);
};
var useCurrentTicketPriceQuantities = function useCurrentTicketPriceQuantities() {
  return useCartSelector(getCurrentTicketPriceQuantities);
};

// declare your configuration
var projectName = 'cart';
var namespaceList = ['messages'];
var defaultNamespace = 'messages';
var languageList = ['fr', 'en', 'de'];
var defaultLanguage = 'fr';

// This function load the local JSON files in case the translation server is down
// We need to keep the full path name and do not use template strings as rollup wont resolve path
function backendLoader(language, namespace) {
  if (namespace !== 'messages') {
    throw new Error('Namespace must be "messages"');
  }
  switch (language) {
    case 'fr':
      return import('./messages-vBhopvdf.js');
    case 'en':
      return import('./messages-C6hmXAzb.js');
    case 'de':
      return import('./messages-OZTMY5eN.js');
    default:
      return Promise.reject(new Error("Do not handle locale ".concat(language)));
  }
}
var _createI18nPack = createI18nPack(projectName, namespaceList, defaultNamespace, languageList, defaultLanguage, backendLoader),
  i18n = _createI18nPack.i18n,
  useTranslation = _createI18nPack.useTranslation;

var CART_BOOKING_ERROR = '@@mapado-booking/CART_BOOKING_ERROR';
var DISMISS_CART_BOOKING_ERROR = '@@mapado-booking/DISMISS_CART_BOOKING_ERROR';
var CART_RECEIVED = '@@mapado-booking/CART_RECEIVED';
var FETCH_CART_UPDATE = '@@mapado-booking/FETCH_CART_UPDATE';
var SET_TICKET_PRICE_QUANTITY = '@@mapado-booking/SET_TICKET_PRICE_QUANTITY';
var RESET_PENDING_TICKET_PRICE_QUANTITIES = '@@mapado-booking/RESET_PENDING_TICKET_PRICE_QUANTITIES';
var SET_CART_ID = '@@mapado-booking/SET_CART_ID';
var DISCARD_CART = '@@mapado-booking/DISCARD_CART';
var UPDATE_COMMENT = '@@mapado-booking/UPDATE_COMMENT';
var UPDATE_CUSTOMERS = '@@mapado-booking/UPDATE_CUSTOMERS';
var UPDATE_OWNER = '@@mapado-booking/UPDATE_OWNER';
var FETCH_CART_STARTED = '@@mapado-booking/FETCH_CART_STARTED';
var FETCH_CART_ENDED = '@@mapado-booking/FETCH_CART_ENDED';
var SET_HAS_CART_ID_IN_STORAGE = '@@mapado-booking/SET_HAS_CART_ID_IN_STORAGE';
var FREE_CART_ID = '@@mapado-booking/FREE_CART_ID';
var SET_CART_AS_SHOPPING_CART = '@@mapado-booking/SET_CART_AS_SHOPPING_CART';

function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: true,
    configurable: true,
    writable: true
  }) : e[r] = t, e;
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = true,
      o = false;
    try {
      if (i = (t = t.call(r)).next, 0 === l) ; else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = true, n = r;
    } finally {
      try {
        if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), true).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = false,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function (t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = true, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), true), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine(u), _regeneratorDefine(u, o, "Generator"), _regeneratorDefine(u, n, function () {
    return this;
  }), _regeneratorDefine(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function () {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine = function (e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine(e, r, n, t);
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r);
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}

var TICKET_PRICE_FIELDS = ['@id', 'hideFees', 'name', 'type', 'isPriceDisplayed', 'description', 'facialValue', 'currency', 'notOnSaleReasons', 'bookableStock', 'hash', 'willGenerateTicket', {
  eventDate: ['@id', 'startDate', 'endDate', 'bookableStock', 'notInStockContingentBookableStock', 'remainingStock', 'unlimitedStock', 'notOnSaleReasons', 'seatConfig', 'isReservableOnline', 'isNumberedSeating', {
    ticketing: ['title', 'timezone', 'slug', 'currency', 'imageList', 'mediaList', 'minisiteParameters', {
      venue: ['seatingName']
    }]
  }]
}, {
  bookingTrack: ['@id', 'cartType']
}];
var STOCK_CONTINGENT_FIELDS = ['@id', 'name', 'color', {
  contingent: ['@id', 'name', 'color']
}];
var CUSTOMER_ALL_FIELDS = ['type', 'crmId', 'firstname', 'lastname', 'address', 'email', 'phone', 'civility', 'zipcode', 'birthday', 'nationality', 'countryOfResidence', 'additionnalInformation', 'client', 'contract', 'gdprInformation', 'city', 'orderList', 'shoppingData', 'diffusionList'];
var CREATE_UPDATE_CART_FIELDS = ['@id', 'comment', 'createdAt', 'originType', 'originId', 'couponCodeList', 'couponValidityMap', 'currency', 'customerPaidAmount', 'customerPaidAmountWithoutOffer', 'facialValue', 'facialFeeValue', 'totalItemNumber', 'totalTicketNumber', 'customerRequiredFields', 'hasMovableSeats', 'schoolMode', {
  sellingDevice: ['isExternalProvider', {
    minisite: ['settings']
  }]
}, 'type', 'status', 'reservationName', 'isOption', 'option', {
  owner: ['externalId', 'provider']
}, {
  providerExportedCartList: ['providerName', 'providerExportUrl']
}, {
  computedBookingTrack: ['bookingOptions', {
    shippingList: ['@id', 'type', {
      fee: ['@id', 'type', 'calculatedAmount', 'vatRate', 'currency']
    }]
  }, {
    billingList: ['@id', 'type', 'recurringPaymentParameters']
  }]
}, {
  contractList: ['@id']
}, {
  couponList: ['code', 'usage', 'nbUseMax', 'offerRuleList', 'nbUseCurrent', 'validUntil', {
    offerRuleList: ['title']
  }, {
    creatingOrderItemList: [{
      ticketPrice: ['name']
    }]
  }, {
    customerStatusList: ['label']
  }]
}, {
  createdCouponList: ['@id', 'code', 'validUntil', 'enabled', 'usage', 'creatingOrder', 'creatingCartItemList', {
    customerStatusList: ['label']
  }, {
    creatingOfferRule: ['@id', 'color', 'timezone']
  }]
}, {
  appliedCouponList: ['@id', 'code', 'enabled', 'usage', 'applyingCartItemList', {
    creatingOfferRule: ['@id', 'title', 'timezone']
  }]
}, {
  organizationalUnitList: ['@id', 'name', 'publicContactEmail', 'gdprOptinMessage']
}, {
  walletList: ['provider', 'providerContractNumber']
}, {
  cartItemList: ['data', 'quantity', 'participantRequiredFields', {
    participant: CUSTOMER_ALL_FIELDS
  }, {
    stockContingent: STOCK_CONTINGENT_FIELDS
  }, {
    ticketPrice: TICKET_PRICE_FIELDS
  }, {
    availableSeatList: ['seatGroup', {
      seat: ['label', 'position', 'type']
    }]
  }]
}, {
  cartItemWithOfferList: ['quantity', 'ticketingTitle', 'ticketingTimezone', 'date', 'endDate', 'name', 'facialValue', 'facialValueWithoutOffer', 'clusterId', 'applicationId', 'groupKey', 'couponCode', 'valid', 'buyable', {
    cartItem: ['@id', 'quantity', 'data', 'participantRequiredFields', 'couponCode', {
      participant: CUSTOMER_ALL_FIELDS
    }, {
      ticketPrice: ['@id', 'willGenerateTicket']
    }, {
      stockContingent: STOCK_CONTINGENT_FIELDS
    }]
  }, {
    availableSeatList: ['manuallyAssigned', 'isLocked', {
      seat: ['type', 'position', 'hasObstructedView', 'label']
    }]
  }, {
    offer: ['id', 'name', 'message', 'exchangeData']
  }, {
    ticketPrice: TICKET_PRICE_FIELDS
  }]
}, {
  customer: CUSTOMER_ALL_FIELDS
}, {
  contact: CUSTOMER_ALL_FIELDS
}, {
  tagList: ['@id', 'name']
}];
var CART_ORDER_STATUS_EXTRA_FIELDS = {
  orderList: ['status']
};

/** @deprecated to move in desk */
var CART_WITH_ALL_FIELDS = [].concat(CREATE_UPDATE_CART_FIELDS, [CART_ORDER_STATUS_EXTRA_FIELDS]);

function checkCodeExistInCodeList(cart, code) {
  var _cart$couponList, _cartCouponCodeList$i;
  var cartCouponCodeList = (_cart$couponList = cart.couponList) === null || _cart$couponList === void 0 ? void 0 : _cart$couponList.map(function (coupon) {
    assertRelationIsObject(coupon, 'coupon');
    assertRelationIsString(coupon.code, 'coupon.code');
    return coupon.code.toUpperCase();
  });
  return (_cartCouponCodeList$i = cartCouponCodeList === null || cartCouponCodeList === void 0 ? void 0 : cartCouponCodeList.includes(code.toUpperCase())) !== null && _cartCouponCodeList$i !== void 0 ? _cartCouponCodeList$i : false;
}
function sanitizeCouponCodeList(cart, code) {
  var _cart$couponCodeList$;
  var sanitizedCode = code.trim().toUpperCase(); // ugly hack to handle backend behavior (always save code as uppercase) https://github.com/mapado/ticketing/commit/d02488ef25bb

  if (!cart.couponCodeList || cart.couponCodeList.size === 0) {
    return List([sanitizedCode]);
  }
  return (_cart$couponCodeList$ = cart.couponCodeList.filter(function (cartCouponCode) {
    return checkCodeExistInCodeList(cart, cartCouponCode);
  })) === null || _cart$couponCodeList$ === void 0 ? void 0 : _cart$couponCodeList$.push(sanitizedCode);
}
var applyCouponToCart = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(ticketingSdk, cart, code, onApplied, onError, t) {
    var newCouponCodeList, updatedCart, _updatedCart$couponVa, couponValidityMap, isValid, errorMessage, sanitizedMessage, errorDescription, _t;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.p = _context.n) {
        case 0:
          newCouponCodeList = sanitizeCouponCodeList(cart, code);
          _context.p = 1;
          _context.n = 2;
          return ticketingSdk.getRepository('cart').update(cart.set('couponCodeList', newCouponCodeList), {
            fields: CREATE_UPDATE_CART_FIELDS
          });
        case 2:
          updatedCart = _context.v;
          onApplied(updatedCart);
          if (checkCodeExistInCodeList(updatedCart, code)) {
            _context.n = 3;
            break;
          }
          couponValidityMap = (_updatedCart$couponVa = updatedCart.couponValidityMap) === null || _updatedCart$couponVa === void 0 ? void 0 : _updatedCart$couponVa.get(code);
          isValid = couponValidityMap === null || couponValidityMap === void 0 ? void 0 : couponValidityMap.get('isValid');
          errorMessage = couponValidityMap === null || couponValidityMap === void 0 ? void 0 : couponValidityMap.get('message');
          sanitizedMessage = isValid || typeof errorMessage === 'string' && errorMessage.length === 0 ? null : errorMessage;
          return _context.a(2, {
            code: sanitizedMessage !== null && sanitizedMessage !== void 0 ? sanitizedMessage : t('cart.coupon_input.field.nonexistent')
          });
        case 3:
          _context.n = 6;
          break;
        case 4:
          _context.p = 4;
          _t = _context.v;
          _context.n = 5;
          return getErrorDescription(_t);
        case 5:
          errorDescription = _context.v;
          onError(errorDescription);
        case 6:
          return _context.a(2);
      }
    }, _callee, null, [[1, 4]]);
  }));
  return function applyCouponToCart(_x, _x2, _x3, _x4, _x5, _x6) {
    return _ref.apply(this, arguments);
  };
}();

function getLocale(locale) {
  if (typeof locale === 'string' && locale) {
    return locale;
  }
  if (!locale) {
    switch (true) {
      case typeof window === 'undefined':
        return 'fr';
      case !!window.navigator.language:
        return window.navigator.language;

      // @ts-expect-error -- fallback for old navigators
      case !!window.navigator.browserLanguage:
        // @ts-expect-error -- fallback for old navigators
        return window.navigator.browserLanguage;

      // @ts-expect-error -- fallback for old navigators
      case !!window.navigator.systemLanguage:
        // @ts-expect-error -- fallback for old navigators
        return window.navigator.systemLanguage;

      // @ts-expect-error -- fallback for old navigators
      case !!window.navigator.userLanguage:
        // @ts-expect-error -- fallback for old navigators
        return window.navigator.userLanguage;
      default:
        return 'fr';
    }
  }
  return 'fr';
}

function CartSummary(_ref) {
  var _currentCart$couponLi, _currentCart$couponLi2;
  var cart = _ref.cart,
    ticketingSdk = _ref.ticketingSdk,
    couponCode = _ref.couponCode;
  var cartFromRedux = useCurrentCart();
  var _useTranslation = useTranslation(),
    t = _useTranslation.t,
    i18n = _useTranslation.i18n;
  var currentCart = cart || cartFromRedux;
  var toast = useMpdToast();
  var dispatch = useDispatch();
  var previousCouponCode = usePrevious(couponCode);
  useEffect(function () {
    if (!currentCart || !couponCode || couponCode === previousCouponCode || checkCodeExistInCodeList(currentCart, couponCode)) {
      return;
    }
    applyCouponToCart(ticketingSdk, currentCart, couponCode, function (updatedCart) {
      dispatch({
        type: CART_RECEIVED,
        cart: updatedCart
      });
    }, function (errorDescription) {
      toast({
        title: errorDescription,
        type: TOAST_TYPE.ERROR
      });
    }, t);
  }, [currentCart, dispatch, t, ticketingSdk, couponCode, previousCouponCode, toast]);
  if (!currentCart) {
    return null;
  }
  assertRelationIsDefined(currentCart.totalTicketNumber, 'currentCart.totalTicketNumber');
  assertRelationIsDefined(currentCart.customerPaidAmount, 'currentCart.customerPaidAmount');
  assertRelationIsDefined(currentCart.customerPaidAmountWithoutOffer, 'currentCart.customerPaidAmountWithoutOffer');
  assertRelationIsDefined(currentCart.currency, 'currentCart.currency');
  var firstCartCouponEntered = (_currentCart$couponLi = (_currentCart$couponLi2 = currentCart.couponList) === null || _currentCart$couponLi2 === void 0 ? void 0 : _currentCart$couponLi2.first()) !== null && _currentCart$couponLi !== void 0 ? _currentCart$couponLi : null;
  assertRelationIsNullOrObject(firstCartCouponEntered, 'firstCartCouponEntered');
  var totalSummary = t('cart.total.prefix');
  if (currentCart.totalTicketNumber || !currentCart.totalItemNumber) {
    totalSummary = "".concat(totalSummary, " ").concat(t('cart.total.ticket_count', {
      count: currentCart.totalTicketNumber
    }));
  }
  if (currentCart.totalItemNumber) {
    if (currentCart.totalTicketNumber) {
      totalSummary = "".concat(totalSummary, " + ").concat(t('cart.total.item_count', {
        count: currentCart.totalItemNumber
      }));
    } else {
      totalSummary = "".concat(totalSummary, " ").concat(t('cart.total.item_count', {
        count: currentCart.totalItemNumber
      }));
    }
  }
  return /*#__PURE__*/jsxs("div", {
    children: [/*#__PURE__*/jsx("b", {
      className: "mpd-color-black",
      children: totalSummary
    }), /*#__PURE__*/jsxs("div", {
      className: "flex-row mt1 mpd-cart__CartSummary__Prices",
      children: [/*#__PURE__*/jsx("div", {
        className: "mt0 mr2 mpd-cart__CartSummary__TotalPrice",
        children: formatPrice(currentCart.customerPaidAmount, currentCart.currency, getLocale(i18n.language))
      }), currentCart.customerPaidAmountWithoutOffer > currentCart.customerPaidAmount && /*#__PURE__*/jsx("div", {
        className: "h3-like m0 mpd-cart__CartSummary__FullPrice",
        children: /*#__PURE__*/jsx("del", {
          children: formatPrice(currentCart.customerPaidAmountWithoutOffer, currentCart.currency, getLocale(i18n.language))
        })
      })]
    }), currentCart.facialFeeValue !== null && currentCart.facialFeeValue > 0 && /*#__PURE__*/jsx("div", {
      className: "help small",
      children: t('cart.total.total_fee', {
        amount: formatPrice(currentCart.facialFeeValue, currentCart.currency, getLocale(i18n.language))
      })
    })]
  });
}

function SidebarSummary(_ref) {
  var cart = _ref.cart,
    children = _ref.children,
    ticketingSdk = _ref.ticketingSdk,
    couponCode = _ref.couponCode;
  var currentCart = useCurrentCart();
  if (!(currentCart || cart) && !children) {
    return null;
  }
  return /*#__PURE__*/jsxs("div", {
    className: "mpd-cart__SidebarSummary__SummaryContainer p3",
    children: [/*#__PURE__*/jsx(CartSummary, {
      cart: cart,
      ticketingSdk: ticketingSdk,
      couponCode: couponCode
    }), children]
  });
}

function getModalRoot() {
  var modalRoot = document.getElementById('modal-root');
  if (!modalRoot) {
    throw new Error('modal-root element not found. Did you create a div with an id "modal-root" in your DOM ?');
  }
  return modalRoot;
}

/**
 * Helper that render a modal in the right DOM event without having to manage the modal-root manually.
 */
function createModalPortal(children, key) {
  return /*#__PURE__*/createPortal(children, getModalRoot(), key);
}

var CartAtomIdContext = /*#__PURE__*/createContext(null);
function CartAtomIdProvider(_ref) {
  var children = _ref.children,
    cartAtomId = _ref.cartAtomId;
  return /*#__PURE__*/jsx(CartAtomIdContext.Provider, {
    value: cartAtomId,
    children: children
  });
}
var useCartAtomIdContext = function useCartAtomIdContext() {
  var contextValue = useContext(CartAtomIdContext);
  if (contextValue === null) {
    throw new Error('SelectedCardItemContext should be defined. Did you add a context provider up in the tree ?');
  }
  return contextValue;
};

function CouponModalInput(_ref) {
  var cart = _ref.cart,
    onApplied = _ref.onApplied,
    onError = _ref.onError;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var ticketingSdk = useTicketingSdkContext();
  var initialValues = {
    code: null
  };
  var onSubmit = function onSubmit(_ref2) {
    var code = _ref2.code;
    if (!code || code.length === 0) {
      return;
    }
    return applyCouponToCart(ticketingSdk, cart, code, onApplied, onError, t);
  };
  return /*#__PURE__*/jsx(Form, {
    onSubmit: onSubmit,
    initialValues: initialValues,
    children: function children(_ref3) {
      var handleSubmit = _ref3.handleSubmit,
        form = _ref3.form,
        submitErrors = _ref3.submitErrors,
        modifiedSinceLastSubmit = _ref3.modifiedSinceLastSubmit;
      return /*#__PURE__*/jsx("form", {
        noValidate: true,
        onSubmit: function onSubmit(event) {
          var _handleSubmit;
          return (_handleSubmit = handleSubmit(event)) === null || _handleSubmit === void 0 ? void 0 : _handleSubmit.then(function (error) {
            return !error && form.restart(initialValues);
          });
        },
        children: /*#__PURE__*/jsx("div", {
          className: cn('mpd-cart__CouponModalInput__Form', {
            'mpd-cart__CouponModalInput__Form__SubmitError': (submitErrors === null || submitErrors === void 0 ? void 0 : submitErrors.code) && !modifiedSinceLastSubmit
          }),
          children: /*#__PURE__*/jsx(FieldInput, {
            className: "w100 mb0",
            name: "code",
            label: t('cart.coupon_input.field.label'),
            validate: required(t('cart.coupon_input.field.required')),
            submitLabel: t('ticketing.ticket.book.coupon_apply'),
            onSubmit: handleSubmit,
            errorMessage: (submitErrors === null || submitErrors === void 0 ? void 0 : submitErrors.code) && !modifiedSinceLastSubmit && (submitErrors === null || submitErrors === void 0 ? void 0 : submitErrors.code)
          })
        })
      });
    }
  });
}

function CouponValidUntilLabel(_ref) {
  var coupon = _ref.coupon;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  if (!coupon.validUntil) {
    return null;
  }
  return /*#__PURE__*/jsx("span", {
    className: "block small mpd-color-gray",
    children: t('cart.createdCoupon.valid_until', {
      date: formatDate(coupon.validUntil)
    })
  });
}

function CouponModalRow(_ref) {
  var cart = _ref.cart,
    coupon = _ref.coupon,
    isValid = _ref.isValid,
    validityMessage = _ref.validityMessage,
    onRemoved = _ref.onRemoved,
    onError = _ref.onError;
  var ticketingSdk = useTicketingSdkContext();
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isRemoving = _useState2[0],
    setIsRemoving = _useState2[1];
  var couponName = getCouponName(coupon);
  var sanitizeCouponCodeList = function sanitizeCouponCodeList(code) {
    var _cart$couponCodeList$, _cart$couponCodeList;
    return (_cart$couponCodeList$ = (_cart$couponCodeList = cart.couponCodeList) === null || _cart$couponCodeList === void 0 ? void 0 : _cart$couponCodeList.filter(function (couponCode) {
      return couponCode !== code;
    })) !== null && _cart$couponCodeList$ !== void 0 ? _cart$couponCodeList$ : null;
  };
  var removeCoupon = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(code) {
      var newCouponCodeList, updatedCart, errorDescription, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            setIsRemoving(true);
            newCouponCodeList = sanitizeCouponCodeList(code);
            _context.p = 1;
            _context.n = 2;
            return ticketingSdk.getRepository('cart').update(cart.set('couponCodeList', newCouponCodeList), {
              fields: CREATE_UPDATE_CART_FIELDS
            });
          case 2:
            updatedCart = _context.v;
            setIsRemoving(false);
            onRemoved(updatedCart);
            _context.n = 5;
            break;
          case 3:
            _context.p = 3;
            _t = _context.v;
            _context.n = 4;
            return getErrorDescription(_t);
          case 4:
            errorDescription = _context.v;
            setIsRemoving(false);
            onError(errorDescription);
          case 5:
            return _context.a(2);
        }
      }, _callee, null, [[1, 3]]);
    }));
    return function removeCoupon(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/jsxs(MpdCard, {
    className: "mpd-cart__CouponModalRow__Main mb2",
    children: [/*#__PURE__*/jsx("div", {
      className: cn('mpd-cart__CouponModalRow__Border', isValid ? 'mpd-cart__CouponModalRow__Border--valid' : 'mpd-cart__CouponModalRow__Border--invalid')
    }), /*#__PURE__*/jsxs("div", {
      className: "flex-column",
      children: [/*#__PURE__*/jsx("b", {
        children: couponName
      }), validityMessage && /*#__PURE__*/jsx("span", {
        className: cn('small', isValid ? 'mpd-color-green' : 'mpd-color-red'),
        children: validityMessage
      }), /*#__PURE__*/jsx("span", {
        className: "large",
        children: coupon.code
      }), /*#__PURE__*/jsx(CouponValidUntilLabel, {
        coupon: coupon
      })]
    }), /*#__PURE__*/jsx("button", {
      type: "button",
      className: "mpd-btn mpd-btn--icon-only",
      disabled: isRemoving,
      onClick: function onClick() {
        return coupon.code && removeCoupon(coupon.code);
      },
      children: /*#__PURE__*/jsx(MpdIcon, {
        icon: "cross"
      })
    })]
  });
}
function getCashCouponTicketPriceName(coupon) {
  var creatingOrderItemList = coupon.creatingOrderItemList;
  if (!creatingOrderItemList) {
    return null;
  }
  var firstOrderItem = creatingOrderItemList.first();
  if (!firstOrderItem) {
    return null;
  }
  assertRelationIsObject(firstOrderItem, 'firstOrderItem');
  var ticketPrice = firstOrderItem.ticketPrice;
  if (!ticketPrice) {
    return null;
  }
  assertRelationIsObject(ticketPrice, 'ticketPrice');
  return ticketPrice.name;
}
function getCouponName(coupon) {
  var _coupon$customerStatu, _coupon$offerRuleList, _coupon$offerRuleList2;
  if (coupon.usage === COUPON_USAGE.CASH) {
    return getCashCouponTicketPriceName(coupon); // Name of the ticket price that generate the cash coupon
  }
  var customerStatuses = (_coupon$customerStatu = coupon.customerStatusList) === null || _coupon$customerStatu === void 0 || (_coupon$customerStatu = _coupon$customerStatu.map(function (_ref3) {
    var label = _ref3.label;
    return label;
  })) === null || _coupon$customerStatu === void 0 ? void 0 : _coupon$customerStatu.join(', ');
  if (customerStatuses && customerStatuses.length > 0) {
    return customerStatuses; // Statuses given by the offer that generate coupon
  }
  return (_coupon$offerRuleList = (_coupon$offerRuleList2 = coupon.offerRuleList) === null || _coupon$offerRuleList2 === void 0 || (_coupon$offerRuleList2 = _coupon$offerRuleList2.first()) === null || _coupon$offerRuleList2 === void 0 ? void 0 : _coupon$offerRuleList2.title) !== null && _coupon$offerRuleList !== void 0 ? _coupon$offerRuleList : null; // Name of the offer that need the coupon
}

function CouponModal(_ref) {
  var title = _ref.title,
    onClose = _ref.onClose;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var dispatch = useDispatch();
  var cartAtomId = useCartAtomIdContext();
  var cart = useAtomCart(cartAtomId);
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    errorMessage = _useState2[0],
    setErrorMessage = _useState2[1];
  if (!cart) {
    return null;
  }
  var couponList = getCouponListWithValidityMapInfos(cart);
  return /*#__PURE__*/jsx(BaseModal, {
    onCancel: onClose,
    maxWidth: "600px",
    title: title,
    actions: /*#__PURE__*/jsx("button", {
      type: "button",
      className: "mpd-btn mpd-btn--primary",
      onClick: onClose,
      children: t('ticketing.modal.coupon.close')
    }),
    children: /*#__PURE__*/jsxs("div", {
      className: "pt2 pb2 pr5 pl5",
      children: [errorMessage && /*#__PURE__*/jsx("div", {
        className: "mpd-alert mpd-alert--error",
        children: errorMessage
      }), /*#__PURE__*/jsx(CouponModalInput, {
        cart: cart,
        onApplied: function onApplied(updatedCart) {
          return dispatch({
            type: CART_RECEIVED,
            cart: updatedCart
          });
        },
        onError: function onError(message) {
          return setErrorMessage(message);
        }
      }), /*#__PURE__*/jsx("div", {
        className: "h3-like mb3",
        children: t('cart.modal.coupon.subtitle')
      }), !couponList || (couponList === null || couponList === void 0 ? void 0 : couponList.size) === 0 ? /*#__PURE__*/jsx("p", {
        className: "mpd-color-gray",
        children: t('cart.modal.coupon.no_code')
      }) : couponList.map(function (_ref2) {
        var coupon = _ref2.coupon,
          validityMessage = _ref2.validityMessage,
          isValid = _ref2.isValid;
        return /*#__PURE__*/jsx(CouponModalRow, {
          cart: cart,
          coupon: coupon,
          isValid: isValid,
          validityMessage: validityMessage,
          onRemoved: function onRemoved(updatedCart) {
            return dispatch({
              type: CART_RECEIVED,
              cart: updatedCart
            });
          },
          onError: function onError(message) {
            return setErrorMessage(message);
          }
        });
      })]
    })
  });
}
function getCouponListWithValidityMapInfos(cart) {
  if (!cart.couponList) {
    return null;
  }
  assertRelationIsListOfObject(cart.couponList, 'cart.couponList');
  return cart.couponList.map(function (coupon) {
    var _cart$couponValidityM;
    assertRelationIsString(coupon.code, 'coupon.code');
    var couponValidityMap = (_cart$couponValidityM = cart.couponValidityMap) === null || _cart$couponValidityM === void 0 ? void 0 : _cart$couponValidityM.get(coupon.code);
    var isValid = couponValidityMap === null || couponValidityMap === void 0 ? void 0 : couponValidityMap.get('isValid');
    var message = couponValidityMap === null || couponValidityMap === void 0 ? void 0 : couponValidityMap.get('message');

    // @ts-expect-error ts issue with couponValidityMap in the ticketing-js-sdk
    var sanitizedIsValid = isValid !== null && isValid !== void 0 ? isValid : false;

    // @ts-expect-error ts issue with couponValidityMap in the ticketing-js-sdk
    var sanitizedMessage = typeof message === 'string' && message.length === 0 ? null : message;
    return {
      coupon: coupon,
      isValid: sanitizedIsValid,
      validityMessage: sanitizedMessage
    };
  });
}

function CouponModalButton(_ref) {
  var label = _ref.label,
    title = _ref.title,
    className = _ref.className,
    _ref$displayIcon = _ref.displayIcon,
    displayIcon = _ref$displayIcon === void 0 ? false : _ref$displayIcon,
    buttonType = _ref.buttonType;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    modalIsVisible = _useState2[0],
    setModalIsVisible = _useState2[1];
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsxs("button", {
      type: "button",
      className: cn("mpd-btn ".concat(className), _defineProperty({}, "mpd-btn--".concat(buttonType), buttonType)),
      onClick: function onClick() {
        return setModalIsVisible(true);
      },
      children: [displayIcon && /*#__PURE__*/jsx(MpdIcon, {
        icon: "percent"
      }), label]
    }), modalIsVisible && createModalPortal(/*#__PURE__*/jsx(CouponModal, {
      title: title !== null && title !== void 0 ? title : label,
      onClose: function onClose() {
        return setModalIsVisible(false);
      }
    }))]
  });
}

function CartItemQuantityInput(_ref) {
  var value = _ref.value,
    max = _ref.max,
    min = _ref.min,
    onChange = _ref.onChange,
    onClick = _ref.onClick,
    onFocus = _ref.onFocus,
    onBlur = _ref.onBlur,
    label = _ref.label;
  return /*#__PURE__*/jsx(MpdInput, {
    className: "CartItemQuantityInput",
    value: value,
    onChange: onChange,
    onClick: onClick,
    onFocus: onFocus,
    onBlur: onBlur,
    type: "number",
    min: min,
    max: max,
    "aria-label": label
  });
}

// Auto-generated file. Edit "src/breakpoints.js" to change values
var $primaryBlue = '#00859c';

var offerType = 'offer';
var eventDateType = 'eventDate';
var CartViewContext = /*#__PURE__*/createContext(null);
function CartViewProvider(_ref) {
  var children = _ref.children;
  var cartHasOffers = useCurrentCartHasOffers();
  var _useState = useState(cartHasOffers ? offerType : eventDateType),
    _useState2 = _slicedToArray(_useState, 2),
    type = _useState2[0],
    setType = _useState2[1];
  useEffect(function () {
    setType(cartHasOffers ? offerType : eventDateType);
  }, [cartHasOffers]);
  var values = useMemo(function () {
    return {
      type: type,
      setType: setType
    };
  }, [type]);
  return /*#__PURE__*/jsx(CartViewContext.Provider, {
    value: values,
    children: children
  });
}
var useCartViewContext = function useCartViewContext() {
  var cartViewContext = useContext(CartViewContext);
  if (!cartViewContext) {
    throw new Error('CartViewContext should be defined. Did you add a context provider up in the tree ?');
  }
  return cartViewContext;
};

var getCartItemId = function getCartItemId(ciwo) {
  return ciwo.getIn(['cartItem', '@id']);
};
var getItemCount = function getItemCount(cartItemWithOfferList) {
  return cartItemWithOfferList.reduce(function (acc, cartItemWithOffer) {
    if (cartItemWithOffer.ticketPrice) {
      assertRelationIsObject(cartItemWithOffer.ticketPrice, 'cartItemWithOffer.ticketPrice');
      if (!cartItemWithOffer.ticketPrice.willGenerateTicket) {
        var _cartItemWithOffer$ge;
        return acc + ((_cartItemWithOffer$ge = cartItemWithOffer.get('quantity')) !== null && _cartItemWithOffer$ge !== void 0 ? _cartItemWithOffer$ge : 0);
      }
    }
    return acc;
  }, 0);
};
var getTicketCount = function getTicketCount(cartItemWithOfferList) {
  return cartItemWithOfferList.reduce(function (acc, cartItemWithOffer) {
    if (cartItemWithOffer.ticketPrice) {
      assertRelationIsObject(cartItemWithOffer.ticketPrice, 'cartItemWithOffer.ticketPrice');
      if (cartItemWithOffer.ticketPrice.willGenerateTicket) {
        var _cartItemWithOffer$ge2;
        return acc + ((_cartItemWithOffer$ge2 = cartItemWithOffer.get('quantity')) !== null && _cartItemWithOffer$ge2 !== void 0 ? _cartItemWithOffer$ge2 : 0);
      }
    }
    return acc;
  }, 0);
};

// @ts-expect-error -- need participant type
var participantFirstname = function participantFirstname(participant) {
  return typeof participant.get === 'function' ? participant.get('firstname') : participant.firstname;
};

// @ts-expect-error -- need participant type
var participantLastname = function participantLastname(participant) {
  return typeof participant.get === 'function' ? participant.get('lastname') : participant.lastame;
};
var getParticipantFromCIWO = function getParticipantFromCIWO(cartItemWithOffer) {
  var cartItem = cartItemWithOffer.get('cartItem');
  if (!cartItem) {
    return null;
  }
  var participantData = cartItem.get('participant');
  if (!participantData) {
    return null;
  }
  return [participantFirstname(participantData), participantLastname(participantData)].filter(function (a) {
    return a;
  }) // skip empty names
  .join(' ');
};
var getCIWOUSeatingInfo = function getCIWOUSeatingInfo(cartItemWithOffer, key) {
  var seatInfo = cartItemWithOffer.getIn(['availableSeatList', key, 'seat']);
  if (!seatInfo) {
    return null;
  }
  var seatLabel = seatInfo.get('label');
  return {
    seatLabel: typeof seatLabel === 'string' ? seatLabel : null
  };
};

// TODO move to desk
var getCIWOUSeat = function getCIWOUSeat(cartItemWithOffer, key) {
  return cartItemWithOffer.getIn(['availableSeatList', key, 'seat']);
};
var getCIWOUIsManuallyAssigned = function getCIWOUIsManuallyAssigned(cartItemWithOffer, key) {
  return cartItemWithOffer.getIn(['availableSeatList', key, 'manuallyAssigned']);
};
var getCartItemWithOfferGroupedByEventDate = function getCartItemWithOfferGroupedByEventDate(ciwoList) {
  return ciwoList === null || ciwoList === void 0 ? void 0 : ciwoList.groupBy(function (ciwo) {
    var eventDate = ciwo.getIn(['ticketPrice', 'eventDate']);
    return getEntityId(eventDate);
  }).map(function (list) {
    return Map({
      eventDate: list.getIn([0, 'ticketPrice', 'eventDate']),
      cartItemWithOfferList: list
    });
  });
};
var SELLING_DEVICE_DESK = 'desk';
var SELLING_DEVICE_MINISITE = 'minisite';
var MAX_QUANTITY = 299;
function shouldHideSeatingReplacement(isMinisite, cart,
// eslint-disable-next-line @typescript-eslint/no-unused-vars
ticketing) {
  if (!isMinisite) {
    return false;
  }
  var sellingDevice = cart === null || cart === void 0 ? void 0 : cart.sellingDevice;
  assertRelationIsObject(sellingDevice, 'sellingDevice');
  var minisite = sellingDevice.minisite;
  assertRelationIsObject(minisite, 'minisite');
  return minisite.hasSeatingReplacementHidden() || ticketing.hasSeatingReplacementHidden();
}

/**
 * Used to filter invalid CartItemWithOffer if not on desk.
 * Usage:
 * ```
 * const filtered = cart.cartItemWithOfferList
 *   .filter(filterInvalidCartItemExceptOnDesk(originType));
 * ```
 */
var filterInvalidCartItemExceptOnDesk = function filterInvalidCartItemExceptOnDesk(originTypeEnv) {
  return function (cartItemWithOffer) {
    if (originTypeEnv === SELLING_DEVICE_ORIGIN_TYPE.DESK) {
      return true;
    }
    return cartItemWithOffer.valid === true;
  };
};

/**
 * Convert TicketPriceQuantities to a list of CartItem.
 * This is the list that will be sent to the API, so we need to have a valid list of CartItem in the output.
 */
function convertToCartItemList(currentTicketPriceQuantities) {
  return currentTicketPriceQuantities.map(function (item) {
    var ticketPrice = item.get('ticketPrice');
    var ticketPriceId = ticketPrice['@id'];
    assertRelationIsString(ticketPriceId, 'ticketPrice.@id');
    var availableSeat = item.get('availableSeat');
    return new CartItem$1({
      '@id': null,
      '@type': 'CartItem',
      ticketPrice: ticketPrice,
      quantity: item.get('quantity'),
      groupKey: item.get('groupKey'),
      couponCode: item.get('couponCode'),
      data: item.get('data'),
      participant: item.get('participant'),
      stockContingent: getEntityId(item.get('stockContingent')),
      facialValue: ticketPrice.facialValue,
      availableSeatList: availableSeat ? List([availableSeat]) : null
    });
  })

  // explode CartItemWithQuantity to a list of CartItem with a quantity of only one
  // TODO use .flatMap https://immutable-js.com/docs/v4.1.0/List/#flatMap() instead of `.map().reduce()`
  .map(function (cartItem) {
    return Array(cartItem.quantity).fill(cartItem.set('quantity', 1));
  })

  // then merge all arrays
  .reduce(function (carry, cartItemList) {
    return carry.concat(List(cartItemList));
  }, List());
}

var NO_STOCK_CONTINGENT = 'NO_STOCK_CONTINGENT';
function assertAllKeysPresent() {
  return function () {
    for (var _len = arguments.length, keys = new Array(_len), _key = 0; _key < _len; _key++) {
      keys[_key] = arguments[_key];
    }
    return keys;
  };
}
var TICKET_PRICE_QUANTITY_INPUT_KEYS = assertAllKeysPresent()('ticketPrice', 'groupKey', 'couponCode', 'stockContingent', 'data', 'participant', 'quantity', 'quantityDelta', 'availableSeat');
var GROUP_MODE_FULL = 'full';
var GROUP_MODE_MINIMAL_WITH_GROUP_KEY = 'minimal-with-group-key';
var GROUP_MODE_MINIMAL = 'minimal';
function hasQuantity(item) {
  var quantity = item.get('quantity');
  return quantity !== null && typeof quantity !== 'undefined';
}
var getNumber = function getNumber(v) {
  return typeof v === 'string' ? parseInt(v, 10) : v;
};
function getQuantity(item) {
  var quantity = item.get('quantity');
  if (quantity === null || typeof quantity === 'undefined') {
    throw new Error('getQuantity must be called with a TicketPriceQuantity that have a quantity. Did you called `hasQuantity` before ?');
  }
  return getNumber(quantity);
}
function getQuantityDelta(item) {
  var quantityDelta = item.get('quantityDelta');
  if (!quantityDelta) {
    throw new Error('getQuantityDelta must be called with a TicketPriceQuantity that have a quantityDelta. Did you called `hasQuantity` before ?');
  }
  return getNumber(quantityDelta);
}
var getFromTicketPriceQuantityOrAccumulator = function getFromTicketPriceQuantityOrAccumulator(key, item, acc) {
  var _acc$get;
  if (item.has(key)) {
    var _item$get;
    return (_item$get = item.get(key)) !== null && _item$get !== void 0 ? _item$get : null;
  }
  return (_acc$get = acc === null || acc === void 0 ? void 0 : acc.get(key)) !== null && _acc$get !== void 0 ? _acc$get : null;
};

/**
 * Method called to reduce a list of TicketPriceQuantity. It does merge similiar items and set the reduced quantity.
 */
function reduceTicketPriceQuantities(acc, item) {
  var accQuantity = acc && acc.get('quantity') !== null && typeof acc.get('quantity') !== 'undefined' ? acc.get('quantity') : 0;
  var quantity = item.get('quantity');
  var quantityDelta = item.get('quantityDelta');
  if (typeof quantity === 'undefined' && typeof quantityDelta === 'undefined') {
    throw new Error('quantity or quantityDelta is required');
  }
  var newQuantity = hasQuantity(item) ? getQuantity(item) : getQuantityDelta(item) + accQuantity;
  var availableSeat = item.get('availableSeat') || null;
  if (availableSeat) {
    // If we set a availableSeat, we want to erase all other values as it is a unique key generated by ther `group` function

    // @ts-expect-error -- issue with type variance in immutable type as availableSeat is string instead of string | null
    return Map({
      ticketPrice: getFromTicketPriceQuantityOrAccumulator('ticketPrice', item, acc),
      quantity: Math.min(newQuantity, 1),
      couponCode: getFromTicketPriceQuantityOrAccumulator('couponCode', item, acc),
      groupKey: getFromTicketPriceQuantityOrAccumulator('groupKey', item, acc),
      data: getFromTicketPriceQuantityOrAccumulator('data', item, acc),
      participant: getFromTicketPriceQuantityOrAccumulator('participant', item, acc),
      stockContingent: getFromTicketPriceQuantityOrAccumulator('stockContingent', item, acc),
      availableSeat: availableSeat
    });
  }
  if (!acc) {
    var _item$get2;
    // Accumulator is not set already : that is the first time that we encouter this key.
    // Let's create a full TicketPriceQuantity

    var tmpItemData = (_item$get2 = item.get('data')) !== null && _item$get2 !== void 0 ? _item$get2 : null;
    // @ts-expect-error issue in immutable type with Map.isMap. (weird as we have the exact same call elsewhere in this file !)
    var itemData = tmpItemData && !Map.isMap(tmpItemData) ? Map(tmpItemData) : tmpItemData;
    return Map({
      ticketPrice: item.get('ticketPrice'),
      quantity: newQuantity,
      groupKey: item.get('groupKey') || null,
      couponCode: item.get('couponCode') || null,
      data: itemData,
      participant: getEntityId(item.get('participant')),
      stockContingent: item.get('stockContingent') || null,
      availableSeat: item.get('availableSeat') || null
    });
  }

  // Accumulator is set already : just update the quantity.
  return acc.set('quantity', newQuantity);
}

/**
 * Generate a key for a TicketPriceQuantity that will be used to fetch existing items in the ticketPriceQuantity list.
 */
function getItemKey(item) {
  var mode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : GROUP_MODE_FULL;
  if (mode === GROUP_MODE_MINIMAL) {
    return item.getIn(['ticketPrice', '@id']);
  }
  if (mode === GROUP_MODE_MINIMAL_WITH_GROUP_KEY) {
    return [getEntityId(item.get('ticketPrice', null)), item.get('groupKey', null)].join('|');
  }
  var parts = [getEntityId(item.get('ticketPrice', null)), item.get('couponCode', null), item.get('groupKey', null), getEntityId(item.get('participant', null)), getEntityId(item.get('stockContingent', null)), getEntityId(item.get('availableSeat', null))];
  return parts.join('|');
}
var groupItemByKey = function groupItemByKey(item) {
  return getItemKey(item);
};
var highestQuantityFirst = function highestQuantityFirst(a, b) {
  var aQuantity = a.get('quantity');
  var bQuantity = b.get('quantity');
  if (aQuantity > bQuantity) {
    return -1;
  }
  if (aQuantity < bQuantity) {
    return 1;
  }
  return 0;
};
function highestPriorityLast(a, b) {
  if (a.get('couponCode') && !b.get('couponCode')) {
    return 1;
  }
  if (!a.get('couponCode') && b.get('couponCode')) {
    return -1;
  }
  if (a.get('groupKey') && !b.get('groupKey')) {
    return 1;
  }
  if (!a.get('groupKey') && b.get('groupKey')) {
    return -1;
  }
  if (a.get('participant') && !b.get('participant')) {
    return 1;
  }
  if (!a.get('participant') && b.get('participant')) {
    return -1;
  }
  if (a.get('availableSeat') && !b.get('availableSeat')) {
    return 1;
  }
  if (!a.get('availableSeat') && b.get('availableSeat')) {
    return -1;
  }
  if (a.get('stockContingent') && !b.get('stockContingent')) {
    return 1;
  }
  if (!a.get('stockContingent') && b.get('stockContingent')) {
    return -1;
  }
  return 0;
}
function findBestMatchForTicketPriceQuantity(item, ticketPriceQuantityList) {
  var accByHighestPriorityLast = ticketPriceQuantityList.sort(highestPriorityLast);

  // if item has a groupKey, we use an intermediate group mode to handle the case where the
  // ticketPrice quantity is present in multiple groups, in order to remove it from its own group
  // instead of the first group it is found in.
  var groupModeList = item.get('groupKey', null) ? [GROUP_MODE_FULL, GROUP_MODE_MINIMAL_WITH_GROUP_KEY, GROUP_MODE_MINIMAL] : [GROUP_MODE_FULL, GROUP_MODE_MINIMAL];

  // try to find the item using different group modes
  // the group mode is less strict after each iteration
  // this is to ensure that we can find an item with a positive quantity
  // eslint-disable-next-line @typescript-eslint/prefer-for-of
  var _loop = function _loop() {
      var groupMode = groupModeList[i];
      var found = accByHighestPriorityLast.find(function (entry) {
        return getItemKey(entry, groupMode) === getItemKey(item, groupMode) && entry.get('quantity') > 0;
      });
      if (found) {
        // if we found an item, we can stop searching
        return {
          v: found
        };
      }
    },
    _ret;
  for (var i = 0; i < groupModeList.length; i++) {
    _ret = _loop();
    if (_ret) return _ret.v;
  }
  return null;
}

/**
 * Does handle ticket price quantity
 * If two TicketPriceQuantities have the same keys, they will be grouped together.
 * ```
 * [
 *   { ticketPrice: '/v1/ticket_prices/1', quantity: 2 },
 *   { ticketPrice: '/v1/ticket_prices/1', quantityDelta: -1 },
 *   { ticketPrice: '/v1/ticket_prices/1', groupKey: 'ABC', quantityDelta: 2 },
 * ]
 * ```
 * The first two objects will be grouped together, the third will have its own key.
 * This allow the reducer to have the following output:
 * ```
 * [
 *   { ticketPrice: '/v1/ticket_prices/1', quantity: 1 },
 *   { ticketPrice: '/v1/ticket_prices/1', groupKey: 'ABC', quantity: 2 },
 * ]
 * ```
 *
 */
function processTicketPriceQuantities(ticketPriceQuantities) {
  var groupedTicketPriceQuantities = ticketPriceQuantities.groupBy(groupItemByKey);

  // for each key, reduce the list to have only one TicketPriceQuantityInput
  var reducedTicketPriceQuantities = groupedTicketPriceQuantities.map(function (itemList) {
    var out = itemList.reduce(reduceTicketPriceQuantities, null);
    if (out === null) {
      throw new Error('reduced TicketPriceQuantityList should not output a `null` value.');
    }
    return out;
  });

  // when we decrement the quantity by more than 1, we might not find an item
  // with a matching positive quantity, so we need to decrement the quantity 1 by 1, each time finding an item
  // with enough positive quantity to decrement.
  // In order to do so, ticketPriceQuantity entries with negative quantities
  // are flattened into multiple entries with a quantity of -1.
  // (NB: at this stage, we do not have to deal with quantityDeltas anymore, as they have previously been reduced to a single quantity)
  var withFlattenedNegativeQuantities = reducedTicketPriceQuantities.reduce(function (acc, item, key) {
    var quantity = item.get('quantity');
    if (quantity >= 0) {
      return acc.set(key, item);
    }
    var absQuantity = Math.abs(quantity);
    var newAcc = acc;
    for (var i = 0; i < absQuantity; i++) {
      var newKey = i === 0 ? key : "".concat(key, "_").concat(i);
      newAcc = newAcc.set(newKey, item.set('quantity', -1));
    }
    return newAcc;
  }, Map());

  // sort by highest quantity first, so that we will create an accumulator of all the positive quantities
  // before trying to decrement them with negative quantities.
  var sortedTicketPriceQuantities = withFlattenedNegativeQuantities.sort(highestQuantityFirst);
  return sortedTicketPriceQuantities.reduce(function (acc, item, key) {
    var quantity = item.get('quantity');
    if (quantity >= 0) {
      // if quantity is positive, just use it as is
      return acc.set(key, item);
    }
    var foundItem = findBestMatchForTicketPriceQuantity(item, acc.toList());
    if (!foundItem) {
      // if no item was found, set the quantity for this item to 0
      // making sure not to send negative quantities to the API
      var updatedItem = item.set('quantity', 0);
      return acc.set(key, updatedItem);
    }
    var foundKey = getItemKey(foundItem);
    var foundItemQuantity = foundItem.get('quantity');
    var newQuantity = quantity + foundItemQuantity;
    return acc.set(foundKey, foundItem.set('quantity', newQuantity));
  }, Map()).filter(function (item) {
    return item.get('quantity') > 0;
  }).toList();
}
function explodeMultipleAvailableSeat(cartItemWithOffer) {
  var availableSeatList = cartItemWithOffer.availableSeatList;
  if (!availableSeatList || availableSeatList.size <= 0) {
    return [cartItemWithOffer.set('availableSeatList', List())];
  }
  assertRelationIsListOfObject(availableSeatList, 'cartItemWithOffer.availableSeatList');
  var outManuallyAssigned = List();
  var outAutoAssigned = cartItemWithOffer.set('quantity', 0).set('availableSeatList', List());
  availableSeatList.forEach(function (availableSeat) {
    if (availableSeat.manuallyAssigned) {
      outManuallyAssigned = outManuallyAssigned.push(cartItemWithOffer.set('quantity', 1).set('availableSeatList', List([availableSeat])));
    } else {
      outAutoAssigned = outAutoAssigned.set('quantity', outAutoAssigned.quantity + 1);
    }
  });
  if (outAutoAssigned.quantity > 0) {
    return outManuallyAssigned.unshift(outAutoAssigned).toArray();
  }
  return outManuallyAssigned.toArray();
}
function convertCartItemWithOfferToTicketPriceQuantity(cartItemWithOffer) {
  var _cartItemWithOffer$ge, _cartItemWithOffer$ge2, _getEntityId;
  var ticketPrice = cartItemWithOffer.get('ticketPrice');
  assertRelationIsObject(ticketPrice, 'cartItemWithOffer.ticketPrice');
  var quantityDelta = cartItemWithOffer.get('quantity');
  assertRelationIsDefined(quantityDelta, 'cartItemWithOffer.quantity');
  var couponCode = (_cartItemWithOffer$ge = cartItemWithOffer.get('couponCode')) !== null && _cartItemWithOffer$ge !== void 0 ? _cartItemWithOffer$ge : undefined;
  var groupKey = (_cartItemWithOffer$ge2 = cartItemWithOffer.get('groupKey')) !== null && _cartItemWithOffer$ge2 !== void 0 ? _cartItemWithOffer$ge2 : undefined;
  var cartItem = cartItemWithOffer.get('cartItem');
  assertRelationIsObject(cartItem, 'cartItemWithOffer.cartItem');
  var stockContingent = cartItem.get('stockContingent');
  assertRelationIsNullOrObject(stockContingent, 'cartItemWithOffer.cartItem.stockContingent');
  var availableSeatList = cartItemWithOffer.get('availableSeatList') || List();
  assertRelationIsListOfObject(availableSeatList, 'cart.availableSeatList');
  var availableSeat = availableSeatList.first();
  var dataInput = cartItem.get('data');
  var data = dataInput && !Map.isMap(dataInput) ? Map(dataInput) :
  // Issue with `isMap` returning Map<unknown, unknown>
  dataInput;
  return Map({
    ticketPrice: ticketPrice,
    quantityDelta: quantityDelta,
    groupKey: groupKey,
    couponCode: couponCode,
    stockContingent: stockContingent,
    data: data,
    participant: (_getEntityId = getEntityId(cartItem.get('participant'))) !== null && _getEntityId !== void 0 ? _getEntityId : null,
    availableSeat: availableSeat !== null && availableSeat !== void 0 && availableSeat.manuallyAssigned ? getEntityId(availableSeat) : null
  });
}

/**
 * Will take a cart and convert it to a processable list of TicketPriceQuantity. It is used when we have a cart and refresh the page or when a cart is updated, we update the ticketPriceQuantities from the updated cart.
 * CartItems are directly mapped to TicketPriceQuantity.
 *
 * @param {string} originTypeEnv if originTypeEnv is 'desk', ther we won't filter invalid cart items as invalid carts can still be processed by the pro.
 */
function convertCartToTicketPriceQuantity(cart, originTypeEnv) {
  assertRelationIsListOfObject(cart.cartItemWithOfferList, 'cart.cartItemWithOfferList');
  var flattenedTicketPriceQuantities = cart.cartItemWithOfferList.filter(filterInvalidCartItemExceptOnDesk(originTypeEnv))

  // if we have an availableSeatList, let's explode this list to have only one quantity and one availableSeat
  .flatMap(explodeMultipleAvailableSeat).map(function (cartItemWithOffer) {
    return convertCartItemWithOfferToTicketPriceQuantity(cartItemWithOffer);
  });
  return processTicketPriceQuantities(flattenedTicketPriceQuantities);
}
function getCartItemQuantityForAvailableSeat(availableSeat, cart, quantityDelta) {
  var lockSeat = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  assertRelationIsListOfObject(cart.cartItemWithOfferList, 'cart.cartItemWithOfferList');
  var cartItemWithOfferToRemove = cart.cartItemWithOfferList.find(function (cartItemWithOffer) {
    assertRelationIsObject(cartItemWithOffer, 'cartItemWithOffer');
    assertRelationIsListOfObject(cartItemWithOffer.availableSeatList, 'cartItemWithOffer.availableSeatList');
    return cartItemWithOffer.availableSeatList.some(function (cartItemWithOfferAvailableSeat) {
      return getEntityId(cartItemWithOfferAvailableSeat) === getEntityId(availableSeat);
    });
  });
  assertRelationIsObject(cartItemWithOfferToRemove, 'cartItemWithOfferToRemove');
  assertRelationIsListOfObject(cartItemWithOfferToRemove.availableSeatList, 'cartItemWithOfferToRemove.availableSeatList');
  var cartItemWithOfferAvailableSeat = cartItemWithOfferToRemove.availableSeatList.first();
  assertRelationIsObject(cartItemWithOfferAvailableSeat, 'cartItemWithOfferAvailableSeat.availableSeatList.first()');
  assertRelationIsListOfObject(cart.cartItemList, 'cart.cartItemList');
  var cartItem = cartItemWithOfferToRemove.cartItem;
  assertRelationIsObject(cartItem, 'cartItem');
  var ticketPrice = cartItem.ticketPrice,
    participant = cartItem.participant,
    cartItemStockContingent = cartItem.stockContingent,
    data = cartItem.data;
  assertRelationIsObject(ticketPrice, 'cartItem.ticketPrice');
  assertRelationIsNullOrObject(cartItemStockContingent, 'cartItem.stockContingent');
  assertRelationIsNullOrObject(participant, 'cartItem.participant');
  return {
    ticketPrice: ticketPrice,
    availableSeat: lockSeat ? getEntityId(cartItemWithOfferAvailableSeat) : null,
    quantityDelta: quantityDelta,
    groupKey: cartItemWithOfferToRemove.groupKey,
    stockContingent: cartItemStockContingent,
    participant: getEntityId(participant),
    data: data,
    couponCode: cartItemWithOfferToRemove.couponCode
  };
}
function mergeTicketPriceQuantityUpdate(original, updates) {
  var result = original;
  TICKET_PRICE_QUANTITY_INPUT_KEYS.forEach(function (key) {
    var value = updates[key];
    if (value !== undefined) {
      result = result.set(key, value);
    }
  });
  return result;
}

function setTicketPriceQuantity$1(cartAtomId, ticketPriceList, cartType, cartStatus) {
  return {
    type: SET_TICKET_PRICE_QUANTITY,
    ticketPriceList: ticketPriceList,
    cartType: cartType,
    cartStatus: cartStatus,
    cartAtomId: cartAtomId
  };
}
function removeCartItemFromCurrentCart(cartAtomId, cartItemWithOfferList) {
  return setTicketPriceQuantity$1(cartAtomId, cartItemWithOfferList.map(function (ciwo) {
    assertRelationIsObject(ciwo.ticketPrice, 'ciwo.ticketPrice');
    return {
      ticketPrice: ciwo.ticketPrice,
      quantity: 0
    };
  }).toArray());
}
var isHttpError = function isHttpError(e) {
  return 'baseResponse' in e;
};
function cartError(cartAtomId, error) {
  // @ts-expect-error: too intricated with other functions, works at runtime
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(dispatch) {
      var resBody, message, mapadoError, body;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            resBody = null;
            message = null;
            mapadoError = null;
            if (!(isHttpError(error) && error.baseResponse)) {
              _context.n = 4;
              break;
            }
            if (error.baseResponse.bodyUsed) {
              _context.n = 2;
              break;
            }
            _context.n = 1;
            return error.baseResponse.json();
          case 1:
            resBody = _context.v;
            _context.n = 3;
            break;
          case 2:
            body = error.baseResponse.body; // @ts-expect-error body is a string (is it ?)
            resBody = body;
          case 3:
            if (resBody) {
              message = resBody['hydra:description'];
              mapadoError = resBody['mapado:error'];
            }
            _context.n = 5;
            break;
          case 4:
            message = error.name;
          case 5:
            return _context.a(2, dispatch({
              type: CART_BOOKING_ERROR,
              cartAtomId: cartAtomId,
              error: message,
              'mapado:error': mapadoError,
              reset: true
            }));
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
}
function receiveCart(newCart, cartAtomId) {
  return {
    type: CART_RECEIVED,
    cart: newCart,
    cartAtomId: cartAtomId
  };
}
function resetCouponCodeListForCart(cart, cartAtomId) {
  return function (dispatch, getState, extraArguments) {
    var func = cart.get('@id') ? 'update' : 'create';

    // @ts-expect-error window.ticketingSdk should be set
    return window.ticketingSdk.cart[func](cart.set('couponCodeList', null), {
      fields: CREATE_UPDATE_CART_FIELDS
    }).then(function (newCart) {
      return dispatch(receiveCart(newCart, cartAtomId));
    })["catch"](function (err2) {
      return cartError(cartAtomId, err2)(dispatch, getState, extraArguments);
    });
  };
}

/**
 * @param {TicketingSdk} ticketingSdk Should be defined. Fallback to `window.ticketingSdk` but this is now deprecated.
 */
function createOrUpdateCart(cart, cartAtomId, ticketingSdk) {
  if (!ticketingSdk) {
    // eslint-disable-next-line no-console
    console.warn('ticketingSdk should be injected into `createOrUpdateCart`');
  }
  var innerTicketingSdk = ticketingSdk || window.ticketingSdk;
  assertRelationIsDefined(innerTicketingSdk, 'ticketingSdk in createOrUpdateCart');
  var couponedCart = cart;
  var couponCodeList = cart.couponCodeList && cart.couponCodeList.size > 0 ? cart.couponCodeList : null;
  if (couponCodeList && couponCodeList.size > 0) {
    couponedCart = couponedCart.set('couponCodeList', couponCodeList);
  }
  var func = couponedCart.get('@id') ? 'update' : 'create';

  // @ts-expect-error: too intricated with other functions, works at runtime
  return innerTicketingSdk.getRepository('cart')[func](couponedCart, {
    fields: CREATE_UPDATE_CART_FIELDS
  }).then(function (newCart) {
    return receiveCart(newCart, cartAtomId);
  })["catch"](function (error) {
    if (couponedCart.get('couponCodeList')) {
      return resetCouponCodeListForCart(couponedCart, cartAtomId);
    }
    return cartError(cartAtomId, error);
  });
}
function splitCart(_x2, _x3, _x4, _x5, _x6, _x7, _x8) {
  return _splitCart.apply(this, arguments);
}
function _splitCart() {
  _splitCart = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(parentCart, newCartItemList, sellingDeviceId, ticketingSdk, selectedCustomerId, selectedContactId, selectedOwnerId) {
    var currency, customer, cartItemList, newCart, createdCart;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          currency = parentCart.get('currency');
          customer = parentCart.get('customer');
          cartItemList = newCartItemList.map(function (cartItem) {
            return cartItem.get('@id');
          });
          assertRelationIsNullOrObject(customer, 'parentCart.customer');
          newCart = new Cart({
            currency: currency,
            type: CART_TYPE.RESERVATION,
            status: parentCart.type === CART_TYPE.CART ? CART_STATUS.VALIDATED // same behavior then "put aside". A cart become a "validated" reservation
            : parentCart.status,
            // if cart already was a reservation we keep it status
            customer: selectedCustomerId,
            contact: selectedContactId,
            // @ts-expect-error toJS is too lazy
            cartItemList: cartItemList.toJS(),
            couponCodeList: parentCart.couponCodeList,
            reservationName: parentCart.reservationName,
            comment: parentCart.comment,
            tagList: parentCart.tagList,
            sellingDevice: sellingDeviceId,
            parent: parentCart.get('@id'),
            owner: selectedOwnerId
          });
          _context2.n = 1;
          return ticketingSdk.getRepository('cart').create(newCart, {
            fields: '@id'
          });
        case 1:
          createdCart = _context2.v;
          return _context2.a(2, createdCart);
      }
    }, _callee2);
  }));
  return _splitCart.apply(this, arguments);
}
function processPendingTicketPriceQuantities(cartAtomId) {
  return function (dispatch, getState) {
    var _getAtomPendingTicket;
    var state = getState();
    var pendingTicketPriceQuantities = (_getAtomPendingTicket = getAtomPendingTicketPriceQuantities(state, cartAtomId)) !== null && _getAtomPendingTicket !== void 0 ? _getAtomPendingTicket : List();
    if (pendingTicketPriceQuantities.size === 0) {
      return null;
    }
    dispatch({
      type: RESET_PENDING_TICKET_PRICE_QUANTITIES,
      cartAtomId: cartAtomId
    });
    return dispatch(setTicketPriceQuantity$1(cartAtomId, pendingTicketPriceQuantities));
  };
}
function discardCart(cartAtomId) {
  return {
    type: DISCARD_CART,
    cartAtomId: cartAtomId
  };
}
function freeCartId(cartAtomId) {
  return {
    type: FREE_CART_ID,
    cartAtomId: cartAtomId
  };
}
function discardOrDeleteCart(cartAtomId) {
  return function (dispatch, getState) {
    var state = getState();
    var cart = getAtomCart(state, cartAtomId);
    dispatch(discardCart(cartAtomId));
    if (cart) {
      var type = cart.type;
      var hasCartItemList = cart.cartItemWithOfferList && cart.cartItemWithOfferList.size > 0;
      if ((type === CART_TYPE.CART || type === CART_TYPE.RESERVATION && !hasCartItemList) && cart !== null && cart !== void 0 && cart.get('@id')) {
        assertRelationIsDefined(window.ticketingSdk, 'ticketingSdk in discardOrDeleteCart');
        window.ticketingSdk.getRepository('cart')["delete"](cart)["catch"](function (err) {
          // eslint-disable-next-line no-console
          console.error(err.message);
        });
      }
    }
    return Promise.resolve();
  };
}
function updateComment(cartAtomId, comment) {
  return {
    type: UPDATE_COMMENT,
    cartAtomId: cartAtomId,
    comment: comment
  };
}
function updateCustomers(cartAtomId, customer, contact) {
  return {
    type: UPDATE_CUSTOMERS,
    cartAtomId: cartAtomId,
    customer: customer,
    contact: contact !== null && contact !== void 0 ? contact : null
  };
}
function updateOwner(cartAtomId, owner) {
  return {
    type: UPDATE_OWNER,
    cartAtomId: cartAtomId,
    owner: owner
  };
}
function cartItemIsForEventDate(cartItem, eventDateId) {
  assertRelationIsObject(cartItem.ticketPrice, 'cartItem.ticketPrice');
  var eventDate = cartItem.ticketPrice.eventDate;
  assertRelationIsObject(eventDate, 'cartItem.ticketPrice.eventDate');
  return eventDate.getShortId() === eventDateId.toString();
}
function ticketPriceQuantityIsForEventDate(ticketPriceQuantity, eventDateId) {
  var ticketPrice = ticketPriceQuantity.get('ticketPrice');
  assertRelationIsObject(ticketPrice.eventDate, 'ticketPrice.eventDate');
  return ticketPrice.eventDate.getShortId() === eventDateId.toString();
}
/**
 * This helper function inform `setTicketPriceQuantity` to lock all available seats
 * for the given event date id.
 * This way, no automatic replacement will happen.
 * This helper might be moved to js-component (and cart when actions are moved there) directly as an autonomous action
 * and might be handled in the reducer.
 */
function lockSeatsForEventDate(cartAtomId, eventDateId) {
  return function (dispatch, getState) {
    var state = getState();

    // get only ticketPriceQuantities for current eventDate
    var currentTicketPriceQuantitiesForEventDate = getAtomTicketPriceQuantities(state, cartAtomId).filter(function (ticketPriceQuantity) {
      return ticketPriceQuantityIsForEventDate(ticketPriceQuantity, eventDateId);
    });
    var cart = getAtomCart(state, cartAtomId);
    if (!cart) {
      // no cart : we can't lock anything
      return Promise.resolve();
    }
    assertRelationIsListOfObject(cart.cartItemList, 'cart.cartItemList');

    // get only cart items for current eventDate
    var cartItemListForEventDate = cart.cartItemList.filter(function (cartItem) {
      return cartItemIsForEventDate(cartItem, eventDateId);
    });

    // get ticket price quantity that have an available seat, ie. those who are explicitly locked
    var lockedTicketPriceQuantityList = currentTicketPriceQuantitiesForEventDate.map(function (ticketPriceQuantity) {
      return ticketPriceQuantity.get('availableSeat');
    }).filter(function (availableSeat) {
      return availableSeat !== null;
    });

    // extract all availableSeat from the list of cart item, return an object containing the availableSeat and the cart item
    var cartItemByAvailableSeat = cartItemListForEventDate.flatMap(function (cartItem) {
      var availableSeatList = cartItem.availableSeatList;
      if (!availableSeatList || availableSeatList.size === 0) {
        // if there is no available seat, just return an empty list that will be filtered by the `flatMap` method
        return List();
      }
      assertRelationIsListOfObject(availableSeatList, 'cartItem.availableSeatList');
      return availableSeatList.map(function (availableSeat) {
        return {
          availableSeat: availableSeat,
          cartItem: cartItem
        };
      });
    });
    var ticketPriceIdWithAvailableSeats = cartItemByAvailableSeat.map(function (_ref2) {
      var cartItem = _ref2.cartItem;
      assertRelationIsObject(cartItem.ticketPrice, 'cartItem.ticketPrice');
      assertRelationIsDefined(cartItem.ticketPrice['@id'], 'ticketPrice.@id');
      return cartItem.ticketPrice['@id'];
    });

    // get al lticket price quantity that are not already locked
    var notLockedTicketPriceQuantityList = currentTicketPriceQuantitiesForEventDate.filter(function (ticketPriceQuantity) {
      var ticketPrice = ticketPriceQuantity.get('ticketPrice');
      assertRelationIsDefined(ticketPrice['@id'], 'ticketPrice.@id');
      return !ticketPriceQuantity.get('availableSeat') && ticketPriceIdWithAvailableSeats.includes(ticketPrice['@id']);
    });

    // this is the number of ticket price quantity that are not locked, as we do not want to
    // lock extra cart items that might have been removed (the `currentTicketPriceQuantities` is the source of thruth here)
    var nbNotLockedTicketPriceQuantityList = notLockedTicketPriceQuantityList.reduce(function (acc, ticketPriceQuantity) {
      return acc + ticketPriceQuantity.get('quantity');
    }, 0);

    // format the ticketPriceQuantityList that will be dispatched
    var ticketPriceQuantityList = [].concat(_toConsumableArray(notLockedTicketPriceQuantityList.map(function (ticketPriceQuantity) {
      return {
        ticketPrice: ticketPriceQuantity.get('ticketPrice'),
        quantity: 0,
        groupKey: ticketPriceQuantity.get('groupKey'),
        couponCode: ticketPriceQuantity.get('couponCode'),
        stockContingent: ticketPriceQuantity.get('stockContingent'),
        data: ticketPriceQuantity.get('data'),
        participant: ticketPriceQuantity.get('participant'),
        availableSeat: null
      };
    })), _toConsumableArray(cartItemByAvailableSeat
    // we want only items that are not already locked
    .filter(function (_ref3) {
      var availableSeat = _ref3.availableSeat;
      assertRelationIsDefined(availableSeat['@id'], 'availableSeat.@id');
      return !lockedTicketPriceQuantityList.includes(availableSeat['@id']);
    })
    // do not take more available seats than the number of items that are not locked
    .slice(0, nbNotLockedTicketPriceQuantityList)
    // and convert that into a proper TicketPriceQuantityParameter
    .map(function (_ref4) {
      var cartItem = _ref4.cartItem,
        availableSeat = _ref4.availableSeat;
      var ticketPrice = cartItem.ticketPrice,
        stockContingent = cartItem.stockContingent,
        data = cartItem.data,
        participant = cartItem.participant;
      var cartItemWithOfferList = cart.cartItemWithOfferList;
      assertRelationIsListOfObject(cartItemWithOfferList, 'cart.cartItemWithOfferList');
      var cartItemWithOffer = cartItemWithOfferList.find(function (ciwo) {
        assertRelationIsObject(ciwo.cartItem, 'ciwo.cartItem');
        return getEntityId(ciwo.cartItem) === getEntityId(cartItem);
      });
      assertRelationIsObject(cartItemWithOffer, 'cartItemWithOffer');
      var groupKey = cartItemWithOffer.groupKey,
        couponCode = cartItemWithOffer.couponCode;
      assertRelationIsObject(ticketPrice, 'cartItem.ticketPrice');
      assertRelationIsNullOrObject(stockContingent, 'cartItem.stockContingent');
      return {
        ticketPrice: ticketPrice,
        quantity: 1,
        groupKey: groupKey,
        couponCode: couponCode || null,
        stockContingent: stockContingent,
        data: data,
        participant: getEntityId(participant),
        availableSeat: availableSeat['@id']
      };
    })));
    if (!ticketPriceQuantityList.length) {
      // do not dispatch if the list is empty
      return Promise.resolve();
    }

    // finaly, dispatch the action
    return dispatch(setTicketPriceQuantity$1(cartAtomId, ticketPriceQuantityList));
  };
}
function dismissCartBookingError(cartAtomId) {
  return {
    type: DISMISS_CART_BOOKING_ERROR,
    cartAtomId: cartAtomId
  };
}
function changeAvailableSeatTicketPrice(cartAtomId, eventDateId, availableSeat, oldTicketPrice, newTicketPrice) {
  return function (dispatch, getState) {
    var state = getState();
    var cart = getAtomCart(state, cartAtomId);
    if (!cart) {
      // no cart : we can't change anything
      return;
    }

    // lock all availableSeats for the event date
    dispatch(lockSeatsForEventDate(cartAtomId, eventDateId));

    // then switch the ticket price of targeted availableSeat
    dispatch(setTicketPriceQuantity$1(cartAtomId, [_objectSpread2(_objectSpread2({}, getCartItemQuantityForAvailableSeat(availableSeat, cart, -1, true)), {
      ticketPrice: oldTicketPrice
    }), _objectSpread2(_objectSpread2({}, getCartItemQuantityForAvailableSeat(availableSeat, cart, 1, true)), {
      ticketPrice: newTicketPrice
    })]));
  };
}
function deleteSelectedCartItemWithOfferList(cartAtomId, selectedCartItemWithOfferList) {
  return function (dispatch) {
    var ticketPriceQuantities = selectedCartItemWithOfferList.flatMap(function (_ref5) {
      var _cartItem$get;
      var cartItemWithOffer = _ref5.cartItemWithOffer,
        index = _ref5.index;
      var ticketPrice = cartItemWithOffer.ticketPrice,
        availableSeatList = cartItemWithOffer.availableSeatList,
        cartItem = cartItemWithOffer.cartItem;
      assertRelationIsObject(ticketPrice, 'cartItemWithOffer.ticketPrice');
      assertRelationIsObject(cartItem, 'cartItemWithOffer.cartItem');
      var stockContingent = (_cartItem$get = cartItem.get('stockContingent')) !== null && _cartItem$get !== void 0 ? _cartItem$get : null;
      assertRelationIsNullOrObject(stockContingent, 'cartItem.stockContingent');
      assertRelationIsNullOrListOfObject(availableSeatList, 'cartItemWithOffer.availableSeatList');
      var availableSeat = availableSeatList.get(index);
      if (availableSeat) {
        assertRelationIsObject(availableSeat);
        assertRelationIsDefined(availableSeat.manuallyAssigned, 'availableSeat.manuallyAssigned');
      }
      return List([Map({
        ticketPrice: ticketPrice,
        quantityDelta: -1,
        groupKey: cartItemWithOffer.get('groupKey'),
        data: cartItem.get('data'),
        participant: getEntityId(cartItem.get('participant')),
        couponCode: cartItemWithOffer.get('couponCode'),
        stockContingent: stockContingent,
        availableSeat: availableSeat !== null && availableSeat !== void 0 && availableSeat.manuallyAssigned ? getEntityId(availableSeat) : null
      })]);
    });
    dispatch(setTicketPriceQuantity$1(cartAtomId, ticketPriceQuantities));
  };
}

/*
 * Update the ticket price and/or stock contingent of the selected cart items with offer
 * This is useful to modify a cartItemWithOffer already in the cart
 *
 * when the user change the ticket price or stock contingent in the UI
 * The quantity of the existing cart item with offer is decremented by one
 * and a new ticket price quantity is added with a quantityDelta of 1
 * If a new group key is provided for the new ticket price quantity, it is added to it
 */
function updateExistingTicketPriceQuantity(cartAtomId, selectedCartItemWithOfferList, selectedOffersWithTemporaryGroupKey, newTicketPriceId, newStockContingentId) {
  return function (dispatch, getState) {
    if (!newTicketPriceId && !newStockContingentId) {
      return;
    }
    var tpQttUpdate = {
      ticketPrice: newTicketPriceId && new TicketPrice({
        '@id': newTicketPriceId
      }),
      stockContingent: newStockContingentId && (newStockContingentId === NO_STOCK_CONTINGENT ? NO_STOCK_CONTINGENT : new StockContingent({
        '@id': newStockContingentId
      }))
    };
    var ticketPriceQuantities = getState().booking[cartAtomId].get('currentTicketPriceQuantities');
    selectedCartItemWithOfferList.forEach(function (_ref6) {
      var cartItemWithOffer = _ref6.cartItemWithOffer;
      var ciwoTicketPriceQuantity = convertCartItemWithOfferToTicketPriceQuantity(cartItemWithOffer);

      // find entry again to extract its index from the ticketPriceQuantity list
      var foundEntry = ticketPriceQuantities.findEntry(function (entry) {
        return getItemKey(entry) === getItemKey(ciwoTicketPriceQuantity) && !!entry.get('quantity');
      });
      if (!foundEntry) {
        throw new Error('Entry was not found. This should not happen.');
      }
      var _foundEntry = _slicedToArray(foundEntry, 2),
        currentTpQttIndex = _foundEntry[0],
        currentTpQtt = _foundEntry[1]; // eslint-disable-line prefer-const

      // merge tpQttUpdate into currentTpQtt
      var updatedTpQtt = mergeTicketPriceQuantityUpdate(currentTpQtt, tpQttUpdate);
      var currentQuantity = currentTpQtt.get('quantity', 1) || 1;
      var decrementedQuantity = typeof currentQuantity === 'string' ? parseInt(currentQuantity, 10) : currentQuantity - 1;

      // remove quantity of updated item, replace it with a quantityDelta of 1
      updatedTpQtt = updatedTpQtt["delete"]('quantity').set('quantityDelta', 1);
      var newGroupKey = selectedOffersWithTemporaryGroupKey.get(cartItemWithOffer);

      // if a new group key should be added, then add it to the updated tpQtt
      if (newGroupKey && !updatedTpQtt.get('groupKey')) {
        updatedTpQtt = updatedTpQtt.set('groupKey', newGroupKey);
      }

      // repack ticketPriceQuantity list
      ticketPriceQuantities = ticketPriceQuantities.set(currentTpQttIndex,
      // decrement current quantity by 1
      currentTpQtt.set('quantity', decrementedQuantity)).push(updatedTpQtt);
    });
    dispatch(setTicketPriceQuantity$1(cartAtomId, ticketPriceQuantities));
  };
}
function convertCartToReservationOrOption(cartAtomId, cartType) {
  return function (dispatch, getState) {
    var currentTicketPriceQuantity = getState().booking[cartAtomId].get('currentTicketPriceQuantities');
    dispatch(setTicketPriceQuantity$1(cartAtomId, currentTicketPriceQuantity, cartType, CART_STATUS.VALIDATED));
  };
}

/*
 * Update the ticket price quantity of the selected ticket price
 * This is useful to add or remove ticket prices from the cart
 * when the user click on the + or - button in the UI (and we do not have all the info about which cartItem we are acting upon)
 */
function changeTicketPriceQuantity(cartAtomId, ticketPrice, quantityDelta, stockContingent, groupKey, cartType) {
  return function (dispatch) {
    dispatch(setTicketPriceQuantity$1(cartAtomId, List([Map({
      ticketPrice: ticketPrice,
      quantityDelta: quantityDelta,
      stockContingent: stockContingent,
      groupKey: groupKey
    })]), cartType));
  };
}

/*
 * Replace all ticket prices in the current list by the new list, for the given group key
 * This is useful to swap the ticketPrice for an offer
 */
function replaceTicketPriceListWithGroupKey(cartAtomId, currentTicketPriceIdList, nextTicketPriceIdList, currency, groupKey) {
  return function (dispatch) {
    dispatch(setTicketPriceQuantity$1(cartAtomId, currentTicketPriceIdList.map(function (id) {
      return {
        ticketPrice: new TicketPrice({
          '@id': id,
          currency: currency
        }),
        quantityDelta: -1,
        groupKey: groupKey
      };
    }).concat(nextTicketPriceIdList.map(function (id) {
      return {
        ticketPrice: new TicketPrice({
          '@id': id,
          currency: currency
        }),
        quantityDelta: 1,
        groupKey: groupKey
      };
    }))));
  };
}
var INCREMENT_OR_DECREMENT = /*#__PURE__*/function (INCREMENT_OR_DECREMENT) {
  INCREMENT_OR_DECREMENT["INCREMENT"] = "INCREMENT";
  INCREMENT_OR_DECREMENT["DECREMENT"] = "DECREMENT";
  return INCREMENT_OR_DECREMENT;
}(INCREMENT_OR_DECREMENT || {});
function getIncrementOrDecrementTicketPriceQuantity(ticketPriceId, groupKey, incrementOrDecrement, currency) {
  return {
    ticketPrice: new TicketPrice({
      '@id': ticketPriceId,
      currency: currency
    }),
    quantityDelta: incrementOrDecrement === INCREMENT_OR_DECREMENT.INCREMENT ? 1 : -1,
    groupKey: groupKey
  };
}

/*
 * Decrement all ticket prices in the list, for the given group key
 * This is useful to remove an offer application
 */
function decrementTicketPriceListWithGroupKey(cartAtomId, currentTicketPriceIdList, groupKey) {
  return function (dispatch) {
    dispatch(setTicketPriceQuantity$1(cartAtomId, currentTicketPriceIdList.map(function (id) {
      return getIncrementOrDecrementTicketPriceQuantity(id, groupKey, INCREMENT_OR_DECREMENT.DECREMENT);
    })));
  };
}

/*
 * Increment all ticket prices in the list, for each group key in the group key list
 * This is useful to duplicate an offer application once or multiple times (as many times as there are group keys in the list)
 */
function incrementTicketPriceListWithGroupKeyList(cartAtomId, ticketPriceIdList, groupKeyList, currency, cartType) {
  return function (dispatch) {
    var ticketPriceQuantityList = groupKeyList.reduce(function (acc, groupKey) {
      return acc.concat(ticketPriceIdList.map(function (ticketPriceId) {
        return getIncrementOrDecrementTicketPriceQuantity(ticketPriceId, groupKey, INCREMENT_OR_DECREMENT.INCREMENT, currency);
      }));
    }, List());
    return dispatch(setTicketPriceQuantity$1(cartAtomId, ticketPriceQuantityList, cartType));
  };
}

var PACK_CARTITEM_LIMIT = 10;
var SelectedCartItemContext = /*#__PURE__*/createContext(null);
function SelectedCartItemProvider(_ref) {
  var children = _ref.children,
    cartAtomId = _ref.cartAtomId;
  var cart = useAtomCart(cartAtomId);
  var dispatch = useCartDispatch();
  var _useState = useState(List()),
    _useState2 = _slicedToArray(_useState, 2),
    selectedCartItems = _useState2[0],
    setSelectedCartItems = _useState2[1];
  var _useState3 = useState(Map()),
    _useState4 = _slicedToArray(_useState3, 2),
    selectedOffersWithTemporaryGroupKey = _useState4[0],
    setSelectedOffersWithTemporaryGroupKey = _useState4[1];
  useEffect(function () {
    var _cart$cartItemList;
    if (cart && cart['@id'] && !((_cart$cartItemList = cart.cartItemList) !== null && _cart$cartItemList !== void 0 && _cart$cartItemList.size)) {
      dispatch(discardOrDeleteCart(cartAtomId));
    }
  }, [cart, dispatch, cartAtomId]);
  var selectedCartItemHashAndIndexSet = useMemo(function () {
    return Set(selectedCartItems.map(function (cartItemWithOffer) {
      return "".concat(cartItemWithOffer.cartItemWithOffer.hashCode(), "-").concat(cartItemWithOffer.index);
    }));
  }, [selectedCartItems]);
  var selectedCartItemIdAndIndexSet = useMemo(function () {
    return selectedCartItems.map(function (_ref2) {
      var cartItemWithOffer = _ref2.cartItemWithOffer,
        index = _ref2.index;
      return "".concat(getCartItemId(cartItemWithOffer), "-").concat(index);
    }).toSet();
  }, [selectedCartItems]);
  var CartProps = useMemo(function () {
    return {
      selectedCartItems: selectedCartItems,
      selectedCartItemIdAndIndexSet: selectedCartItemIdAndIndexSet,
      selectedCartItemHashAndIndexSet: selectedCartItemHashAndIndexSet,
      setSelectedCartItems: setSelectedCartItems,
      selectedOffersWithTemporaryGroupKey: selectedOffersWithTemporaryGroupKey,
      setSelectedOffersWithTemporaryGroupKey: setSelectedOffersWithTemporaryGroupKey
    };
  }, [selectedCartItems, selectedCartItemIdAndIndexSet, selectedCartItemHashAndIndexSet, selectedOffersWithTemporaryGroupKey]);
  return /*#__PURE__*/jsx(SelectedCartItemContext.Provider, {
    value: CartProps,
    children: children
  });
}
var useSelectedCartItemContext = function useSelectedCartItemContext() {
  var selectedCardItemContext = useContext(SelectedCartItemContext);
  if (!selectedCardItemContext) {
    throw new Error('SelectedCardItemContext should be defined. Did you add a context provider up in the tree ?');
  }
  return selectedCardItemContext;
};

var generateGroupKey = function generateGroupKey() {
  return Math.random().toString(36).substring(2);
};

function AllSelect(_ref) {
  var id = _ref.id,
    ciwoList = _ref.ciwoList,
    isOffer = _ref.isOffer;
  var _useSelectedCartItemC = useSelectedCartItemContext(),
    selectedCartItemIdAndIndexSet = _useSelectedCartItemC.selectedCartItemIdAndIndexSet,
    setSelectedCartItems = _useSelectedCartItemC.setSelectedCartItems,
    setSelectedOffersWithTemporaryGroupKey = _useSelectedCartItemC.setSelectedOffersWithTemporaryGroupKey;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;

  // Intersect between ciwoList & selectedCartItemIdAndIndexSet
  // to know if all block items are checked 🤯
  var checked = useMemo(function () {
    return selectedCartItemIdAndIndexSet.isSuperset(ciwoList.flatMap(function (ciwo) {
      // TODO CartItemWithOffer should have quantity 1 only now

      return Array(ciwo.get('quantity')).fill(null).map(function (_v, index) {
        return "".concat(getCartItemId(ciwo), "-").concat(index);
      });
    }).toSet());
  }, [selectedCartItemIdAndIndexSet, ciwoList]);
  useEffect(function () {
    var firstItem = ciwoList.first();
    var hasGroupKey = !!(firstItem !== null && firstItem !== void 0 && firstItem.get('groupKey'));
    if (!isOffer || hasGroupKey) {
      return;
    }
    if (checked) {
      // generate groupKey to fully selected offer if it doesn't exist
      var temporaryGroupKey = "".concat(firstItem === null || firstItem === void 0 ? void 0 : firstItem.getIn(['offer', 'id']), "|").concat(generateGroupKey());
      setSelectedOffersWithTemporaryGroupKey(function (selectedOffers) {
        var newSelectedOffers = selectedOffers;
        ciwoList.forEach(function (cartItemWithOffer) {
          newSelectedOffers = newSelectedOffers.set(cartItemWithOffer, temporaryGroupKey);
        });
        return newSelectedOffers;
      });
    } else {
      setSelectedOffersWithTemporaryGroupKey(function (selectedOffers) {
        var newSelectedOffers = selectedOffers;
        ciwoList.forEach(function (cartItemWithOffer) {
          newSelectedOffers = newSelectedOffers["delete"](cartItemWithOffer);
        });
        return newSelectedOffers;
      });
    }
  }, [checked, isOffer, ciwoList, setSelectedOffersWithTemporaryGroupKey]);
  var handleAllSelect = function handleAllSelect(event) {
    var isChecked = event.target.checked;
    setSelectedCartItems(function (list) {
      var cleanList = list.filter(function (_ref2) {
        var cartItemWithOffer = _ref2.cartItemWithOffer;
        return !ciwoList.some(function (ciwo) {
          return getCartItemId(ciwo) === getCartItemId(cartItemWithOffer);
        });
      });
      if (isChecked) {
        return cleanList.concat(ciwoList.flatMap(function (ciwo) {
          var iterator = List(Array(ciwo.get('quantity'))).keySeq();
          return List(iterator.toArray().map(function (index) {
            return {
              cartItemWithOffer: ciwo,
              index: index
            };
          }));
        }));
      }
      return cleanList;
    });
  };
  return /*#__PURE__*/jsx(MpdCheckbox, {
    id: id,
    checked: checked,
    onChange: handleAllSelect,
    className: "uppercase",
    children: t('select_all')
  });
}

var CartTypeContext = /*#__PURE__*/createContext(SELLING_DEVICE_DESK);
var useCartTypeContext = function useCartTypeContext() {
  return useContext(CartTypeContext);
};

function CartItemNotBuyable(_ref) {
  var cart = _ref.cart,
    data = _ref.data,
    renderCouponModalButton = _ref.renderCouponModalButton;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var cartType = useCartTypeContext();
  var isDesk = cartType === SELLING_DEVICE_DESK;
  var isMinisite = cartType === SELLING_DEVICE_MINISITE;
  var buyableTerms = getBuyableTerms(data);
  if (!isDesk && !isMinisite) {
    return null;
  }
  return /*#__PURE__*/jsx("div", {
    className: "mpd-cart__CartItem__NotBuyable",
    children: /*#__PURE__*/jsxs("div", {
      className: "mpd-cart__CartItem__NotBuyable__Content",
      children: [/*#__PURE__*/jsx("div", {
        className: "mpd-cart__CartItem__NotBuyable__Border"
      }), /*#__PURE__*/jsxs("div", {
        className: "mpd-cart__CartItem__NotBuyable__WarningMessage p1",
        children: [isDesk && /*#__PURE__*/jsx("span", {
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML: {
            __html: t('cart.desk.ticket_price_not_buyable_message')
          }
        }), isMinisite && /*#__PURE__*/jsx("span", {
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML: {
            __html: t('cart.minisite.ticket_price_not_buyable_message')
          }
        }), buyableTerms && /*#__PURE__*/jsxs("div", {
          children: [/*#__PURE__*/jsx("span", {
            className: "mpd-color-gray",
            children: t('cart.ticket_price_buyable_terms')
          }), buyableTerms]
        })]
      }), /*#__PURE__*/jsxs("div", {
        className: "mpd-cart__CartItem__NotBuyable__Actions",
        children: [isDesk && !!renderCouponModalButton && renderCouponModalButton(cart), (isMinisite || !renderCouponModalButton) && /*#__PURE__*/jsx(CouponModalButton, {
          label: t('cart.cartItem_not_buyable.apply_coupon'),
          buttonType: "link"
        })]
      })]
    })
  });
}
function getBuyableTerms(data) {
  if (!data.ticketPrice || typeof data.ticketPrice === 'string') {
    return null;
  }
  assertRelationIsObject(data.ticketPrice, 'data.ticketPrice');
  var description = data.ticketPrice.description;
  if ((description === null || description === void 0 ? void 0 : description.length) === 0) {
    return null;
  }
  return description;
}

function CartItemParticipant(_ref) {
  var _data$getIn;
  var data = _ref.data,
    cartItemNumber = _ref.cartItemNumber,
    quantity = _ref.quantity,
    multiple = _ref.multiple,
    _ref$isOffer = _ref.isOffer,
    isOffer = _ref$isOffer === void 0 ? true : _ref$isOffer,
    createdCashCoupon = _ref.createdCashCoupon,
    _ref$isCheckboxVisibl = _ref.isCheckboxVisible,
    isCheckboxVisible = _ref$isCheckboxVisibl === void 0 ? true : _ref$isCheckboxVisibl,
    onParticipantClick = _ref.onParticipantClick;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useCartViewContext = useCartViewContext(),
    type = _useCartViewContext.type;
  var cartType = useCartTypeContext();
  var isMinisite = cartType === SELLING_DEVICE_MINISITE;

  // @ts-expect-error -- need offer type with Map in TS
  var colorOffer = (_data$getIn = data.getIn(['offer', 'exchangeData'])) === null || _data$getIn === void 0 ? void 0 : _data$getIn.color;
  var participantLabel = getParticipantFromCIWO(data);
  var renderParticipant = function renderParticipant() {
    // TODO : Change back key name once migrated everywhere
    var transKey = 'cart.item.new_index';
    var transKeyMultiple = 'ticketing.summary_block.item_count';
    if (data !== null && data !== void 0 && data.cartItem) {
      assertRelationIsObject(data.cartItem, 'data.cartItem');
      var cartItem = data.cartItem;
      if (cartItem.ticketPrice) {
        assertRelationIsObject(cartItem.ticketPrice, 'cartItem.ticketPrice');
        var ticketPrice = cartItem.ticketPrice;
        if (ticketPrice.willGenerateTicket) {
          transKey = 'cart.ticket.index';
          transKeyMultiple = 'ticketing.summary_block.ticket_count';
        }
      }
    }
    if (multiple && quantity) {
      return t(transKeyMultiple, {
        count: quantity
      });
    }
    if (participantLabel) {
      return participantLabel;
    }
    if (createdCashCoupon) {
      return t('cart.item.cash_coupon.index', {
        index: cartItemNumber
      });
    }
    return t(transKey, {
      index: cartItemNumber
    });
  };
  var handleOnClick = function handleOnClick(e) {
    var _data$cartItem, _cartItem$participant;
    if (!onParticipantClick) {
      return;
    }
    var cartItem = (_data$cartItem = data === null || data === void 0 ? void 0 : data.cartItem) !== null && _data$cartItem !== void 0 ? _data$cartItem : null;
    assertRelationIsNullOrObject(cartItem);
    var participant = (_cartItem$participant = cartItem === null || cartItem === void 0 ? void 0 : cartItem.participant) !== null && _cartItem$participant !== void 0 ? _cartItem$participant : null;
    assertRelationIsNullOrObject(participant);
    var crmId = participant === null || participant === void 0 ? void 0 : participant.get('crmId');
    if (crmId) {
      e.preventDefault();
      onParticipantClick(crmId);
    }
  };
  return /*#__PURE__*/jsx("div", {
    className: "mpd-cart__CartItemParticipant_Container",
    children: /*#__PURE__*/jsxs("div", {
      className: cn('mpd-cart__CartItemParticipant', {
        'mpd-cart__CartItemParticipant--no-checkbox': !isCheckboxVisible
      }, colorOffer && type === eventDateType && "gradiant-background-color-".concat(colorOffer)),
      "aria-hidden": "true",
      onClick: handleOnClick,
      children: [/*#__PURE__*/jsx("div", {
        className: "mpd-cart__CartItemParticipant__TicketName",
        children: renderParticipant()
      }), isOffer && /*#__PURE__*/jsxs(Fragment, {
        children: [/*#__PURE__*/jsx("div", {
          className: "h3-like mpd-cart__CartItemParticipant__TicketingTitle",
          children: data.ticketingTitle
        }), /*#__PURE__*/jsx("div", {
          className: "small mpd-color-gray",
          children: /*#__PURE__*/jsx(FormattedDateForStartAndEndDate, {
            startDate: data.date ? moment.parseZone(data.date) : null,
            endDate: data.endDate ? moment.parseZone(data.endDate) : null,
            format: FORMATTED_DATE_FORMAT.LONG_WITH_YEAR_AND_SHORT_MONTH
          })
        })]
      }), isMinisite && /*#__PURE__*/jsx("div", {
        className: "small bold mt1",
        children: data.name
      })]
    })
  });
}

function CartItemPriceInfos(_ref) {
  var _data$getIn;
  var data = _ref.data,
    createdCashCoupon = _ref.createdCashCoupon,
    _ref$isOffer = _ref.isOffer,
    isOffer = _ref$isOffer === void 0 ? false : _ref$isOffer;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t,
    i18n = _useTranslation.i18n;
  var cartType = useCartTypeContext();
  var isDesk = cartType === SELLING_DEVICE_DESK;
  var isMinisite = cartType === SELLING_DEVICE_MINISITE;
  var formattedPrice = formatPrice(data.getIn(['ticketPrice', 'facialValue']), data.getIn(['ticketPrice', 'currency']), getLocale(i18n.language));
  var displayPrice =
  // @ts-expect-error -- need offer type
  !isOffer || !((_data$getIn = data.getIn(['offer', 'exchangeData'])) !== null && _data$getIn !== void 0 && _data$getIn.hideIndividualPrice);
  return /*#__PURE__*/jsxs("div", {
    className: cn({
      center: isMinisite
    }),
    children: [isDesk && !createdCashCoupon && /*#__PURE__*/jsxs("span", {
      className: "mpd-color-gray small",
      children: [data.name, displayPrice && ' : ']
    }), isDesk && createdCashCoupon && /*#__PURE__*/jsx("span", {
      className: "mpd-color-gray small",
      children: t('cart.createdCoupon.price')
    }), /*#__PURE__*/jsx("span", {
      className: cn('h3-like mpd-cart__CartItem__Price', {
        'mpd-cart__CartItem__Price--offer': isMinisite && isOffer,
        larger: isMinisite
      }),
      children: displayPrice && formattedPrice
    })]
  });
}

var CartViewPlanContext = /*#__PURE__*/createContext(null);
function CartViewPlanProvider(_ref) {
  var children = _ref.children;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    selectedEventDateIdViewPlan = _useState2[0],
    setSelectedEventDateIdViewPlan = _useState2[1];
  var handleViewPlanClick = function handleViewPlanClick(ciwo) {
    setSelectedEventDateIdViewPlan(ciwo.getIn(['ticketPrice', 'eventDate']).getShortId());
  };
  var values = useMemo(function () {
    return {
      selectedEventDateIdViewPlan: selectedEventDateIdViewPlan,
      setSelectedEventDateIdViewPlan: setSelectedEventDateIdViewPlan,
      handleViewPlanClick: handleViewPlanClick
    };
  }, [selectedEventDateIdViewPlan]);
  return /*#__PURE__*/jsx(CartViewPlanContext.Provider, {
    value: values,
    children: children
  });
}
var useCartViewPlanContext = function useCartViewPlanContext() {
  var cartViewPlanContext = useContext(CartViewPlanContext);
  if (!cartViewPlanContext) {
    throw new Error('CartViewPlanContext should be defined. Did you add a context provider up in the tree ?');
  }
  return cartViewPlanContext;
};

function ReplaceSeatingButton(_ref) {
  var cartItemWithOffer = _ref.cartItemWithOffer,
    _ref$isOffer = _ref.isOffer,
    isOffer = _ref$isOffer === void 0 ? false : _ref$isOffer;
  var _useCartViewPlanConte = useCartViewPlanContext(),
    handleViewPlanClick = _useCartViewPlanConte.handleViewPlanClick;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/jsxs("button", {
    type: "button",
    onClick: function onClick() {
      if (cartItemWithOffer) handleViewPlanClick(cartItemWithOffer);
    },
    className: cn('mpd-btn', {
      'pl0 capitalize normal pt1': isOffer,
      'mpd-color-white': !isOffer
    }),
    children: [/*#__PURE__*/jsx(MpdIcon, {
      icon: "seat",
      width: "18",
      height: "18"
    }), t('cart.item.replacement')]
  });
}

function CartItemSeatingInfos(_ref) {
  var data = _ref.data,
    createdCashCoupon = _ref.createdCashCoupon,
    _ref$index = _ref.index,
    index = _ref$index === void 0 ? 0 : _ref$index,
    _ref$isOffer = _ref.isOffer,
    isOffer = _ref$isOffer === void 0 ? false : _ref$isOffer,
    _ref$multiple = _ref.multiple,
    multiple = _ref$multiple === void 0 ? false : _ref$multiple,
    isMovableSeat = _ref.isMovableSeat;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useCartViewPlanConte = useCartViewPlanContext(),
    handleViewPlanClick = _useCartViewPlanConte.handleViewPlanClick;
  var cartType = useCartTypeContext();
  var cartAtomId = useCartAtomIdContext();
  var cart = useAtomCart(cartAtomId);
  var isDesk = cartType === SELLING_DEVICE_DESK;
  var isMinisite = cartType === SELLING_DEVICE_MINISITE;
  var contingentLabel = data.getIn(['cartItem', 'stockContingent', 'name']) || t('cart.not_in_contingent');
  var contingentColor = data.getIn(['cartItem', 'stockContingent', 'color']) || $primaryBlue;
  var manuallyAssigned = data.getIn(['availableSeatList', index, 'manuallyAssigned']);
  var seatingInfo = getCIWOUSeatingInfo(data, index);
  if (createdCashCoupon) {
    return /*#__PURE__*/jsxs("div", {
      className: "flex-row",
      children: [/*#__PURE__*/jsx("div", {
        className: "mpd-cart__CartItem__Seating"
      }), /*#__PURE__*/jsx("div", {
        children: /*#__PURE__*/jsx(CouponValidUntilLabel, {
          coupon: createdCashCoupon
        })
      })]
    });
  }
  if (isDesk) {
    return /*#__PURE__*/jsx("div", {
      children: /*#__PURE__*/jsxs("div", {
        className: "mpd-cart__CartItem__Contingent",
        style: {
          color: contingentColor
        },
        children: [seatingInfo ? /*#__PURE__*/jsx("div", {
          className: cn('mpd-cart__CartItem__Seating', {
            'mpd-cart__CartItem__Seating--manuallyAssigned': manuallyAssigned,
            'mpd-cart__CartItem__Seating--no-click': !isMovableSeat
          }),
          "aria-hidden": "true",
          onClick: function onClick() {
            if (isMovableSeat) {
              handleViewPlanClick(data);
            }
          },
          title: getCIWOUIsManuallyAssigned(data, index) ? t('ticketing.summary_block.seat_assignation.manual') : t('ticketing.summary_block.seat_assignation.automatic'),
          children: /*#__PURE__*/jsx("strong", {
            children: multiple ? /*#__PURE__*/jsx(MpdIcon, {
              icon: "seat",
              width: "20"
            }) : (seatingInfo === null || seatingInfo === void 0 ? void 0 : seatingInfo.seatLabel) && /*#__PURE__*/jsx("span", {
              children: seatingInfo.seatLabel
            })
          })
        }) : /*#__PURE__*/jsx("div", {
          className: "mpd-cart__CartItem__Seating"
        }), /*#__PURE__*/jsx("div", {
          className: "mpd-cart__CartItem__ContingentLabel",
          children: contingentLabel
        })]
      })
    });
  }
  if (isMinisite) {
    var ticketPrice = data.ticketPrice;
    assertRelationIsObject(ticketPrice);
    assertRelationIsObject(ticketPrice.eventDate);
    var ticketing = ticketPrice.eventDate.ticketing;
    assertRelationIsObject(ticketing);
    var hideReplaceButton = shouldHideSeatingReplacement(isMinisite, cart, ticketing);
    return /*#__PURE__*/jsx("div", {
      className: cn({
        'mpd-cart__CartItem__Contingent_Seating_Container': !seatingInfo
      }),
      children: seatingInfo && /*#__PURE__*/jsxs("div", {
        className: "mpd-color-gray small",
        children: [/*#__PURE__*/jsx("div", {
          children: seatingInfo.seatLabel && /*#__PURE__*/jsx("span", {
            className: "mr1",
            children: t('cart.cart_item.seating.number', {
              seatNumber: seatingInfo.seatLabel
            })
          })
        }), isOffer && !hideReplaceButton && /*#__PURE__*/jsx(ReplaceSeatingButton, {
          cartItemWithOffer: data,
          isOffer: true
        })]
      })
    });
  }
  return null;
}

function SeatIsolatedWarning(_ref) {
  var _getCartItemWithOffer;
  var data = _ref.data,
    index = _ref.index;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var cartAtomId = useCartAtomIdContext();
  var cart = useAtomCart(cartAtomId);
  if (!(cart !== null && cart !== void 0 && cart.cartItemWithOfferList)) {
    return null;
  }
  assertRelationIsNullOrListOfObject(cart.cartItemWithOfferList, 'cart.cartItemWithOfferList');
  var eventDateGrouped = (_getCartItemWithOffer = getCartItemWithOfferGroupedByEventDate(cart.cartItemWithOfferList)) === null || _getCartItemWithOffer === void 0 ? void 0 : _getCartItemWithOffer.toList();
  var availableSeatList = data.get('availableSeatList');
  assertRelationIsListOfObject(availableSeatList);
  var currentSeat = availableSeatList.get(index);
  if (!(currentSeat !== null && currentSeat !== void 0 && currentSeat.seat) || currentSeat !== null && currentSeat !== void 0 && currentSeat.manuallyAssigned) {
    return null;
  }
  assertRelationIsObject(currentSeat.seat);
  var currentSeatPosition = currentSeat.seat.position;
  var currentSeatType = currentSeat.seat.type;
  var relatedEventData = eventDateGrouped === null || eventDateGrouped === void 0 ? void 0 : eventDateGrouped.filter(function (eventDate) {
    return eventDate.get('cartItemWithOfferList').some(function (cartItemWithOffer) {
      return cartItemWithOffer === data;
    });
  });
  var adjacentSeatPositions = relatedEventData === null || relatedEventData === void 0 ? void 0 : relatedEventData.flatMap(function (eventData) {
    return eventData.get('cartItemWithOfferList').map(function (cartItemWithOffer) {
      var seatList = cartItemWithOffer.get('availableSeatList');
      assertRelationIsListOfObject(seatList);
      var seatInCart = seatList.get(index);
      if (!(seatInCart !== null && seatInCart !== void 0 && seatInCart.seat)) {
        return null;
      }
      assertRelationIsObject(seatInCart.seat);
      return seatInCart.seat.position;
    });
  });
  var isIsolated = !(adjacentSeatPositions !== null && adjacentSeatPositions !== void 0 && adjacentSeatPositions.some(function (position) {
    if (!currentSeatPosition || (adjacentSeatPositions === null || adjacentSeatPositions === void 0 ? void 0 : adjacentSeatPositions.size) === 1) {
      return true;
    }
    return position === currentSeatPosition - 1 || position === currentSeatPosition + 1;
  }));
  if (!isIsolated || currentSeatType === SEAT_TYPE.STANDING) {
    // Do not display warning if seat is not isolated or it a seat with type "standing"
    return null;
  }
  return /*#__PURE__*/jsx("div", {
    className: "mpd-cart__CartItem__NotBuyable",
    children: /*#__PURE__*/jsxs("div", {
      className: "mpd-cart__CartItem__NotBuyable__Content",
      children: [/*#__PURE__*/jsx("div", {
        className: "mpd-cart__CartItem__Warning__Border"
      }), /*#__PURE__*/jsx("div", {
        className: "mpd-cart__CartItem__NotBuyable__WarningMessage p1",
        children: t('cart.seating.warning.isolated_seat')
      })]
    })
  });
}

function SeatTypeFoldableWarning(_ref) {
  var data = _ref.data,
    index = _ref.index;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var availableSeat = data.getIn(['availableSeatList', index]);
  if (!availableSeat || !availableSeat.seat) {
    return null;
  }
  assertRelationIsObject(availableSeat.seat);
  if (availableSeat.seat.type !== 'foldable') {
    return null;
  }
  return /*#__PURE__*/jsx("div", {
    className: "mpd-cart__CartItem__NotBuyable",
    children: /*#__PURE__*/jsxs("div", {
      className: "mpd-cart__CartItem__NotBuyable__Content",
      children: [/*#__PURE__*/jsx("div", {
        className: "mpd-cart__CartItem__Warning__Border"
      }), /*#__PURE__*/jsx("div", {
        className: "mpd-cart__CartItem__NotBuyable__WarningMessage p1",
        children: t('cart.seating.warning.foldable_seat')
      })]
    })
  });
}

function SeatTypeObstructedViewWarning(_ref) {
  var data = _ref.data,
    index = _ref.index;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var availableSeat = data.getIn(['availableSeatList', index]);
  if (!availableSeat || !availableSeat.seat) {
    return null;
  }
  assertRelationIsObject(availableSeat.seat);
  if (!availableSeat.seat.hasObstructedView) {
    return null;
  }
  return /*#__PURE__*/jsx("div", {
    className: "mpd-cart__CartItem__NotBuyable",
    children: /*#__PURE__*/jsxs("div", {
      className: "mpd-cart__CartItem__NotBuyable__Content",
      children: [/*#__PURE__*/jsx("div", {
        className: "mpd-cart__CartItem__Warning__Border"
      }), /*#__PURE__*/jsx("div", {
        className: "mpd-cart__CartItem__NotBuyable__WarningMessage p1",
        children: t('cart.seating.warning.obstructed_view')
      })]
    })
  });
}

function useUpdateCiwoQuantity(cartAtomId) {
  var dispatch = useCartDispatch();
  var updateCiwoQuantity = function updateCiwoQuantity(cartItemWithOffer, quantityDelta, availableSeat) {
    var cartItem = cartItemWithOffer.cartItem,
      ticketPrice = cartItemWithOffer.ticketPrice,
      groupKey = cartItemWithOffer.groupKey,
      couponCode = cartItemWithOffer.couponCode;

    // TODO move to jscomponent
    assertRelationIsObject(cartItem, 'cartItemWithOffer.cartItem');
    assertRelationIsObject(ticketPrice, 'cartItemWithOffer.ticketPrice');
    assertRelationIsNullOrObject(cartItem.stockContingent, 'cartItemWithOffer.cartItem.stockContingent');
    assertRelationIsNullOrObject(cartItem.participant, 'cartItemWithOffer.cartItem.participant');
    if (quantityDelta > 0) {
      return dispatch(setTicketPriceQuantity$1(cartAtomId, [{
        ticketPrice: ticketPrice,
        quantityDelta: quantityDelta,
        groupKey: groupKey || null,
        couponCode: couponCode || null,
        data: cartItem.data || null,
        participant: getEntityId(cartItem.participant) || null,
        stockContingent: cartItem.stockContingent,
        availableSeat: null
      }]));
    }
    if (availableSeat) {
      assertRelationIsDefined(availableSeat['@id'], 'availableSeat.@id');
      if (quantityDelta < -1) {
        throw new Error("Cannot remove more than one item linked to available seat (".concat(availableSeat['@id'], ")"));
      }
    }
    return dispatch(setTicketPriceQuantity$1(cartAtomId, [{
      ticketPrice: ticketPrice,
      quantityDelta: quantityDelta,
      groupKey: groupKey || null,
      couponCode: couponCode || null,
      data: cartItem.data || null,
      participant: getEntityId(cartItem.participant) || null,
      stockContingent: cartItem.stockContingent,
      availableSeat: availableSeat && availableSeat.manuallyAssigned ? getEntityId(availableSeat) : null
    }]));
  };
  return updateCiwoQuantity;
}
function useDuplicateOffer(cartAtomId) {
  var dispatch = useCartDispatch();
  return function (ciwoList) {
    var groupKey = generateGroupKey();
    var ticketPriceQuantities = ciwoList.map(function (ciwo) {
      // TODO move to jscomponent
      assertRelationIsObject(ciwo.cartItem, 'ciwo.cartItem');
      assertRelationIsObject(ciwo.ticketPrice, 'ciwo.ticketPrice');
      assertRelationIsObject(ciwo.offer, 'ciwo.offer');
      assertRelationIsDefined(ciwo.quantity, 'ciwo.quantity');

      // do not pass couponCode here since we do not want to duplicate offers applied using cartItem.couponCode
      // maybe don't event pass a groupKey when there is a couponCode so that duplicated items are not grouped in vain?
      return {
        ticketPrice: ciwo.ticketPrice,
        quantityDelta: ciwo.quantity,
        groupKey: "".concat(ciwo.offer.get('id'), "|").concat(groupKey) || null,
        data: ciwo.cartItem.data || null,
        participant: getEntityId(ciwo.cartItem.participant) || null,
        availableSeat: null
        // no stockContingent passed here when duplicating offer?
      };
    });
    dispatch(setTicketPriceQuantity$1(cartAtomId, ticketPriceQuantities));
  };
}

function CartItem(_ref) {
  var data = _ref.data,
    createdCashCoupon = _ref.createdCashCoupon,
    appliedCouponList = _ref.appliedCouponList,
    _ref$index = _ref.index,
    index = _ref$index === void 0 ? 0 : _ref$index,
    cartItemNumber = _ref.cartItemNumber,
    quantity = _ref.quantity,
    _ref$isOffer = _ref.isOffer,
    isOffer = _ref$isOffer === void 0 ? false : _ref$isOffer,
    _ref$multiple = _ref.multiple,
    multiple = _ref$multiple === void 0 ? false : _ref$multiple,
    _ref$multipleLinkedCi = _ref.multipleLinkedCiwoList,
    multipleLinkedCiwoList = _ref$multipleLinkedCi === void 0 ? List() : _ref$multipleLinkedCi,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    isDetailOpened = _ref.isDetailOpened,
    _ref$isFromExternalPr = _ref.isFromExternalProvider,
    isFromExternalProvider = _ref$isFromExternalPr === void 0 ? false : _ref$isFromExternalPr,
    onToggleDetail = _ref.onToggleDetail,
    onParticipantClick = _ref.onParticipantClick,
    renderCouponModalButton = _ref.renderCouponModalButton;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var cartType = useCartTypeContext();
  var cartAtomId = useCartAtomIdContext();
  var cart = useAtomCart(cartAtomId);
  var updateCiwoQuantity = useUpdateCiwoQuantity(cartAtomId);
  var isDesk = cartType === SELLING_DEVICE_DESK;
  var isMinisite = cartType === SELLING_DEVICE_MINISITE;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    activeQuantityInput = _useState2[0],
    setActiveQuantityInput = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    quantityInput = _useState4[0],
    setQuantityInput = _useState4[1];
  var availableSeat = data.getIn(['availableSeatList', index]);
  useEffect(function () {
    setQuantityInput('');
    setActiveQuantityInput(false);
  }, [data.quantity]);
  var _useSelectedCartItemC = useSelectedCartItemContext(),
    selectedCartItemHashAndIndexSet = _useSelectedCartItemC.selectedCartItemHashAndIndexSet,
    setSelectedCartItems = _useSelectedCartItemC.setSelectedCartItems;
  var handleSelect = function handleSelect(event) {
    var checked = event.target.checked;
    if (checked) {
      setSelectedCartItems(function (list) {
        if (multiple) {
          return list.concat(multipleLinkedCiwoList.map(function (ciwo) {
            return {
              cartItemWithOffer: ciwo,
              index: 0
            };
          }));
        }
        return list.push({
          cartItemWithOffer: data,
          index: index
        });
      });
      return;
    }
    setSelectedCartItems(function (list) {
      if (multiple) {
        // remove from list those who are in `multipleLinkedCiwoList`
        return list.filter(function (item) {
          return !multipleLinkedCiwoList.some(function (ciwo) {
            return item.cartItemWithOffer.hashCode() === ciwo.hashCode() && item.index === index;
          });
        });
      }
      return list.filter(function (item) {
        return !(item.cartItemWithOffer.hashCode() === data.hashCode() && item.index === index);
      });
    });
  };
  var deselectCartItems = function deselectCartItems() {
    setSelectedCartItems(List());
  };
  var increment = function increment() {
    deselectCartItems();
    updateCiwoQuantity(data, 1);
  };
  var decrement = function decrement() {
    deselectCartItems();
    updateCiwoQuantity(data, -1, availableSeat);
  };
  var onClickQuantityInput = function onClickQuantityInput(event) {
    event.stopPropagation();
    event.currentTarget.select();
  };
  var onFocusQuantityInput = function onFocusQuantityInput() {
    setActiveQuantityInput(true);
    setQuantityInput((quantity === null || quantity === void 0 ? void 0 : quantity.toString()) || '');
  };
  var onChangeQuantityInput = function onChangeQuantityInput(event) {
    var target = event.target;
    var value = target.validity.valid ? target.value : quantityInput;
    setQuantityInput(value);
  };
  var onBlurQuantityInput = function onBlurQuantityInput() {
    if (typeof quantity === 'undefined' || quantityInput === quantity.toString()) {
      return;
    }
    updateCiwoQuantity(data, +quantityInput - quantity);
  };
  var appliedCoupon = appliedCouponList === null || appliedCouponList === void 0 ? void 0 : appliedCouponList.find(function (coupon) {
    var _coupon$applyingCartI, _coupon$applyingCartI2;
    return (_coupon$applyingCartI = (_coupon$applyingCartI2 = coupon.applyingCartItemList) === null || _coupon$applyingCartI2 === void 0 ? void 0 : _coupon$applyingCartI2.some(function (cartItem) {
      return getEntityId(cartItem) === getEntityId(data.get('cartItem'));
    })) !== null && _coupon$applyingCartI !== void 0 ? _coupon$applyingCartI : false;
  });
  var displayCartItemQuantityInput = (isDesk || isMinisite && (cart === null || cart === void 0 ? void 0 : cart.type) === CART_TYPE.OPTION) && quantity && quantity >= PACK_CARTITEM_LIMIT;
  var isMovableSeat = !(availableSeat !== null && availableSeat !== void 0 && availableSeat.isLocked);
  var isCheckboxVisible = isDesk && isMovableSeat;
  return /*#__PURE__*/jsxs(MpdCard, {
    className: cn('mpd-cart__CartItem__Container', {
      'mpd-cart__CartItem__Container--disabled': disabled
    }),
    children: [/*#__PURE__*/jsxs("div", {
      className: "mpd-cart__CartItem__Line",
      children: [createdCashCoupon && /*#__PURE__*/jsx("div", {
        className: "mpd-cart__CartItem__CouponBorder"
      }), isCheckboxVisible ? /*#__PURE__*/jsxs(MpdCheckbox, {
        cardWithoutShadow: true,
        id: "".concat(data.hashCode(), "-").concat(index, "-").concat(multiple ? 'multiple' : ''),
        active: false,
        checked: selectedCartItemHashAndIndexSet.has("".concat(data.hashCode(), "-").concat(index)),
        onChange: handleSelect,
        children: [/*#__PURE__*/jsx(CartItemParticipant, {
          data: data,
          cartItemNumber: cartItemNumber,
          quantity: quantity,
          multiple: multiple,
          isOffer: isOffer,
          createdCashCoupon: createdCashCoupon,
          isCheckboxVisible: isCheckboxVisible,
          onParticipantClick: onParticipantClick
        }), createdCashCoupon && /*#__PURE__*/jsx("b", {
          children: data.name
        })]
      }) : /*#__PURE__*/jsx(CartItemParticipant, {
        data: data,
        cartItemNumber: cartItemNumber,
        quantity: quantity,
        multiple: multiple,
        isOffer: isOffer,
        createdCashCoupon: createdCashCoupon,
        isCheckboxVisible: isCheckboxVisible,
        onParticipantClick: onParticipantClick
      }), /*#__PURE__*/jsx(CartItemSeatingInfos, {
        data: data,
        createdCashCoupon: createdCashCoupon,
        isOffer: isOffer,
        index: index,
        multiple: multiple,
        isMovableSeat: isMovableSeat
      }), /*#__PURE__*/jsx(CartItemPriceInfos, {
        data: data,
        createdCashCoupon: createdCashCoupon,
        isOffer: isOffer
      }), /*#__PURE__*/jsxs("div", {
        className: "mpd-cart__CartItem__Actions",
        children: [!isOffer && !isFromExternalProvider && /*#__PURE__*/jsxs("div", {
          className: "mpd-cart__CartItem__Quantity",
          children: [/*#__PURE__*/jsx("button", {
            className: "mpd-btn pr0 mpd-cart__CartItem__ActionButton",
            type: "button",
            onClick: decrement,
            title: t('cart.item.remove'),
            children: /*#__PURE__*/jsx(MpdIcon, {
              icon: "minus-stroke",
              width: "24",
              className: "mr0"
            })
          }), displayCartItemQuantityInput && /*#__PURE__*/jsx(CartItemQuantityInput, {
            value: activeQuantityInput ? quantityInput : quantity,
            onChange: onChangeQuantityInput,
            onClick: onClickQuantityInput,
            onFocus: onFocusQuantityInput,
            onBlur: onBlurQuantityInput,
            min: "0",
            max: isMinisite && (cart === null || cart === void 0 ? void 0 : cart.type) === CART_TYPE.OPTION ? MAX_QUANTITY.toString() : undefined,
            label: t('quantity')
          }), /*#__PURE__*/jsx("button", {
            className: cn('mpd-btn mpd-cart__CartItem__ActionButton', displayCartItemQuantityInput ? 'pl0' : 'pl3'),
            type: "button",
            onClick: increment,
            title: t('cart.item.add'),
            children: /*#__PURE__*/jsx(MpdIcon, {
              icon: "plus-stroke",
              width: "24"
            })
          })]
        }), multiple && /*#__PURE__*/jsx("button", {
          type: "button",
          className: "mpd-btn mpd-cart__CartItem__ActionButton",
          onClick: onToggleDetail,
          title: isDetailOpened ? t('cart.cart_item_pack.hide_detail') : t('cart.cart_item_pack.show_detail'),
          children: /*#__PURE__*/jsx(MpdIcon, {
            icon: isDetailOpened ? 'arrow-top' : 'arrow-down'
          })
        })]
      })]
    }), appliedCoupon && appliedCoupon.get('@id') && /*#__PURE__*/jsx("div", {
      className: "pr2 pb2",
      children: /*#__PURE__*/jsx(CouponApplied, {
        coupon: appliedCoupon
      })
    }), !data.buyable && cart && /*#__PURE__*/jsx(CartItemNotBuyable, {
      renderCouponModalButton: renderCouponModalButton,
      data: data,
      cart: cart
    }), /*#__PURE__*/jsx(SeatIsolatedWarning, {
      data: data,
      index: index
    }), !multiple && /*#__PURE__*/jsx(SeatTypeFoldableWarning, {
      data: data,
      index: index
    }), !multiple && /*#__PURE__*/jsx(SeatTypeObstructedViewWarning, {
      data: data,
      index: index
    })]
  });
}

function DeleteCartItemButton(_ref) {
  var cartItemWithOfferList = _ref.cartItemWithOfferList;
  var dispatch = useCartDispatch();
  var cartAtomId = useCartAtomIdContext();
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var deleteCartItemWithOfferList = function deleteCartItemWithOfferList() {
    var ticketPriceQuantities = cartItemWithOfferList.flatMap(function (ciwo) {
      // TODO move to jscomponent
      var cartItem = ciwo.cartItem,
        ticketPrice = ciwo.ticketPrice,
        quantity = ciwo.quantity;
      assertRelationIsObject(cartItem, 'ciwo.cartItem');
      assertRelationIsObject(ticketPrice, 'ciwo.ticketPrice');
      assertRelationIsNullOrObject(cartItem.stockContingent, 'ciwo.cartItem.stockContingent');
      assertRelationIsDefined(quantity, 'ciwo.quantity');
      var stockContingent = cartItem.stockContingent;
      if (ciwo.availableSeatList && ciwo.availableSeatList.size > 0) {
        assertRelationIsListOfObject(ciwo.availableSeatList, 'ciwo.availableSeatList');
        return ciwo.availableSeatList.map(function (availableSeat) {
          return {
            ticketPrice: ticketPrice,
            quantityDelta: -1,
            // remove items linked to available seats one by one
            groupKey: ciwo.groupKey || undefined,
            couponCode: ciwo.couponCode || undefined,
            data: cartItem.data || undefined,
            participant: getEntityId(cartItem.participant) || null,
            stockContingent: stockContingent || null,
            availableSeat: availableSeat.manuallyAssigned ? getEntityId(availableSeat) : null
          };
        });
      }
      return List([{
        ticketPrice: ticketPrice,
        quantityDelta: quantity * -1,
        // remove the same number of items that we have in the cartItemWithOfferList
        groupKey: ciwo.groupKey || undefined,
        couponCode: ciwo.couponCode || undefined,
        data: cartItem.data || undefined,
        participant: getEntityId(cartItem.participant) || null,
        stockContingent: stockContingent || null,
        availableSeat: null
      }]);
    });
    dispatch(setTicketPriceQuantity$1(cartAtomId, ticketPriceQuantities));
  };
  return /*#__PURE__*/jsxs("button", {
    type: "button",
    onClick: deleteCartItemWithOfferList,
    className: "mpd-btn",
    children: [/*#__PURE__*/jsx(MpdIcon, {
      icon: "trash",
      width: "18",
      height: "18"
    }), t('delete')]
  });
}

function ActionBtnBlock$1(_ref) {
  var isDesk = _ref.isDesk,
    isMinisite = _ref.isMinisite,
    eventDate = _ref.eventDate,
    ciwoList = _ref.ciwoList,
    _ref$cartIsOption = _ref.cartIsOption,
    cartIsOption = _ref$cartIsOption === void 0 ? false : _ref$cartIsOption,
    hideReplaceButton = _ref.hideReplaceButton,
    hasMovableSeats = _ref.hasMovableSeats;
  return /*#__PURE__*/jsxs("div", {
    children: [isDesk && /*#__PURE__*/jsx(AllSelect, {
      id: eventDate.get('@id'),
      ciwoList: ciwoList
    }), eventDate.isNumberedSeating && !cartIsOption && !hideReplaceButton && hasMovableSeats && /*#__PURE__*/jsx(ReplaceSeatingButton, {
      cartItemWithOffer: ciwoList.first(),
      isOffer: false
    }), isMinisite && /*#__PURE__*/jsx(DeleteCartItemButton, {
      cartItemWithOfferList: ciwoList
    })]
  });
}
function generateCiwoGroupKey(ciwo) {
  return [getEntityId(ciwo.ticketPrice), ciwo.offer ? ciwo.offer.get('id') : null, ciwo.facialValue, ciwo.buyable, ciwo.isValid,
  // ciwo.applicationId
  // ciwo.groupKey
  // ciwo.cartItem.data,
  _typeof(ciwo.cartItem) === 'object' && ciwo.cartItem !== null ? getEntityId(ciwo.cartItem.stockContingent) : null].join('|');
}
// eslint-disable-next-line react/no-multi-comp
function CartItemBlock(_ref2) {
  var _eventDate$ticketing$, _eventDate$ticketing$2;
  var createdCashCouponList = _ref2.createdCashCouponList,
    appliedCouponList = _ref2.appliedCouponList,
    ciwoList = _ref2.ciwoList,
    eventDate = _ref2.eventDate,
    _ref2$cartIsOption = _ref2.cartIsOption,
    cartIsOption = _ref2$cartIsOption === void 0 ? false : _ref2$cartIsOption,
    _ref2$isFromExternalP = _ref2.isFromExternalProvider,
    isFromExternalProvider = _ref2$isFromExternalP === void 0 ? false : _ref2$isFromExternalP,
    hasMovableSeats = _ref2.hasMovableSeats,
    eventDateAccessBlock = _ref2.eventDateAccessBlock,
    onParticipantClick = _ref2.onParticipantClick,
    renderEventDateStartDate = _ref2.renderEventDateStartDate,
    renderCouponModalButton = _ref2.renderCouponModalButton;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var startDate = eventDate.startDate,
    endDate = eventDate.endDate;
  var _useState = useState(Set()),
    _useState2 = _slicedToArray(_useState, 2),
    openedCiwoSet = _useState2[0],
    setOpenedCiwoList = _useState2[1];
  var cartType = useCartTypeContext();
  var cartAtomId = useCartAtomIdContext();
  var cart = useAtomCart(cartAtomId);
  var isDesk = cartType === SELLING_DEVICE_DESK;
  var isMinisite = cartType === SELLING_DEVICE_MINISITE;
  var ticketing = eventDate.get('ticketing');
  var getImageUrl = function getImageUrl() {
    var _ticketing$getMainIma;
    var path = (_ticketing$getMainIma = ticketing.getMainImageMedia()) === null || _ticketing$getMainIma === void 0 ? void 0 : _ticketing$getMainIma.get('path');
    return path ? buildUrl(path, 120, 120) : undefined;
  };
  var imageUrl = getImageUrl();
  var cartItemNumber = 0;
  assertRelationIsDefined(eventDate.isNumberedSeating, 'eventDate.isNumberedSeating');
  assertRelationIsObject(eventDate.ticketing, 'eventDate.ticketing');
  assertRelationIsString(eventDate.ticketing.title, 'eventDate.ticketing.title');
  assertRelationIsNullOrObject(eventDate.ticketing.venue, 'eventDate.ticketing.venue');

  // TODO this should be useless once https://app.clickup.com/t/860rwhvub is OK (aka all ciwoList should be unpacked after that)
  var unpackedCiwoList = ciwoList.reduce(function (acc, ciwo) {
    var quantity = ciwo.get('quantity');
    if (quantity > 1) {
      return acc.concat(List(Array(quantity)).keySeq().map(function (index) {
        return ciwo.set('quantity', 1).update('availableSeatList', function (availableSeatList) {
          var _availableSeatList$sl;
          return (_availableSeatList$sl = availableSeatList === null || availableSeatList === void 0 ? void 0 : availableSeatList.slice(index, index + 1)) !== null && _availableSeatList$sl !== void 0 ? _availableSeatList$sl : null;
        });
      }));
    }
    return acc.push(ciwo);
  }, List());
  var groupedCiwoList = unpackedCiwoList.groupBy(generateCiwoGroupKey).valueSeq().toArray();
  var ticketCountTrans = '';
  if (getTicketCount(ciwoList)) {
    ticketCountTrans = t('cart.total.ticket_count', {
      count: getTicketCount(ciwoList)
    });
  }
  if (getItemCount(ciwoList)) {
    if (ticketCountTrans) {
      ticketCountTrans = "".concat(ticketCountTrans, " + ").concat(t('cart.total.item_count', {
        count: getItemCount(ciwoList)
      }));
    } else {
      ticketCountTrans = t('cart.total.item_count', {
        count: getItemCount(ciwoList)
      });
    }
  }
  var hideReplaceButton = shouldHideSeatingReplacement(isMinisite, cart, ticketing);
  var dateImageProps = isMinisite ? {
    imageUrl: imageUrl,
    formattedDateAndEndDate: /*#__PURE__*/jsx(FormattedDateForStartAndEndDate, {
      startDate: startDate,
      endDate: endDate
    })
  } : {
    dateBlock: renderEventDateStartDate ? renderEventDateStartDate(startDate === null || startDate === void 0 ? void 0 : startDate.toDate(), eventDate.ticketing.timezone, eventDate.getShortId()) : null,
    formattedDateAndEndDate: null
  };
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("div", {
      className: "mb3",
      children: /*#__PURE__*/jsx(MpdEventHeader
      // eslint-disable-next-line react/jsx-props-no-spreading
      , _objectSpread2(_objectSpread2({}, dateImageProps), {}, {
        title: eventDate.ticketing.title,
        seatingName: (_eventDate$ticketing$ = (_eventDate$ticketing$2 = eventDate.ticketing.venue) === null || _eventDate$ticketing$2 === void 0 ? void 0 : _eventDate$ticketing$2.seatingName) !== null && _eventDate$ticketing$ !== void 0 ? _eventDate$ticketing$ : null,
        id: Number(ticketing.getShortId()),
        ticketCountTrans: ticketCountTrans,
        actionBtnBlock: isFromExternalProvider && !hasMovableSeats ? null : /*#__PURE__*/jsx(ActionBtnBlock$1, {
          isDesk: isDesk,
          isMinisite: isMinisite,
          eventDate: eventDate,
          ciwoList: ciwoList,
          cartIsOption: cartIsOption,
          hideReplaceButton: hideReplaceButton,
          hasMovableSeats: hasMovableSeats
        }),
        eventDateAccessBlock: isDesk ? eventDateAccessBlock : null
      }))
    }), groupedCiwoList.map(function (innerCiwoList) {
      var quantity = innerCiwoList.size;
      var firstCiwo = innerCiwoList.first();
      var createdCashCoupon = createdCashCouponList === null || createdCashCouponList === void 0 ? void 0 : createdCashCouponList.find(function (coupon) {
        var _coupon$creatingCartI, _coupon$creatingCartI2;
        return (_coupon$creatingCartI = (_coupon$creatingCartI2 = coupon.creatingCartItemList) === null || _coupon$creatingCartI2 === void 0 ? void 0 : _coupon$creatingCartI2.some(function (cartItem) {
          return getEntityId(cartItem) === (firstCiwo === null || firstCiwo === void 0 ? void 0 : firstCiwo.getIn(['cartItem', '@id']));
        })) !== null && _coupon$creatingCartI !== void 0 ? _coupon$creatingCartI : false;
      });
      if (quantity >= PACK_CARTITEM_LIMIT && !createdCashCoupon) {
        assertRelationIsDefined(firstCiwo, 'firstCiwo');
        var isDetailOpened = openedCiwoSet.has(firstCiwo);
        return /*#__PURE__*/jsxs(Fragment, {
          children: [/*#__PURE__*/jsx(CartItem, {
            quantity: quantity,
            data: firstCiwo,
            disabled: isDetailOpened,
            multiple: true,
            multipleLinkedCiwoList: innerCiwoList,
            isDetailOpened: isDetailOpened,
            isFromExternalProvider: isFromExternalProvider,
            onToggleDetail: function onToggleDetail() {
              if (isDetailOpened) {
                setOpenedCiwoList(openedCiwoSet["delete"](firstCiwo));
              } else {
                setOpenedCiwoList(openedCiwoSet.add(firstCiwo));
              }
            },
            onParticipantClick: onParticipantClick,
            renderCouponModalButton: renderCouponModalButton
          }, "".concat(firstCiwo.hashCode(), "-").concat(quantity)), /*#__PURE__*/jsx(MpdDropDown, {
            opened: isDetailOpened,
            keepOpen: true,
            animate: true,
            children: /*#__PURE__*/jsx(MpdDropDownContent, {
              children: innerCiwoList.map(function (ciwo, key) {
                cartItemNumber++;
                return /*#__PURE__*/jsx(CartItem
                // eslint-disable-next-line react/no-array-index-key
                , {
                  index: 0,
                  cartItemNumber: cartItemNumber,
                  data: ciwo,
                  appliedCouponList: appliedCouponList,
                  onParticipantClick: onParticipantClick,
                  renderCouponModalButton: renderCouponModalButton,
                  isFromExternalProvider: isFromExternalProvider
                }, "".concat(ciwo.hashCode(), "-").concat(key));
              })
            })
          })]
        });
      }
      return innerCiwoList.map(function (ciwo, key) {
        assertRelationIsDefined(ciwo, 'ciwo');
        cartItemNumber++;
        return /*#__PURE__*/jsx(CartItem
        // eslint-disable-next-line react/no-array-index-key
        , {
          index: 0,
          quantity: isMinisite && (cart === null || cart === void 0 ? void 0 : cart.type) === CART_TYPE.OPTION ? quantity : undefined,
          cartItemNumber: cartItemNumber,
          data: ciwo,
          createdCashCoupon: createdCashCoupon,
          appliedCouponList: appliedCouponList,
          isFromExternalProvider: isFromExternalProvider,
          onParticipantClick: onParticipantClick,
          renderCouponModalButton: renderCouponModalButton
        }, "".concat(ciwo.hashCode(), "-").concat(key));
      });
    })]
  });
}

function removeClusterApplications(cartAtomId, clusterId, applicationId) {
  return function (dispatch, getState) {
    var state = getState();
    var offerCluster = getAtomOfferClusterList(state, cartAtomId).find(function (innerOfferCluster) {
      return innerOfferCluster.get('clusterId') === clusterId;
    });
    if (!offerCluster) {
      return Promise.resolve();
    }
    var offerApplicationList = offerCluster.get('offerApplicationList');
    var ticketPriceQuantityListToSend = [];
    offerApplicationList.filter(function (offerApplication) {
      return applicationId === offerApplication.get('applicationId');
    }) // take only less than required applications
    .forEach(function (app) {
      var applicationTicketPriceQuantityListToSend = app.get('cartItemWithOfferList').flatMap(function (ciwo) {
        var ticketPrice = ciwo.get('ticketPrice');
        assertRelationIsObject(ticketPrice, 'ciwo.ticketPrice');
        var cartItem = ciwo.cartItem;
        assertRelationIsObject(cartItem, 'ciwo.cartItem');
        var stockContingent = cartItem.stockContingent;
        assertRelationIsNullOrObject(stockContingent, 'ciwo.cartItem.stockContingent');
        if (ciwo.availableSeatList && ciwo.availableSeatList.size > 0) {
          assertRelationIsListOfObject(ciwo.availableSeatList, 'ciwo.availableSeatList');
          return ciwo.availableSeatList.map(function (availableSeat) {
            return {
              ticketPrice: ticketPrice,
              groupKey: ciwo.get('groupKey') || undefined,
              couponCode: ciwo.get('couponCode') || undefined,
              quantityDelta: -1,
              data: ciwo.getIn(['cartItem', 'data']),
              participant: getEntityId(cartItem.participant),
              availableSeat: availableSeat.manuallyAssigned ? getEntityId(availableSeat) : null,
              stockContingent: stockContingent
            };
          });
        }
        var ciwoQty = ciwo.get('quantity');
        assertRelationIsDefined(ciwoQty, "ciwo.get('quantity')");
        return List([{
          ticketPrice: ticketPrice,
          groupKey: ciwo.get('groupKey') || undefined,
          couponCode: ciwo.get('couponCode') || undefined,
          quantityDelta: -ciwoQty,
          data: ciwo.getIn(['cartItem', 'data']),
          participant: getEntityId(cartItem.participant),
          availableSeat: null,
          stockContingent: stockContingent
        }]);
      }).toArray();
      ticketPriceQuantityListToSend = ticketPriceQuantityListToSend.concat(applicationTicketPriceQuantityListToSend);
    });
    return dispatch(setTicketPriceQuantity$1(cartAtomId, ticketPriceQuantityListToSend));
  };
}

var isActionObject = function isActionObject(action) {
  return !('get' in action) || typeof action.get !== 'function';
};

// copied from js-component
function isTicketPricePickerAction(action) {
  var _action$get, _action$ticketPriceLi;
  var isImmutable = !isActionObject(action);
  var type = isImmutable ? action.get('type') : action.type;
  var hasTicketPriceList = isImmutable ? ((_action$get = action.get('ticketPriceList')) === null || _action$get === void 0 ? void 0 : _action$get.size) > 0 : ((_action$ticketPriceLi = action.ticketPriceList) === null || _action$ticketPriceLi === void 0 ? void 0 : _action$ticketPriceLi.length) > 0;
  return type === 'ticket_price_picker' && hasTicketPriceList;
}
function filterTicketPricepickerForActionList(actionList) {
  // @ts-expect-error -- Array and List filter method are compatible in this case
  return actionList.filter(isTicketPricePickerAction);
}
function getTicketPriceQuantityListToSend(newSelectedTicketPriceIdList, groupKey, cartItemData, participant) {
  return newSelectedTicketPriceIdList.map(function (ticketPriceId) {
    return {
      ticketPrice: new TicketPrice({
        '@id': ticketPriceId,
        '@type': 'TicketPrice'
      }),
      quantityDelta: 1,
      groupKey: groupKey,
      data: cartItemData,
      participant: participant,
      availableSeat: null
    };
  });
}
function EditSubscriptionApplicationButtonWithModal(_ref) {
  var _offerRule$message;
  var applicationId = _ref.applicationId,
    cartItemWithOfferList = _ref.cartItemWithOfferList,
    isFront = _ref.isFront,
    ticketingSdk = _ref.ticketingSdk,
    sellingDeviceId = _ref.sellingDeviceId,
    canSellOnHoldOrScheduledEventDate = _ref.canSellOnHoldOrScheduledEventDate;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var dispatch = useCartDispatch();
  var cartAtomId = useCartAtomIdContext();
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isTicketPricePickerModalOpen = _useState2[0],
    setIsTicketPricePickerModalOpen = _useState2[1];

  // @ts-expect-error -- need typing for `getIn`
  var offerRule = new OfferRule(cartItemWithOfferList.getIn([0, 'offer']));
  offerRule = offerRule.set('message', fromJS(offerRule.message));
  if (!offerRule) {
    return null;
  }
  var actionList = filterTicketPricepickerForActionList(
  // @ts-expect-error -- probable issue with type of "message" that is string
  ((_offerRule$message = offerRule.message) === null || _offerRule$message === void 0 ? void 0 : _offerRule$message.get('actionList')) || []);
  if (!actionList || actionList.length === 0) {
    return null;
  }

  // @ts-expect-error -- need typing for `getIn`
  var clusterId = cartItemWithOfferList.getIn([0, 'clusterId']);
  function onConfirm(newSelectedTicketPriceIdList, groupKeyList) {
    if (clusterId) {
      dispatch(removeClusterApplications(cartAtomId, clusterId, applicationId));
    }
    if (groupKeyList.length > 1) {
      throw new Error('More than one groupKey found. This should not happen in "edit" mode');
    } else if (groupKeyList.length === 0) {
      throw new Error('No groupKey found. This should not happen in "edit" mode');
    }
    var groupKey = groupKeyList[0];
    var firstCartItemWithOffer = cartItemWithOfferList.first();
    assertRelationIsObject(firstCartItemWithOffer);
    var cartItem = firstCartItemWithOffer.get('cartItem');
    assertRelationIsObject(cartItem);
    var ticketPriceQuantityListToSend = getTicketPriceQuantityListToSend(newSelectedTicketPriceIdList, groupKey,
    // @ts-expect-error -- need typing for `getIn`
    cartItemWithOfferList.getIn([0, 'cartItem', 'data']), getEntityId(cartItem.get('participant'))
    // no stockContingent passed here when modifying subscription applications?
    );
    dispatch(setTicketPriceQuantity$1(cartAtomId, ticketPriceQuantityListToSend)); // call API

    setIsTicketPricePickerModalOpen(false);
  }
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsxs("button", {
      type: "button",
      className: "mpd-btn",
      onClick: function onClick() {
        return setIsTicketPricePickerModalOpen(true);
      },
      onKeyPress: function onKeyPress() {
        return setIsTicketPricePickerModalOpen(true);
      },
      children: [/*#__PURE__*/jsx(MpdIcon, {
        icon: "pen",
        height: "18",
        width: "18"
      }), t('edit')]
    }), isTicketPricePickerModalOpen && createModalPortal(/*#__PURE__*/jsx(OfferPicker, {
      isEdition: true,
      onCancel: function onCancel() {
        return setIsTicketPricePickerModalOpen(false);
      },
      offerRule: offerRule,
      ticketPriceRepository: ticketingSdk.getRepository('ticketPrice'),
      sellingDeviceId: sellingDeviceId,
      isFront: isFront
      // @ts-expect-error js-component does not handle new `Iri<'TicketPrice'>` type for now
      // eslint-disable-next-line react/jsx-no-bind
      ,
      onConfirm: onConfirm,
      defaultSelectedTicketPriceIdList: cartItemWithOfferList.reduce(function (carry, ciwo) {
        // @ts-expect-error -- need typing for `getIn`
        var ticketPriceId = ciwo.getIn(['ticketPrice', '@id']);

        // @ts-expect-error -- need typing for `get`
        var nbItems = ciwo.get('quantity');
        var currentTpQtts = List(Array(nbItems).fill(ticketPriceId));
        return carry.concat(currentTpQtts);
      }, List()).toArray(),
      canSellOnHoldOrScheduledEventDate: canSellOnHoldOrScheduledEventDate
    }))]
  });
}

function ActionBtnBlock(_ref) {
  var isDesk = _ref.isDesk,
    isMinisite = _ref.isMinisite,
    applicationId = _ref.applicationId,
    ciwoList = _ref.ciwoList,
    sellingDeviceId = _ref.sellingDeviceId,
    ticketingSdk = _ref.ticketingSdk,
    canSellOnHoldOrScheduledEventDate = _ref.canSellOnHoldOrScheduledEventDate,
    appliedCouponList = _ref.appliedCouponList;
  var cartAtomId = useCartAtomIdContext();
  var duplicateOffer = useDuplicateOffer(cartAtomId);
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var currentCartItemWithOffer = ciwoList.first();
  var isEditable = appliedCouponList && !appliedCouponList.some(function (coupon) {
    var _currentCartItemWithO;
    assertRelationIsNullOrObject(currentCartItemWithOffer === null || currentCartItemWithOffer === void 0 ? void 0 : currentCartItemWithOffer.cartItem, 'currentCartItemWithOffer?.cartItem');
    return (currentCartItemWithOffer === null || currentCartItemWithOffer === void 0 || (_currentCartItemWithO = currentCartItemWithOffer.cartItem) === null || _currentCartItemWithO === void 0 ? void 0 : _currentCartItemWithO.couponCode) === coupon.code;
  });
  return /*#__PURE__*/jsxs("div", {
    children: [isDesk && /*#__PURE__*/jsx(AllSelect, {
      id: applicationId,
      ciwoList: ciwoList,
      isOffer: true
    }), isEditable && /*#__PURE__*/jsx(EditSubscriptionApplicationButtonWithModal, {
      applicationId: applicationId,
      cartItemWithOfferList: ciwoList,
      isFront: isMinisite,
      sellingDeviceId: sellingDeviceId,
      ticketingSdk: ticketingSdk,
      canSellOnHoldOrScheduledEventDate: canSellOnHoldOrScheduledEventDate
    }), /*#__PURE__*/jsxs("button", {
      type: "button",
      onClick: function onClick() {
        return duplicateOffer(ciwoList);
      },
      className: "mpd-btn",
      children: [/*#__PURE__*/jsx(MpdIcon, {
        icon: "duplicate",
        width: "18",
        height: "18"
      }), t('duplicate')]
    }), isMinisite && /*#__PURE__*/jsx(DeleteCartItemButton, {
      cartItemWithOfferList: ciwoList
    })]
  });
}
// eslint-disable-next-line react/no-multi-comp
function OfferBlock(_ref2) {
  var _offer$get, _offer$get2;
  var createdCoupon = _ref2.createdCoupon,
    applicationId = _ref2.applicationId,
    offer = _ref2.offer,
    ciwoList = _ref2.ciwoList,
    ticketingSdk = _ref2.ticketingSdk,
    sellingDeviceId = _ref2.sellingDeviceId,
    appliedCouponList = _ref2.appliedCouponList,
    onParticipantClick = _ref2.onParticipantClick,
    canSellOnHoldOrScheduledEventDate = _ref2.canSellOnHoldOrScheduledEventDate;
  var cartType = useCartTypeContext();
  var cartAtomId = useCartAtomIdContext();
  var cart = useAtomCart(cartAtomId);
  var _useTranslation2 = useTranslation(),
    t = _useTranslation2.t,
    i18n = _useTranslation2.i18n;
  // @ts-expect-error -- need offer type
  var colorOffer = (_offer$get = offer.get('exchangeData')) === null || _offer$get === void 0 ? void 0 : _offer$get.color;
  // @ts-expect-error -- need offer type
  var hideIndividualPrice = (_offer$get2 = offer.get('exchangeData')) === null || _offer$get2 === void 0 ? void 0 : _offer$get2.hideIndividualPrice;
  var blockCount = getTicketCount(ciwoList);
  var blockCountKey = 'cart.block.tickets_label';
  if (!blockCount) {
    blockCount = getItemCount(ciwoList);
    blockCountKey = 'cart.block.items_label';
  }
  var cartItemNumber = 1;
  var isDesk = cartType === SELLING_DEVICE_DESK;
  var isMinisite = cartType === SELLING_DEVICE_MINISITE;
  assertRelationIsString(cart === null || cart === void 0 ? void 0 : cart.currency, 'cart.currency');
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("div", {
      className: "mb3",
      children: /*#__PURE__*/jsx(MpdOfferHeader
      /* @ts-expect-error -- need offer type */, {
        title: t('offer.title_with_name', {
          name: offer.get('name')
        }),
        ticketCount: blockCount,
        ticketCountTrans: t(blockCountKey, {
          count: blockCount
        }),
        color: colorOffer,
        price: formatPrice(getCartItemWithOfferFacialValue(ciwoList), cart.currency, getLocale(i18n.language)),
        hideIndividualPrice: hideIndividualPrice,
        actionBtnBlock: /*#__PURE__*/jsx(ActionBtnBlock, {
          isDesk: isDesk,
          isMinisite: isMinisite,
          applicationId: applicationId,
          ciwoList: ciwoList,
          sellingDeviceId: sellingDeviceId,
          ticketingSdk: ticketingSdk,
          canSellOnHoldOrScheduledEventDate: canSellOnHoldOrScheduledEventDate,
          appliedCouponList: appliedCouponList
        })
      })
    }), createdCoupon && /*#__PURE__*/jsx("div", {
      className: "mt2",
      children: /*#__PURE__*/jsx(CouponOfferStatusRow, {
        coupon: createdCoupon
      })
    }), ciwoList.map(function (ciwo) {
      var quantity = ciwo.get('quantity');
      var iterator = List(Array(quantity)).keySeq();
      var localItemNumber = cartItemNumber;
      cartItemNumber += quantity;
      return iterator.toArray().map(function (key) {
        return /*#__PURE__*/jsx(CartItem, {
          index: key,
          cartItemNumber: localItemNumber + key,
          data: ciwo,
          isOffer: true,
          appliedCouponList: appliedCouponList,
          onParticipantClick: onParticipantClick
        }, "".concat(ciwo.hashCode(), "-").concat(key));
      });
    })]
  });
}

function CartItemsList(_ref) {
  var _getCartItemWithOffer, _cart$createdCouponLi, _cart$appliedCouponLi;
  var _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? {
      type: SELLING_DEVICE_DESK,
      primaryColor: $primaryBlue
    } : _ref$theme,
    ticketingSdk = _ref.ticketingSdk,
    sellingDeviceId = _ref.sellingDeviceId,
    renderEventDateAccess = _ref.renderEventDateAccess,
    renderEventDateStartDate = _ref.renderEventDateStartDate,
    onParticipantClick = _ref.onParticipantClick,
    canSellOnHoldOrScheduledEventDate = _ref.canSellOnHoldOrScheduledEventDate,
    renderCouponModalButton = _ref.renderCouponModalButton;
  var cartAtomId = useCartAtomIdContext();
  var cart = useAtomCart(cartAtomId);
  var _useCartViewContext = useCartViewContext(),
    type = _useCartViewContext.type;
  var offerApplicationList = useMemo(function () {
    return cart ? getOfferApplicationList(cart) : null;
  }, [cart]);
  var noOfferCartItemWithOfferList = useMemo(function () {
    return cart ? getNoOfferCartItemWithOfferList(cart) : null;
  }, [cart]);
  if (!(cart !== null && cart !== void 0 && cart.cartItemWithOfferList)) {
    return null;
  }
  assertRelationIsNullOrListOfObject(cart.cartItemWithOfferList, 'cart.cartItemWithOfferList');
  var eventDateAndCiwoList = (_getCartItemWithOffer = getCartItemWithOfferGroupedByEventDate(type === offerType ? noOfferCartItemWithOfferList : cart.cartItemWithOfferList)) === null || _getCartItemWithOffer === void 0 ? void 0 : _getCartItemWithOffer.toList();
  var style = {
    '--primary-color': theme.primaryColor
  };
  var createdCouponList = (_cart$createdCouponLi = cart.createdCouponList) !== null && _cart$createdCouponLi !== void 0 ? _cart$createdCouponLi : null;
  var appliedCouponList = (_cart$appliedCouponLi = cart.appliedCouponList) !== null && _cart$appliedCouponLi !== void 0 ? _cart$appliedCouponLi : null;
  assertRelationIsNullOrListOfObject(createdCouponList, 'createdCouponList');
  assertRelationIsNullOrListOfObject(appliedCouponList, 'appliedCouponList');
  var sellingDevice = cart.sellingDevice,
    hasMovableSeats = cart.hasMovableSeats;
  assertRelationIsObject(sellingDevice, 'sellingDevice');
  assertRelationIsDefined(hasMovableSeats, 'hasMovableSeats');
  var isFromExternalProvider = sellingDevice.isExternalProvider;
  return /*#__PURE__*/jsx(CartTypeContext.Provider, {
    value: theme.type,
    children: /*#__PURE__*/jsxs("div", {
      style: style,
      className: cn('cartList', _defineProperty({}, "cartList--".concat(theme.type), theme.type)),
      children: [type === offerType && (offerApplicationList === null || offerApplicationList === void 0 ? void 0 : offerApplicationList.map(function (offerApplication) {
        return /*#__PURE__*/jsx(OfferBlock, {
          createdCoupon: createdCouponList === null || createdCouponList === void 0 ? void 0 : createdCouponList.find(function (coupon) {
            var _coupon$creatingOffer;
            return ((_coupon$creatingOffer = coupon.creatingOfferRule) === null || _coupon$creatingOffer === void 0 ? void 0 : _coupon$creatingOffer.get('@id')) === offerApplication.getIn(['offer', '@id']);
          }),
          appliedCouponList: appliedCouponList,
          ticketingSdk: ticketingSdk,
          sellingDeviceId: sellingDeviceId,
          applicationId: offerApplication.get('applicationId'),
          offer: offerApplication.get('offer'),
          ciwoList: offerApplication.get('cartItemWithOfferList'),
          onParticipantClick: onParticipantClick,
          canSellOnHoldOrScheduledEventDate: canSellOnHoldOrScheduledEventDate
        }, offerApplication.get('applicationId'));
      })), eventDateAndCiwoList === null || eventDateAndCiwoList === void 0 ? void 0 : eventDateAndCiwoList.map(function (eventDateAndCiwo) {
        return /*#__PURE__*/jsx(CartItemBlock, {
          createdCashCouponList: createdCouponList === null || createdCouponList === void 0 ? void 0 : createdCouponList.filter(function (coupon) {
            return coupon.usage === COUPON_USAGE.CASH && eventDateAndCiwo.get('cartItemWithOfferList').some(function (ciwo) {
              var _coupon$creatingCartI;
              var firstCreatingCartItem = (_coupon$creatingCartI = coupon.creatingCartItemList) === null || _coupon$creatingCartI === void 0 ? void 0 : _coupon$creatingCartI.first();
              if (!firstCreatingCartItem) {
                return false;
              }
              return ciwo.getIn(['cartItem', '@id']) === getEntityId(firstCreatingCartItem);
            });
          }),
          appliedCouponList: appliedCouponList,
          eventDate: eventDateAndCiwo.get('eventDate'),
          ciwoList: eventDateAndCiwo.get('cartItemWithOfferList'),
          cartIsOption: cart.type === CART_TYPE.OPTION,
          isFromExternalProvider: isFromExternalProvider,
          hasMovableSeats: hasMovableSeats,
          eventDateAccessBlock: renderEventDateAccess === null || renderEventDateAccess === void 0 ? void 0 : renderEventDateAccess(eventDateAndCiwo.get('eventDate')),
          renderEventDateStartDate: renderEventDateStartDate,
          onParticipantClick: onParticipantClick,
          renderCouponModalButton: renderCouponModalButton
        }, eventDateAndCiwo.getIn(['eventDate', '@id']));
      })]
    })
  });
}

function EmptyCart(_ref) {
  var callbackButton = _ref.callbackButton;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/jsx("div", {
    className: "flex-center",
    children: /*#__PURE__*/jsxs(MpdCard, {
      className: "empty-cart",
      children: [/*#__PURE__*/jsx("div", {
        className: "empty-cart__image",
        children: /*#__PURE__*/jsx("img", {
          src: buildUrl('20XX/1/1/white-hands-cart.png', null, null, {
            allowwebp: 1
          }),
          loading: "lazy",
          alt: "hands",
          width: "100%"
        })
      }), /*#__PURE__*/jsxs("div", {
        className: "empty-cart__content mpd-color-black",
        children: [/*#__PURE__*/jsxs("h1", {
          className: "pb4",
          children: [t('cart.empty_cart_beginnings_domjuan_quote'), /*#__PURE__*/jsx("span", {
            className: "mini mpd-color-grey",
            children: t('cart.empty_cart_domjuan_moliere')
          })]
        }), /*#__PURE__*/jsx("p", {
          className: "mb1",
          children: t('cart.your_empty_cart')
        }), /*#__PURE__*/jsx("p", {
          className: "m0",
          children: t('cart.empty_cart_no_order')
        }), callbackButton && /*#__PURE__*/jsx("div", {
          className: "empty-cart__button",
          children: callbackButton
        })]
      })]
    })
  });
}

/**
 * Expose all providers useful for cart components
 */
function CartProvider(_ref) {
  var children = _ref.children,
    cartAtomId = _ref.cartAtomId;
  if (!cartAtomId) {
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return /*#__PURE__*/jsx(Fragment, {
      children: children
    });
  }
  return /*#__PURE__*/jsx(CartAtomIdProvider, {
    cartAtomId: cartAtomId,
    children: /*#__PURE__*/jsx(SelectedCartItemProvider, {
      cartAtomId: cartAtomId,
      children: /*#__PURE__*/jsx(CartViewProvider, {
        children: /*#__PURE__*/jsx(CartViewPlanProvider, {
          children: children
        })
      })
    })
  });
}

var SET_SELLING_DEVICE = '@@mapado-booking/SET_SELLING_DEVICE';
var SET_BOOKING_ORIGIN_TYPE_ENV = '@@mapado-booking/SET_BOOKING_ORIGIN_TYPE_ENV';

function setBookingOriginTypeEnv(originTypeEnv) {
  return {
    type: SET_BOOKING_ORIGIN_TYPE_ENV,
    originTypeEnv: originTypeEnv
  };
}

var ONLINE_ORIGIN_TYPE_LIST = ['MINISITE'];
function getCartKey(originType) {
  var _window;
  return "currentCartId.".concat(originType, ".").concat((_window = window) === null || _window === void 0 || (_window = _window.location) === null || _window === void 0 ? void 0 : _window.hostname);
}
function saveCart(cart, originType) {
  return function (dispatch) {
    dispatch({
      type: SET_HAS_CART_ID_IN_STORAGE,
      hasCartIdInStorage: true,
      // saving cart in storage is only used for shopping cart
      cartAtomId: SHOPPING_CART
    });
    var cartShortId = typeof cart === 'string' ? getShortId(cart) : cart.getShortId();
    return Promise.all([localforage.setItem('cart.save.date', moment$1().toISOString()), localforage.setItem(getCartKey(originType), cartShortId)]);
  };
}
function deleteCart(cartAtomId, originType) {
  return function (dispatch) {
    if (cartAtomId !== SHOPPING_CART) {
      return Promise.resolve();
    }
    dispatch({
      type: SET_HAS_CART_ID_IN_STORAGE,
      cartAtomId: cartAtomId,
      hasCartIdInStorage: false
    });
    return Promise.all([localforage.removeItem('cart.save.date'), localforage.removeItem(getCartKey(originType))]);
  };
}
function checkExpiration(originTypeEnv, dispatch) {
  var expireDate = moment$1().startOf('day');
  return localforage.getItem('cart.save.date').then(function (isoDate) {
    if (isoDate) {
      if (moment$1(isoDate) < expireDate) {
        dispatch(deleteCart(SHOPPING_CART, originTypeEnv));
        return Promise.resolve();
      }
    }
    return Promise.resolve();
  })["catch"](function () {
    return Promise.resolve();
  });
}

/**
 * load cart by it's atomId (either shopping cart or a specific cart IRI)
 * When the cart is loaded, it will change the current cart id to the given cartAtomId
 * @param cartAtomId the cart atom to load. It can be either the shopping cart or a cart IRI.
 * @param controller optional AbortController to cancel the request if needed
 * @returns
 */
function loadCart(ticketingSdk, cartAtomId, controller) {
  return function (dispatch, getState) {
    var state = getState();
    var originTypeEnv = getOriginTypeEnv(state);
    var sellingDevice = getSellingDevice(state);
    if (!sellingDevice) {
      // eslint-disable-next-line no-console
      console.warn('Unable to load cart if there is no selling device. Your user probably does not have any selling devices available.');
      return Promise.resolve();
    }
    var originType = sellingDevice.originType;
    var key = getCartKey(originTypeEnv);
    if (originTypeEnv !== originType) {
      throw new Error("Bad selling device of type ".concat(originType, " found."));
    }
    return checkExpiration(originTypeEnv, dispatch).then(function () {
      return localforage.getItem(key);
    }).then(function (storageCartId) {
      var cartIdToLoad = cartAtomId && cartAtomId !== SHOPPING_CART ? cartAtomId : storageCartId;
      if (!cartIdToLoad) {
        return dispatch({
          type: SET_HAS_CART_ID_IN_STORAGE,
          cartAtomId: cartAtomId,
          hasCartIdInStorage: false
        });
      }
      if (cartAtomId !== SHOPPING_CART) {
        dispatch({
          type: SET_CART_ID,
          cartAtomId: cartAtomId
        });
      } else {
        dispatch({
          type: SET_HAS_CART_ID_IN_STORAGE,
          cartAtomId: cartAtomId,
          hasCartIdInStorage: true
        });
      }
      dispatch({
        type: FETCH_CART_STARTED,
        cartAtomId: cartAtomId
      });
      return ticketingSdk.getRepository('cart').find(cartIdToLoad, CART_WITH_ALL_FIELDS, undefined, undefined, controller !== null && controller !== void 0 && controller.signal ? {
        signal: controller.signal
      } : undefined).then(function (cart) {
        if (cart.orderList && cart.orderList.some(function (order) {
          if (_typeof(order) === 'object' && order !== null) {
            return order.status === 'payed' || order.status === 'refunded_totally';
          }
          return false;
        })) {
          dispatch({
            type: FETCH_CART_ENDED,
            cartAtomId: cartAtomId
          });

          // the cart has already been payed, do not use it anymore
          return dispatch(deleteCart(cartAtomId, originType));
        }
        if (
        // @ts-expect-error just test the runtime
        ONLINE_ORIGIN_TYPE_LIST.indexOf(originTypeEnv) !== -1 &&
        // @ts-expect-error just test the runtime
        ONLINE_ORIGIN_TYPE_LIST.indexOf(cart.originType) === -1) {
          throw new Error("Cannot load Cart with originType ".concat(cart.originType, " on SellingDevice with originType ").concat(originType, "."));
        }
        return dispatch(receiveCart(cart, cartAtomId));
      })["catch"](function (err) {
        // eslint-disable-next-line no-console
        console.error(err);
        dispatch({
          type: FETCH_CART_ENDED,
          cartAtomId: cartAtomId
        });
        return dispatch(deleteCart(cartAtomId, originType));
      });
    });
  };
}

/**
 * Used to change the shopping cart to the given cart atom id.
 * If the cartAtomId is not already loaded, it will be loaded first.
 * @param cartAtomId the cart atom to set as shopping cart. It can be either the shopping cart or a cart IRI.
 */
function setCartAsShoppingCart(ticketingSdk, cartAtomId) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(dispatch, getState) {
      var state;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            state = getState();
            if (cartAtomId in state.booking) {
              _context.n = 1;
              break;
            }
            _context.n = 1;
            return dispatch(loadCart(ticketingSdk, cartAtomId));
          case 1:
            return _context.a(2, dispatch({
              type: SET_CART_AS_SHOPPING_CART,
              cartAtomId: cartAtomId
            }));
        }
      }, _callee);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
}

function useReplaceTicketPriceListWithGroupKey() {
  var cartDispatch = useCartDispatch();
  return function () {
    return cartDispatch(replaceTicketPriceListWithGroupKey.apply(void 0, arguments));
  };
}
function useIncrementTicketPriceListWithGroupKeyList() {
  var cartDispatch = useCartDispatch();
  return function () {
    return cartDispatch(incrementTicketPriceListWithGroupKeyList.apply(void 0, arguments));
  };
}
function useDecrementTicketPriceListWithGroupKey() {
  var cartDispatch = useCartDispatch();
  return function () {
    return cartDispatch(decrementTicketPriceListWithGroupKey.apply(void 0, arguments));
  };
}
function useChangeTicketPriceQuantity() {
  var cartDispatch = useCartDispatch();
  return function () {
    return cartDispatch(changeTicketPriceQuantity.apply(void 0, arguments));
  };
}
function useUpdateExistingTicketPriceQuantity() {
  var cartDispatch = useCartDispatch();
  return function () {
    return cartDispatch(updateExistingTicketPriceQuantity.apply(void 0, arguments));
  };
}
function useDeleteSelectedCartItemWithOfferList() {
  var cartDispatch = useCartDispatch();
  return function () {
    return cartDispatch(deleteSelectedCartItemWithOfferList.apply(void 0, arguments));
  };
}
function useChangeAvailableSeatTicketPrice() {
  var cartDispatch = useCartDispatch();
  return function () {
    return cartDispatch(changeAvailableSeatTicketPrice.apply(void 0, arguments));
  };
}

/**
 * @deprecated `useSetTicketPriceQuantity` should not be imported in projects or libs anymore
 * please use a dedicated hook instead (eg. useChangeTicketPriceQuantity, useIncrementTicketPriceListWithGroupKeyList, useChangeAvailableSeatTicketPrice, etc.)
 */
function useSetTicketPriceQuantity() {
  var cartDispatch = useCartDispatch();
  return function () {
    return cartDispatch(setTicketPriceQuantity$1.apply(void 0, arguments));
  };
}
function useLockSeatsForEventDate() {
  var cartDispatch = useCartDispatch();
  return function () {
    return cartDispatch(lockSeatsForEventDate.apply(void 0, arguments));
  };
}
function useRemoveCartItemFromCurrentCart() {
  var cartDispatch = useCartDispatch();
  return function () {
    return cartDispatch(removeCartItemFromCurrentCart.apply(void 0, arguments));
  };
}
function useConvertCartToReservationOrOption() {
  var cartDispatch = useCartDispatch();
  return function () {
    return cartDispatch(convertCartToReservationOrOption.apply(void 0, arguments));
  };
}
function useActionHook(fn) {
  var cartDispatch = useCartDispatch();

  // @ts-expect-error probable issue with function as callback, but do work in practice
  return useMemo(function () {
    return function () {
      return cartDispatch(fn.apply(void 0, arguments));
    };
  }, [cartDispatch, fn]);
}
var useLoadCart = function useLoadCart() {
  return useActionHook(loadCart);
};
var useSetCartAsShoppingCart = function useSetCartAsShoppingCart() {
  return useActionHook(setCartAsShoppingCart);
};
var useDiscardCart = function useDiscardCart() {
  return useActionHook(discardCart);
};
var useDiscardOrDeleteCart = function useDiscardOrDeleteCart() {
  return useActionHook(discardOrDeleteCart);
};
var useFreeCartId = function useFreeCartId() {
  return useActionHook(freeCartId);
};
var useSetBookingOriginTypeEnv = function useSetBookingOriginTypeEnv() {
  return useActionHook(setBookingOriginTypeEnv);
};
var useUpdateComment = function useUpdateComment() {
  return useActionHook(updateComment);
};
var useUpdateCustomers = function useUpdateCustomers() {
  return useActionHook(updateCustomers);
};
var useUpdateOwner = function useUpdateOwner() {
  return useActionHook(updateOwner);
};
var useSetSellingDevice = function useSetSellingDevice() {
  return useActionHook(function (sellingDevice) {
    return {
      type: SET_SELLING_DEVICE,
      sellingDevice: sellingDevice
    };
  });
};
var useDismissCartBookingError = function useDismissCartBookingError() {
  return useActionHook(dismissCartBookingError);
};

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function (d, b) {
  extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
  };
  return extendStatics(d, b);
};
function __extends(d, b) {
  extendStatics(d, b);
  function __() {
    this.constructor = d;
  }
  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

/** PURE_IMPORTS_START  PURE_IMPORTS_END */
function isFunction(x) {
  return typeof x === 'function';
}

/** PURE_IMPORTS_START  PURE_IMPORTS_END */
var _enable_super_gross_mode_that_will_cause_bad_things = false;
var config = {
  set useDeprecatedSynchronousErrorHandling(value) {
    if (value) {
      var error = /*@__PURE__*/new Error();
      /*@__PURE__*/
      console.warn('DEPRECATED! RxJS was set to use deprecated synchronous error handling behavior by code at: \n' + error.stack);
    }
    _enable_super_gross_mode_that_will_cause_bad_things = value;
  },
  get useDeprecatedSynchronousErrorHandling() {
    return _enable_super_gross_mode_that_will_cause_bad_things;
  }
};

/** PURE_IMPORTS_START  PURE_IMPORTS_END */
function hostReportError(err) {
  setTimeout(function () {
    throw err;
  }, 0);
}

/** PURE_IMPORTS_START _config,_util_hostReportError PURE_IMPORTS_END */
var empty = {
  closed: true,
  next: function (value) {},
  error: function (err) {
    if (config.useDeprecatedSynchronousErrorHandling) {
      throw err;
    } else {
      hostReportError(err);
    }
  },
  complete: function () {}
};

/** PURE_IMPORTS_START  PURE_IMPORTS_END */
var isArray = /*@__PURE__*/function () {
  return Array.isArray || function (x) {
    return x && typeof x.length === 'number';
  };
}();

/** PURE_IMPORTS_START  PURE_IMPORTS_END */
function isObject(x) {
  return x !== null && typeof x === 'object';
}

/** PURE_IMPORTS_START  PURE_IMPORTS_END */
var UnsubscriptionErrorImpl = /*@__PURE__*/function () {
  function UnsubscriptionErrorImpl(errors) {
    Error.call(this);
    this.message = errors ? errors.length + " errors occurred during unsubscription:\n" + errors.map(function (err, i) {
      return i + 1 + ") " + err.toString();
    }).join('\n  ') : '';
    this.name = 'UnsubscriptionError';
    this.errors = errors;
    return this;
  }
  UnsubscriptionErrorImpl.prototype = /*@__PURE__*/Object.create(Error.prototype);
  return UnsubscriptionErrorImpl;
}();
var UnsubscriptionError = UnsubscriptionErrorImpl;

/** PURE_IMPORTS_START _util_isArray,_util_isObject,_util_isFunction,_util_UnsubscriptionError PURE_IMPORTS_END */
var Subscription = /*@__PURE__*/function () {
  function Subscription(unsubscribe) {
    this.closed = false;
    this._parentOrParents = null;
    this._subscriptions = null;
    if (unsubscribe) {
      this._ctorUnsubscribe = true;
      this._unsubscribe = unsubscribe;
    }
  }
  Subscription.prototype.unsubscribe = function () {
    var errors;
    if (this.closed) {
      return;
    }
    var _a = this,
      _parentOrParents = _a._parentOrParents,
      _ctorUnsubscribe = _a._ctorUnsubscribe,
      _unsubscribe = _a._unsubscribe,
      _subscriptions = _a._subscriptions;
    this.closed = true;
    this._parentOrParents = null;
    this._subscriptions = null;
    if (_parentOrParents instanceof Subscription) {
      _parentOrParents.remove(this);
    } else if (_parentOrParents !== null) {
      for (var index = 0; index < _parentOrParents.length; ++index) {
        var parent_1 = _parentOrParents[index];
        parent_1.remove(this);
      }
    }
    if (isFunction(_unsubscribe)) {
      if (_ctorUnsubscribe) {
        this._unsubscribe = undefined;
      }
      try {
        _unsubscribe.call(this);
      } catch (e) {
        errors = e instanceof UnsubscriptionError ? flattenUnsubscriptionErrors(e.errors) : [e];
      }
    }
    if (isArray(_subscriptions)) {
      var index = -1;
      var len = _subscriptions.length;
      while (++index < len) {
        var sub = _subscriptions[index];
        if (isObject(sub)) {
          try {
            sub.unsubscribe();
          } catch (e) {
            errors = errors || [];
            if (e instanceof UnsubscriptionError) {
              errors = errors.concat(flattenUnsubscriptionErrors(e.errors));
            } else {
              errors.push(e);
            }
          }
        }
      }
    }
    if (errors) {
      throw new UnsubscriptionError(errors);
    }
  };
  Subscription.prototype.add = function (teardown) {
    var subscription = teardown;
    if (!teardown) {
      return Subscription.EMPTY;
    }
    switch (typeof teardown) {
      case 'function':
        subscription = new Subscription(teardown);
      case 'object':
        if (subscription === this || subscription.closed || typeof subscription.unsubscribe !== 'function') {
          return subscription;
        } else if (this.closed) {
          subscription.unsubscribe();
          return subscription;
        } else if (!(subscription instanceof Subscription)) {
          var tmp = subscription;
          subscription = new Subscription();
          subscription._subscriptions = [tmp];
        }
        break;
      default:
        {
          throw new Error('unrecognized teardown ' + teardown + ' added to Subscription.');
        }
    }
    var _parentOrParents = subscription._parentOrParents;
    if (_parentOrParents === null) {
      subscription._parentOrParents = this;
    } else if (_parentOrParents instanceof Subscription) {
      if (_parentOrParents === this) {
        return subscription;
      }
      subscription._parentOrParents = [_parentOrParents, this];
    } else if (_parentOrParents.indexOf(this) === -1) {
      _parentOrParents.push(this);
    } else {
      return subscription;
    }
    var subscriptions = this._subscriptions;
    if (subscriptions === null) {
      this._subscriptions = [subscription];
    } else {
      subscriptions.push(subscription);
    }
    return subscription;
  };
  Subscription.prototype.remove = function (subscription) {
    var subscriptions = this._subscriptions;
    if (subscriptions) {
      var subscriptionIndex = subscriptions.indexOf(subscription);
      if (subscriptionIndex !== -1) {
        subscriptions.splice(subscriptionIndex, 1);
      }
    }
  };
  Subscription.EMPTY = function (empty) {
    empty.closed = true;
    return empty;
  }(new Subscription());
  return Subscription;
}();
function flattenUnsubscriptionErrors(errors) {
  return errors.reduce(function (errs, err) {
    return errs.concat(err instanceof UnsubscriptionError ? err.errors : err);
  }, []);
}

/** PURE_IMPORTS_START  PURE_IMPORTS_END */
var rxSubscriber = /*@__PURE__*/function () {
  return typeof Symbol === 'function' ? /*@__PURE__*/Symbol('rxSubscriber') : '@@rxSubscriber_' + /*@__PURE__*/Math.random();
}();

/** PURE_IMPORTS_START tslib,_util_isFunction,_Observer,_Subscription,_internal_symbol_rxSubscriber,_config,_util_hostReportError PURE_IMPORTS_END */
var Subscriber = /*@__PURE__*/function (_super) {
  __extends(Subscriber, _super);
  function Subscriber(destinationOrNext, error, complete) {
    var _this = _super.call(this) || this;
    _this.syncErrorValue = null;
    _this.syncErrorThrown = false;
    _this.syncErrorThrowable = false;
    _this.isStopped = false;
    switch (arguments.length) {
      case 0:
        _this.destination = empty;
        break;
      case 1:
        if (!destinationOrNext) {
          _this.destination = empty;
          break;
        }
        if (typeof destinationOrNext === 'object') {
          if (destinationOrNext instanceof Subscriber) {
            _this.syncErrorThrowable = destinationOrNext.syncErrorThrowable;
            _this.destination = destinationOrNext;
            destinationOrNext.add(_this);
          } else {
            _this.syncErrorThrowable = true;
            _this.destination = new SafeSubscriber(_this, destinationOrNext);
          }
          break;
        }
      default:
        _this.syncErrorThrowable = true;
        _this.destination = new SafeSubscriber(_this, destinationOrNext, error, complete);
        break;
    }
    return _this;
  }
  Subscriber.prototype[rxSubscriber] = function () {
    return this;
  };
  Subscriber.create = function (next, error, complete) {
    var subscriber = new Subscriber(next, error, complete);
    subscriber.syncErrorThrowable = false;
    return subscriber;
  };
  Subscriber.prototype.next = function (value) {
    if (!this.isStopped) {
      this._next(value);
    }
  };
  Subscriber.prototype.error = function (err) {
    if (!this.isStopped) {
      this.isStopped = true;
      this._error(err);
    }
  };
  Subscriber.prototype.complete = function () {
    if (!this.isStopped) {
      this.isStopped = true;
      this._complete();
    }
  };
  Subscriber.prototype.unsubscribe = function () {
    if (this.closed) {
      return;
    }
    this.isStopped = true;
    _super.prototype.unsubscribe.call(this);
  };
  Subscriber.prototype._next = function (value) {
    this.destination.next(value);
  };
  Subscriber.prototype._error = function (err) {
    this.destination.error(err);
    this.unsubscribe();
  };
  Subscriber.prototype._complete = function () {
    this.destination.complete();
    this.unsubscribe();
  };
  Subscriber.prototype._unsubscribeAndRecycle = function () {
    var _parentOrParents = this._parentOrParents;
    this._parentOrParents = null;
    this.unsubscribe();
    this.closed = false;
    this.isStopped = false;
    this._parentOrParents = _parentOrParents;
    return this;
  };
  return Subscriber;
}(Subscription);
var SafeSubscriber = /*@__PURE__*/function (_super) {
  __extends(SafeSubscriber, _super);
  function SafeSubscriber(_parentSubscriber, observerOrNext, error, complete) {
    var _this = _super.call(this) || this;
    _this._parentSubscriber = _parentSubscriber;
    var next;
    var context = _this;
    if (isFunction(observerOrNext)) {
      next = observerOrNext;
    } else if (observerOrNext) {
      next = observerOrNext.next;
      error = observerOrNext.error;
      complete = observerOrNext.complete;
      if (observerOrNext !== empty) {
        context = Object.create(observerOrNext);
        if (isFunction(context.unsubscribe)) {
          _this.add(context.unsubscribe.bind(context));
        }
        context.unsubscribe = _this.unsubscribe.bind(_this);
      }
    }
    _this._context = context;
    _this._next = next;
    _this._error = error;
    _this._complete = complete;
    return _this;
  }
  SafeSubscriber.prototype.next = function (value) {
    if (!this.isStopped && this._next) {
      var _parentSubscriber = this._parentSubscriber;
      if (!config.useDeprecatedSynchronousErrorHandling || !_parentSubscriber.syncErrorThrowable) {
        this.__tryOrUnsub(this._next, value);
      } else if (this.__tryOrSetError(_parentSubscriber, this._next, value)) {
        this.unsubscribe();
      }
    }
  };
  SafeSubscriber.prototype.error = function (err) {
    if (!this.isStopped) {
      var _parentSubscriber = this._parentSubscriber;
      var useDeprecatedSynchronousErrorHandling = config.useDeprecatedSynchronousErrorHandling;
      if (this._error) {
        if (!useDeprecatedSynchronousErrorHandling || !_parentSubscriber.syncErrorThrowable) {
          this.__tryOrUnsub(this._error, err);
          this.unsubscribe();
        } else {
          this.__tryOrSetError(_parentSubscriber, this._error, err);
          this.unsubscribe();
        }
      } else if (!_parentSubscriber.syncErrorThrowable) {
        this.unsubscribe();
        if (useDeprecatedSynchronousErrorHandling) {
          throw err;
        }
        hostReportError(err);
      } else {
        if (useDeprecatedSynchronousErrorHandling) {
          _parentSubscriber.syncErrorValue = err;
          _parentSubscriber.syncErrorThrown = true;
        } else {
          hostReportError(err);
        }
        this.unsubscribe();
      }
    }
  };
  SafeSubscriber.prototype.complete = function () {
    var _this = this;
    if (!this.isStopped) {
      var _parentSubscriber = this._parentSubscriber;
      if (this._complete) {
        var wrappedComplete = function () {
          return _this._complete.call(_this._context);
        };
        if (!config.useDeprecatedSynchronousErrorHandling || !_parentSubscriber.syncErrorThrowable) {
          this.__tryOrUnsub(wrappedComplete);
          this.unsubscribe();
        } else {
          this.__tryOrSetError(_parentSubscriber, wrappedComplete);
          this.unsubscribe();
        }
      } else {
        this.unsubscribe();
      }
    }
  };
  SafeSubscriber.prototype.__tryOrUnsub = function (fn, value) {
    try {
      fn.call(this._context, value);
    } catch (err) {
      this.unsubscribe();
      if (config.useDeprecatedSynchronousErrorHandling) {
        throw err;
      } else {
        hostReportError(err);
      }
    }
  };
  SafeSubscriber.prototype.__tryOrSetError = function (parent, fn, value) {
    if (!config.useDeprecatedSynchronousErrorHandling) {
      throw new Error('bad call');
    }
    try {
      fn.call(this._context, value);
    } catch (err) {
      if (config.useDeprecatedSynchronousErrorHandling) {
        parent.syncErrorValue = err;
        parent.syncErrorThrown = true;
        return true;
      } else {
        hostReportError(err);
        return true;
      }
    }
    return false;
  };
  SafeSubscriber.prototype._unsubscribe = function () {
    var _parentSubscriber = this._parentSubscriber;
    this._context = null;
    this._parentSubscriber = null;
    _parentSubscriber.unsubscribe();
  };
  return SafeSubscriber;
}(Subscriber);

/** PURE_IMPORTS_START _Subscriber PURE_IMPORTS_END */
function canReportError(observer) {
  while (observer) {
    var _a = observer,
      closed_1 = _a.closed,
      destination = _a.destination,
      isStopped = _a.isStopped;
    if (closed_1 || isStopped) {
      return false;
    } else if (destination && destination instanceof Subscriber) {
      observer = destination;
    } else {
      observer = null;
    }
  }
  return true;
}

/** PURE_IMPORTS_START _Subscriber,_symbol_rxSubscriber,_Observer PURE_IMPORTS_END */
function toSubscriber(nextOrObserver, error, complete) {
  if (nextOrObserver) {
    if (nextOrObserver instanceof Subscriber) {
      return nextOrObserver;
    }
    if (nextOrObserver[rxSubscriber]) {
      return nextOrObserver[rxSubscriber]();
    }
  }
  if (!nextOrObserver && !error && !complete) {
    return new Subscriber(empty);
  }
  return new Subscriber(nextOrObserver, error, complete);
}

/** PURE_IMPORTS_START  PURE_IMPORTS_END */
var observable = /*@__PURE__*/function () {
  return typeof Symbol === 'function' && Symbol.observable || '@@observable';
}();

/** PURE_IMPORTS_START  PURE_IMPORTS_END */
function identity(x) {
  return x;
}

/** PURE_IMPORTS_START _identity PURE_IMPORTS_END */
function pipeFromArray(fns) {
  if (fns.length === 0) {
    return identity;
  }
  if (fns.length === 1) {
    return fns[0];
  }
  return function piped(input) {
    return fns.reduce(function (prev, fn) {
      return fn(prev);
    }, input);
  };
}

/** PURE_IMPORTS_START _util_canReportError,_util_toSubscriber,_symbol_observable,_util_pipe,_config PURE_IMPORTS_END */
var Observable = /*@__PURE__*/function () {
  function Observable(subscribe) {
    this._isScalar = false;
    if (subscribe) {
      this._subscribe = subscribe;
    }
  }
  Observable.prototype.lift = function (operator) {
    var observable = new Observable();
    observable.source = this;
    observable.operator = operator;
    return observable;
  };
  Observable.prototype.subscribe = function (observerOrNext, error, complete) {
    var operator = this.operator;
    var sink = toSubscriber(observerOrNext, error, complete);
    if (operator) {
      sink.add(operator.call(sink, this.source));
    } else {
      sink.add(this.source || config.useDeprecatedSynchronousErrorHandling && !sink.syncErrorThrowable ? this._subscribe(sink) : this._trySubscribe(sink));
    }
    if (config.useDeprecatedSynchronousErrorHandling) {
      if (sink.syncErrorThrowable) {
        sink.syncErrorThrowable = false;
        if (sink.syncErrorThrown) {
          throw sink.syncErrorValue;
        }
      }
    }
    return sink;
  };
  Observable.prototype._trySubscribe = function (sink) {
    try {
      return this._subscribe(sink);
    } catch (err) {
      if (config.useDeprecatedSynchronousErrorHandling) {
        sink.syncErrorThrown = true;
        sink.syncErrorValue = err;
      }
      if (canReportError(sink)) {
        sink.error(err);
      } else {
        console.warn(err);
      }
    }
  };
  Observable.prototype.forEach = function (next, promiseCtor) {
    var _this = this;
    promiseCtor = getPromiseCtor(promiseCtor);
    return new promiseCtor(function (resolve, reject) {
      var subscription;
      subscription = _this.subscribe(function (value) {
        try {
          next(value);
        } catch (err) {
          reject(err);
          if (subscription) {
            subscription.unsubscribe();
          }
        }
      }, reject, resolve);
    });
  };
  Observable.prototype._subscribe = function (subscriber) {
    var source = this.source;
    return source && source.subscribe(subscriber);
  };
  Observable.prototype[observable] = function () {
    return this;
  };
  Observable.prototype.pipe = function () {
    var operations = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      operations[_i] = arguments[_i];
    }
    if (operations.length === 0) {
      return this;
    }
    return pipeFromArray(operations)(this);
  };
  Observable.prototype.toPromise = function (promiseCtor) {
    var _this = this;
    promiseCtor = getPromiseCtor(promiseCtor);
    return new promiseCtor(function (resolve, reject) {
      var value;
      _this.subscribe(function (x) {
        return value = x;
      }, function (err) {
        return reject(err);
      }, function () {
        return resolve(value);
      });
    });
  };
  Observable.create = function (subscribe) {
    return new Observable(subscribe);
  };
  return Observable;
}();
function getPromiseCtor(promiseCtor) {
  if (!promiseCtor) {
    promiseCtor = Promise;
  }
  if (!promiseCtor) {
    throw new Error('no Promise impl found');
  }
  return promiseCtor;
}

/** PURE_IMPORTS_START  PURE_IMPORTS_END */
var subscribeToArray = function (array) {
  return function (subscriber) {
    for (var i = 0, len = array.length; i < len && !subscriber.closed; i++) {
      subscriber.next(array[i]);
    }
    subscriber.complete();
  };
};

/** PURE_IMPORTS_START _hostReportError PURE_IMPORTS_END */
var subscribeToPromise = function (promise) {
  return function (subscriber) {
    promise.then(function (value) {
      if (!subscriber.closed) {
        subscriber.next(value);
        subscriber.complete();
      }
    }, function (err) {
      return subscriber.error(err);
    }).then(null, hostReportError);
    return subscriber;
  };
};

/** PURE_IMPORTS_START  PURE_IMPORTS_END */
function getSymbolIterator() {
  if (typeof Symbol !== 'function' || !Symbol.iterator) {
    return '@@iterator';
  }
  return Symbol.iterator;
}
var iterator = /*@__PURE__*/getSymbolIterator();

/** PURE_IMPORTS_START _symbol_iterator PURE_IMPORTS_END */
var subscribeToIterable = function (iterable) {
  return function (subscriber) {
    var iterator$1 = iterable[iterator]();
    do {
      var item = void 0;
      try {
        item = iterator$1.next();
      } catch (err) {
        subscriber.error(err);
        return subscriber;
      }
      if (item.done) {
        subscriber.complete();
        break;
      }
      subscriber.next(item.value);
      if (subscriber.closed) {
        break;
      }
    } while (true);
    if (typeof iterator$1.return === 'function') {
      subscriber.add(function () {
        if (iterator$1.return) {
          iterator$1.return();
        }
      });
    }
    return subscriber;
  };
};

/** PURE_IMPORTS_START _symbol_observable PURE_IMPORTS_END */
var subscribeToObservable = function (obj) {
  return function (subscriber) {
    var obs = obj[observable]();
    if (typeof obs.subscribe !== 'function') {
      throw new TypeError('Provided object does not correctly implement Symbol.observable');
    } else {
      return obs.subscribe(subscriber);
    }
  };
};

/** PURE_IMPORTS_START  PURE_IMPORTS_END */
var isArrayLike = function (x) {
  return x && typeof x.length === 'number' && typeof x !== 'function';
};

/** PURE_IMPORTS_START  PURE_IMPORTS_END */
function isPromise(value) {
  return !!value && typeof value.subscribe !== 'function' && typeof value.then === 'function';
}

/** PURE_IMPORTS_START _subscribeToArray,_subscribeToPromise,_subscribeToIterable,_subscribeToObservable,_isArrayLike,_isPromise,_isObject,_symbol_iterator,_symbol_observable PURE_IMPORTS_END */
var subscribeTo = function (result) {
  if (!!result && typeof result[observable] === 'function') {
    return subscribeToObservable(result);
  } else if (isArrayLike(result)) {
    return subscribeToArray(result);
  } else if (isPromise(result)) {
    return subscribeToPromise(result);
  } else if (!!result && typeof result[iterator] === 'function') {
    return subscribeToIterable(result);
  } else {
    var value = isObject(result) ? 'an invalid object' : "'" + result + "'";
    var msg = "You provided " + value + " where a stream was expected." + ' You can provide an Observable, Promise, Array, or Iterable.';
    throw new TypeError(msg);
  }
};

/** PURE_IMPORTS_START tslib,_Subscriber,_Observable,_util_subscribeTo PURE_IMPORTS_END */
var SimpleInnerSubscriber = /*@__PURE__*/function (_super) {
  __extends(SimpleInnerSubscriber, _super);
  function SimpleInnerSubscriber(parent) {
    var _this = _super.call(this) || this;
    _this.parent = parent;
    return _this;
  }
  SimpleInnerSubscriber.prototype._next = function (value) {
    this.parent.notifyNext(value);
  };
  SimpleInnerSubscriber.prototype._error = function (error) {
    this.parent.notifyError(error);
    this.unsubscribe();
  };
  SimpleInnerSubscriber.prototype._complete = function () {
    this.parent.notifyComplete();
    this.unsubscribe();
  };
  return SimpleInnerSubscriber;
}(Subscriber);
var SimpleOuterSubscriber = /*@__PURE__*/function (_super) {
  __extends(SimpleOuterSubscriber, _super);
  function SimpleOuterSubscriber() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  SimpleOuterSubscriber.prototype.notifyNext = function (innerValue) {
    this.destination.next(innerValue);
  };
  SimpleOuterSubscriber.prototype.notifyError = function (err) {
    this.destination.error(err);
  };
  SimpleOuterSubscriber.prototype.notifyComplete = function () {
    this.destination.complete();
  };
  return SimpleOuterSubscriber;
}(Subscriber);
function innerSubscribe(result, innerSubscriber) {
  if (innerSubscriber.closed) {
    return undefined;
  }
  if (result instanceof Observable) {
    return result.subscribe(innerSubscriber);
  }
  var subscription;
  try {
    subscription = subscribeTo(result)(innerSubscriber);
  } catch (error) {
    innerSubscriber.error(error);
  }
  return subscription;
}

/** PURE_IMPORTS_START tslib,_Subscription PURE_IMPORTS_END */
var Action = /*@__PURE__*/function (_super) {
  __extends(Action, _super);
  function Action(scheduler, work) {
    return _super.call(this) || this;
  }
  Action.prototype.schedule = function (state, delay) {
    return this;
  };
  return Action;
}(Subscription);

/** PURE_IMPORTS_START tslib,_Action PURE_IMPORTS_END */
var AsyncAction = /*@__PURE__*/function (_super) {
  __extends(AsyncAction, _super);
  function AsyncAction(scheduler, work) {
    var _this = _super.call(this, scheduler, work) || this;
    _this.scheduler = scheduler;
    _this.work = work;
    _this.pending = false;
    return _this;
  }
  AsyncAction.prototype.schedule = function (state, delay) {
    if (delay === void 0) {
      delay = 0;
    }
    if (this.closed) {
      return this;
    }
    this.state = state;
    var id = this.id;
    var scheduler = this.scheduler;
    if (id != null) {
      this.id = this.recycleAsyncId(scheduler, id, delay);
    }
    this.pending = true;
    this.delay = delay;
    this.id = this.id || this.requestAsyncId(scheduler, this.id, delay);
    return this;
  };
  AsyncAction.prototype.requestAsyncId = function (scheduler, id, delay) {
    if (delay === void 0) {
      delay = 0;
    }
    return setInterval(scheduler.flush.bind(scheduler, this), delay);
  };
  AsyncAction.prototype.recycleAsyncId = function (scheduler, id, delay) {
    if (delay === void 0) {
      delay = 0;
    }
    if (delay !== null && this.delay === delay && this.pending === false) {
      return id;
    }
    clearInterval(id);
    return undefined;
  };
  AsyncAction.prototype.execute = function (state, delay) {
    if (this.closed) {
      return new Error('executing a cancelled action');
    }
    this.pending = false;
    var error = this._execute(state, delay);
    if (error) {
      return error;
    } else if (this.pending === false && this.id != null) {
      this.id = this.recycleAsyncId(this.scheduler, this.id, null);
    }
  };
  AsyncAction.prototype._execute = function (state, delay) {
    var errored = false;
    var errorValue = undefined;
    try {
      this.work(state);
    } catch (e) {
      errored = true;
      errorValue = !!e && e || new Error(e);
    }
    if (errored) {
      this.unsubscribe();
      return errorValue;
    }
  };
  AsyncAction.prototype._unsubscribe = function () {
    var id = this.id;
    var scheduler = this.scheduler;
    var actions = scheduler.actions;
    var index = actions.indexOf(this);
    this.work = null;
    this.state = null;
    this.pending = false;
    this.scheduler = null;
    if (index !== -1) {
      actions.splice(index, 1);
    }
    if (id != null) {
      this.id = this.recycleAsyncId(scheduler, id, null);
    }
    this.delay = null;
  };
  return AsyncAction;
}(Action);

var Scheduler = /*@__PURE__*/function () {
  function Scheduler(SchedulerAction, now) {
    if (now === void 0) {
      now = Scheduler.now;
    }
    this.SchedulerAction = SchedulerAction;
    this.now = now;
  }
  Scheduler.prototype.schedule = function (work, delay, state) {
    if (delay === void 0) {
      delay = 0;
    }
    return new this.SchedulerAction(this, work).schedule(state, delay);
  };
  Scheduler.now = function () {
    return Date.now();
  };
  return Scheduler;
}();

/** PURE_IMPORTS_START tslib,_Scheduler PURE_IMPORTS_END */
var AsyncScheduler = /*@__PURE__*/function (_super) {
  __extends(AsyncScheduler, _super);
  function AsyncScheduler(SchedulerAction, now) {
    if (now === void 0) {
      now = Scheduler.now;
    }
    var _this = _super.call(this, SchedulerAction, function () {
      if (AsyncScheduler.delegate && AsyncScheduler.delegate !== _this) {
        return AsyncScheduler.delegate.now();
      } else {
        return now();
      }
    }) || this;
    _this.actions = [];
    _this.active = false;
    _this.scheduled = undefined;
    return _this;
  }
  AsyncScheduler.prototype.schedule = function (work, delay, state) {
    if (delay === void 0) {
      delay = 0;
    }
    if (AsyncScheduler.delegate && AsyncScheduler.delegate !== this) {
      return AsyncScheduler.delegate.schedule(work, delay, state);
    } else {
      return _super.prototype.schedule.call(this, work, delay, state);
    }
  };
  AsyncScheduler.prototype.flush = function (action) {
    var actions = this.actions;
    if (this.active) {
      actions.push(action);
      return;
    }
    var error;
    this.active = true;
    do {
      if (error = action.execute(action.state, action.delay)) {
        break;
      }
    } while (action = actions.shift());
    this.active = false;
    if (error) {
      while (action = actions.shift()) {
        action.unsubscribe();
      }
      throw error;
    }
  };
  return AsyncScheduler;
}(Scheduler);

/** PURE_IMPORTS_START _AsyncAction,_AsyncScheduler PURE_IMPORTS_END */
var asyncScheduler = /*@__PURE__*/new AsyncScheduler(AsyncAction);
var async = asyncScheduler;

/** PURE_IMPORTS_START _Observable,_util_subscribeTo,_scheduled_scheduled PURE_IMPORTS_END */
function from(input, scheduler) {
  {
    if (input instanceof Observable) {
      return input;
    }
    return new Observable(subscribeTo(input));
  }
}

/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */
function map(project, thisArg) {
  return function mapOperation(source) {
    if (typeof project !== 'function') {
      throw new TypeError('argument is not a function. Are you looking for `mapTo()`?');
    }
    return source.lift(new MapOperator(project, thisArg));
  };
}
var MapOperator = /*@__PURE__*/function () {
  function MapOperator(project, thisArg) {
    this.project = project;
    this.thisArg = thisArg;
  }
  MapOperator.prototype.call = function (subscriber, source) {
    return source.subscribe(new MapSubscriber(subscriber, this.project, this.thisArg));
  };
  return MapOperator;
}();
var MapSubscriber = /*@__PURE__*/function (_super) {
  __extends(MapSubscriber, _super);
  function MapSubscriber(destination, project, thisArg) {
    var _this = _super.call(this, destination) || this;
    _this.project = project;
    _this.count = 0;
    _this.thisArg = thisArg || _this;
    return _this;
  }
  MapSubscriber.prototype._next = function (value) {
    var result;
    try {
      result = this.project.call(this.thisArg, value, this.count++);
    } catch (err) {
      this.destination.error(err);
      return;
    }
    this.destination.next(result);
  };
  return MapSubscriber;
}(Subscriber);

/** PURE_IMPORTS_START tslib,_map,_observable_from,_innerSubscribe PURE_IMPORTS_END */
function mergeMap(project, resultSelector, concurrent) {
  if (concurrent === void 0) {
    concurrent = Number.POSITIVE_INFINITY;
  }
  if (typeof resultSelector === 'function') {
    return function (source) {
      return source.pipe(mergeMap(function (a, i) {
        return from(project(a, i)).pipe(map(function (b, ii) {
          return resultSelector(a, b, i, ii);
        }));
      }, concurrent));
    };
  } else if (typeof resultSelector === 'number') {
    concurrent = resultSelector;
  }
  return function (source) {
    return source.lift(new MergeMapOperator(project, concurrent));
  };
}
var MergeMapOperator = /*@__PURE__*/function () {
  function MergeMapOperator(project, concurrent) {
    if (concurrent === void 0) {
      concurrent = Number.POSITIVE_INFINITY;
    }
    this.project = project;
    this.concurrent = concurrent;
  }
  MergeMapOperator.prototype.call = function (observer, source) {
    return source.subscribe(new MergeMapSubscriber(observer, this.project, this.concurrent));
  };
  return MergeMapOperator;
}();
var MergeMapSubscriber = /*@__PURE__*/function (_super) {
  __extends(MergeMapSubscriber, _super);
  function MergeMapSubscriber(destination, project, concurrent) {
    if (concurrent === void 0) {
      concurrent = Number.POSITIVE_INFINITY;
    }
    var _this = _super.call(this, destination) || this;
    _this.project = project;
    _this.concurrent = concurrent;
    _this.hasCompleted = false;
    _this.buffer = [];
    _this.active = 0;
    _this.index = 0;
    return _this;
  }
  MergeMapSubscriber.prototype._next = function (value) {
    if (this.active < this.concurrent) {
      this._tryNext(value);
    } else {
      this.buffer.push(value);
    }
  };
  MergeMapSubscriber.prototype._tryNext = function (value) {
    var result;
    var index = this.index++;
    try {
      result = this.project(value, index);
    } catch (err) {
      this.destination.error(err);
      return;
    }
    this.active++;
    this._innerSub(result);
  };
  MergeMapSubscriber.prototype._innerSub = function (ish) {
    var innerSubscriber = new SimpleInnerSubscriber(this);
    var destination = this.destination;
    destination.add(innerSubscriber);
    var innerSubscription = innerSubscribe(ish, innerSubscriber);
    if (innerSubscription !== innerSubscriber) {
      destination.add(innerSubscription);
    }
  };
  MergeMapSubscriber.prototype._complete = function () {
    this.hasCompleted = true;
    if (this.active === 0 && this.buffer.length === 0) {
      this.destination.complete();
    }
    this.unsubscribe();
  };
  MergeMapSubscriber.prototype.notifyNext = function (innerValue) {
    this.destination.next(innerValue);
  };
  MergeMapSubscriber.prototype.notifyComplete = function () {
    var buffer = this.buffer;
    this.active--;
    if (buffer.length > 0) {
      this._next(buffer.shift());
    } else if (this.active === 0 && this.hasCompleted) {
      this.destination.complete();
    }
  };
  return MergeMapSubscriber;
}(SimpleOuterSubscriber);

/** PURE_IMPORTS_START _mergeMap PURE_IMPORTS_END */
function concatMap(project, resultSelector) {
  return mergeMap(project, resultSelector, 1);
}

/** PURE_IMPORTS_START tslib,_Subscriber,_scheduler_async PURE_IMPORTS_END */
function debounceTime(dueTime, scheduler) {
  if (scheduler === void 0) {
    scheduler = async;
  }
  return function (source) {
    return source.lift(new DebounceTimeOperator(dueTime, scheduler));
  };
}
var DebounceTimeOperator = /*@__PURE__*/function () {
  function DebounceTimeOperator(dueTime, scheduler) {
    this.dueTime = dueTime;
    this.scheduler = scheduler;
  }
  DebounceTimeOperator.prototype.call = function (subscriber, source) {
    return source.subscribe(new DebounceTimeSubscriber(subscriber, this.dueTime, this.scheduler));
  };
  return DebounceTimeOperator;
}();
var DebounceTimeSubscriber = /*@__PURE__*/function (_super) {
  __extends(DebounceTimeSubscriber, _super);
  function DebounceTimeSubscriber(destination, dueTime, scheduler) {
    var _this = _super.call(this, destination) || this;
    _this.dueTime = dueTime;
    _this.scheduler = scheduler;
    _this.debouncedSubscription = null;
    _this.lastValue = null;
    _this.hasValue = false;
    return _this;
  }
  DebounceTimeSubscriber.prototype._next = function (value) {
    this.clearDebounce();
    this.lastValue = value;
    this.hasValue = true;
    this.add(this.debouncedSubscription = this.scheduler.schedule(dispatchNext, this.dueTime, this));
  };
  DebounceTimeSubscriber.prototype._complete = function () {
    this.debouncedNext();
    this.destination.complete();
  };
  DebounceTimeSubscriber.prototype.debouncedNext = function () {
    this.clearDebounce();
    if (this.hasValue) {
      var lastValue = this.lastValue;
      this.lastValue = null;
      this.hasValue = false;
      this.destination.next(lastValue);
    }
  };
  DebounceTimeSubscriber.prototype.clearDebounce = function () {
    var debouncedSubscription = this.debouncedSubscription;
    if (debouncedSubscription !== null) {
      this.remove(debouncedSubscription);
      debouncedSubscription.unsubscribe();
      this.debouncedSubscription = null;
    }
  };
  return DebounceTimeSubscriber;
}(Subscriber);
function dispatchNext(subscriber) {
  subscriber.debouncedNext();
}

function mergeInCart(cart, sellingDevice, currency, currentTicketPriceQuantities) {
  var cartItemList = convertToCartItemList(currentTicketPriceQuantities);
  return cart.merge({
    sellingDevice: sellingDevice,
    currency: currency,
    cartItemList: cartItemList
  });
}
function updateCart(state$, cartAtomId) {
  var _getSellingDevice$get, _getSellingDevice;
  var baseState = state$.value;
  var cart = getAtomCart(baseState, cartAtomId) || new Cart({
    '@type': 'Cart',
    '@id': null
  });
  var cartType = getAtomCartType(baseState, cartAtomId);
  var cartStatus = getAtomCartStatus(baseState, cartAtomId);
  var currentTicketPriceQuantities = getAtomTicketPriceQuantities(baseState, cartAtomId);
  if (currentTicketPriceQuantities.isEmpty() && !cart.get('@id')) {
    // No cart on the API yet and nothing to send: nothing to do.
    // This can happen when the user adds then removes a tariff within the debounce window,
    // or after an error rollback empties currentTicketPriceQuantities.
    return EMPTY;
  }
  var sellingDevice = (_getSellingDevice$get = (_getSellingDevice = getSellingDevice(baseState)) === null || _getSellingDevice === void 0 ? void 0 : _getSellingDevice.get('@id')) !== null && _getSellingDevice$get !== void 0 ? _getSellingDevice$get : null;
  var currency = cart.currency || currentTicketPriceQuantities.getIn([0, 'ticketPrice', 'currency']);
  if (typeof currency !== 'string') {
    throw new Error('Currency should be available in the injected TicketPrice from `currentTicketPriceQuantities`.');
  }
  var newCart = mergeInCart(cart, sellingDevice, currency, currentTicketPriceQuantities);
  if (cartType) {
    newCart = newCart.set('type', cartType).set('isOption', cartType === CART_TYPE.OPTION);
  }
  if (cartStatus) {
    newCart = newCart.set('status', cartStatus);
  }
  return concat(of({
    type: FETCH_CART_STARTED,
    cartAtomId: cartAtomId
  }), of({
    type: FETCH_CART_UPDATE,
    cartAtomId: cartAtomId
  }), from$1(createOrUpdateCart(newCart, cartAtomId)));
}
var cartEpic = function cartEpic(action$, state$) {
  return action$.pipe(ofType(SET_TICKET_PRICE_QUANTITY),
  // catch all these type of actions…
  debounceTime(450),
  // … and wait 450 ms. switchMap will ignore take only THE LAST ACTION that happend during this 450 ms
  concatMap(function (action) {
    // concatMap ensures that previous request has completed before sending next one
    return updateCart(state$, action.cartAtomId);
  }));
};

var CartSaverMiddleware = function CartSaverMiddleware(store) {
  return function (next) {
    return function (action) {
      var out = next(action);
      var originTypeEnv = getOriginTypeEnv(store.getState());
      var cartStatus = getAtomCartStatus(store.getState(), action.cartAtomId);
      if (action.type === CART_RECEIVED && cartStatus !== CART_STATUS.VALIDATED) {
        store.dispatch(processPendingTicketPriceQuantities(action.cartAtomId));
        if (action.cart.cartItemWithOfferList.size &&
        // only save the cart id, not reservation ones.
        action.cartAtomId === SHOPPING_CART) {
          store.dispatch(saveCart(action.cart, originTypeEnv));
        }
      }
      if (action.type === SET_CART_AS_SHOPPING_CART) {
        // force to set the reservation as a cartId means that we want to save the cart into the local storage too
        store.dispatch(saveCart(action.cartAtomId, originTypeEnv));
      }
      if (action.type === DISCARD_CART) {
        store.dispatch(deleteCart(action.cartAtomId, originTypeEnv));
      }
      return out;
    };
  };
};

var baseCartState = Map({
  currentTicketPriceQuantities: List(),
  oldCurrentTicketPriceQuantitiesIfError: List(),
  pendingTicketPriceQuantities: List(),
  currentCart: null,
  currentCartUpdating: false,
  offerClusterList: List(),
  noOfferCartItemWithOfferList: List(),
  cartType: undefined,
  cartStatus: undefined,
  hasCartIdInStorage: null,
  bookingError: null,
  'mapado:error': null
});
var baseInnerState = Map({}).merge(baseCartState);
function cartReceived(state, receivedCart, originTypeEnv) {
  // if a reservation has been taken online, the cart should be discarded.
  // a resetCart redux event has already been dispatched, but was handled in the
  // cart-checkout redux store, and not in the current store.
  // the issue only affects minisite. We should not send such a resetCart event
  // from the desk
  if (document.getElementById('contentContainerBottom') && !document.getElementById('mpd-cart-checkout') && receivedCart && receivedCart.type === CART_TYPE.RESERVATION) {
    return resetCart(state);
  }
  var cart = receivedCart;
  if (!cart.cartItemWithOfferList) {
    cart = cart.set('cartItemWithOfferList', List());
  }

  // @ts-expect-error Possible missunderstanding with `getCartDerivedState`
  var newState = state.merge(_objectSpread2({
    currentCartUpdating: false,
    bookingError: null,
    'mapado:error': null,
    currentCart: cart
  }, getCartDerivedState(originTypeEnv, cart)));
  return newState;
}
function resetCart(state) {
  return state.set('currentCart', null);
}
function getCartDerivedState(originTypeEnv, cart) {
  if (!cart) {
    return {};
  }
  var currentTicketPriceQuantities = convertCartToTicketPriceQuantity(cart, originTypeEnv);
  var offerClusterMap = generateOfferClusterMap(cart);
  return {
    currentTicketPriceQuantities: currentTicketPriceQuantities,
    offerClusterList: offerClusterMap.get('offerClusterList'),
    noOfferCartItemWithOfferList: offerClusterMap.get('noOfferCartItemWithOfferList')
  };
}
function setTicketPriceQuantity(state, ticketPriceQuantityList, cartType, cartStatus) {
  var immutableTicketPriceQuantityMaybeObjectList = !List.isList(ticketPriceQuantityList) ? List(ticketPriceQuantityList) : ticketPriceQuantityList;
  var immutableTicketPriceQuantityList = immutableTicketPriceQuantityMaybeObjectList.map(function (item) {
    return Map.isMap(item) ? item : fromJS(item);
  });
  var pendingTicketPriceQuantities = state.get('pendingTicketPriceQuantities', List()).concat(immutableTicketPriceQuantityList);
  var currentTicketPriceQuantities = state.get('currentTicketPriceQuantities');
  var newTicketPriceQuantities = currentTicketPriceQuantities.concat(immutableTicketPriceQuantityList);
  var flattenedTicketPriceQuantities = processTicketPriceQuantities(newTicketPriceQuantities);

  // Only mark as "updating" if there's actually something to send to the API:
  // either there are ticket prices to sync, or there's an existing cart to update.
  var needsApiUpdate = !flattenedTicketPriceQuantities.isEmpty() || state.get('currentCart') !== null;
  var newState = state.set('currentTicketPriceQuantities', flattenedTicketPriceQuantities).set('pendingTicketPriceQuantities', pendingTicketPriceQuantities).set('oldCurrentTicketPriceQuantitiesIfError', currentTicketPriceQuantities).set('currentCartUpdating', needsApiUpdate).set('cartType', cartType || state.get('cartType')).set('cartStatus', cartStatus || state.get('cartStatus'));
  return newState;
}

/**
 * If an action does implements this interface, then the sub-reducer will not be the one
 * of the state.booking.currentCartAtomId, but the one of the given cartAtomId
 */

/**
 * This is the old reducer that did work fine with only one cart.
 * As the new reducer is multi-cart, we keep this one and decorate it with the
 * new `bookingReducer` method.
 * Everything in here still works fine on one cart
 */
function innerBookingReducer(state, action, originTypeEnv) {
  switch (action.type) {
    case FETCH_CART_UPDATE:
      return state.set('pendingTicketPriceQuantities', List());
    case CART_RECEIVED:
      return cartReceived(state, action.cart, originTypeEnv);
    case CART_BOOKING_ERROR:
      {
        var bookingErrorState = {
          bookingError: action.error,
          'mapado:error': action['mapado:error'] ? fromJS(action['mapado:error']) : null,
          currentCartUpdating: false
        };

        // If reset is true, clear ticket price quantities and related state
        if (action.reset) {
          // reset pending (they did trigger the error)
          // and remove currentTicketPriceQuantities linked to those pending ones (we do not want them to stay in the store)
          bookingErrorState.pendingTicketPriceQuantities = List();
          bookingErrorState.currentTicketPriceQuantities = state.get('oldCurrentTicketPriceQuantitiesIfError');
        }

        // @ts-expect-error issue with Map.merge type definition
        return state.merge(bookingErrorState);
      }
    case DISMISS_CART_BOOKING_ERROR:
      // @ts-expect-error issue with Map.merge type definition
      return state.merge({
        bookingError: null,
        'mapado:error': null
      });
    case RESET_PENDING_TICKET_PRICE_QUANTITIES:
      return state.set('pendingTicketPriceQuantities', List());
    case SET_TICKET_PRICE_QUANTITY:
      return setTicketPriceQuantity(state, action.ticketPriceList, action.cartType, action.cartStatus);
    case DISCARD_CART:
      // @ts-expect-error issue with Map merge type definition
      return state.merge(baseCartState);
    case UPDATE_COMMENT:
      return state.setIn(['currentCart', 'comment'], action.comment);
    case UPDATE_CUSTOMERS:
      return state.setIn(['currentCart', 'customer'], action.customer).setIn(['currentCart', 'contact'], action.contact);
    case UPDATE_OWNER:
      return state.setIn(['currentCart', 'owner'], action.owner);
    case FETCH_CART_STARTED:
      return state.set('currentCartUpdating', true);
    case FETCH_CART_ENDED:
      return state.set('currentCartUpdating', false);
    case SET_HAS_CART_ID_IN_STORAGE:
      {
        if (action.hasCartIdInStorage) {
          return state.set('hasCartIdInStorage', action.hasCartIdInStorage);
        }

        // @ts-expect-error issue with Map merge type definition
        var stateWithBaseCartState = state.merge(baseCartState);
        return stateWithBaseCartState.set('hasCartIdInStorage', action.hasCartIdInStorage);
      }
    default:
      return state;
  }
}

/** Test that the specified cartAtomId is the `SHOPPING_CART` already */
var cartAtomIdIsTheShoppingCart = function cartAtomIdIsTheShoppingCart(cartAtomId, multiState) {
  return cartAtomId === multiState[SHOPPING_CART].getIn(['currentCart', '@id']);
};
function isActionWithCartAtomId(action) {
  return 'cartAtomId' in action;
}
var baseState = {
  currentCartAtomId: SHOPPING_CART,
  sellingDevice: null,
  originTypeEnv: null,
  shoppingCart: baseInnerState
};
function bookingReducer() {
  var multiState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : baseState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case SET_CART_ID:
      {
        var cartAtomId = action.cartAtomId;
        if (cartAtomId in multiState) {
          return multiState;
        }
        if (cartAtomIdIsTheShoppingCart(cartAtomId, multiState)) {
          return _objectSpread2(_objectSpread2({}, multiState), {}, {
            currentCartAtomId: SHOPPING_CART
          });
        }
        return _objectSpread2(_objectSpread2({}, multiState), {}, _defineProperty({
          currentCartAtomId: cartAtomId
        }, cartAtomId, baseInnerState));
      }
    case FREE_CART_ID:
      {
        var _cartAtomId = action.cartAtomId;
        var nextKey = multiState.currentCartAtomId === _cartAtomId ? SHOPPING_CART : multiState.currentCartAtomId;
        var nextState = _objectSpread2(_objectSpread2({}, multiState), {}, {
          currentCartAtomId: nextKey
        });
        delete nextState[_cartAtomId];
        return nextState;
      }
    case SET_CART_AS_SHOPPING_CART:
      {
        var _cartAtomId2 = action.cartAtomId;
        if (cartAtomIdIsTheShoppingCart(_cartAtomId2, multiState)) {
          // if this is already the shopping cart, do nothing
          return _objectSpread2(_objectSpread2({}, multiState), {}, {
            currentCartAtomId: SHOPPING_CART
          });
        }
        if (!(_cartAtomId2 in multiState)) {
          throw new Error("Unable to set ".concat(_cartAtomId2, " as shopping cart as it has not be loaded in state already."));
        }
        var innerState = multiState[_cartAtomId2];
        return _objectSpread2(_objectSpread2({}, multiState), {}, _defineProperty({
          currentCartAtomId: SHOPPING_CART
        }, SHOPPING_CART, innerState));
      }
    case SET_SELLING_DEVICE:
      {
        if (!action.sellingDevice) {
          return _objectSpread2(_objectSpread2({}, multiState), {}, {
            sellingDevice: null
          });
        }
        return _objectSpread2(_objectSpread2({}, multiState), {}, {
          sellingDevice: new SellingDevice(action.sellingDevice)
        });
      }
    case SET_BOOKING_ORIGIN_TYPE_ENV:
      {
        var originTypeEnv = action.originTypeEnv;
        return _objectSpread2(_objectSpread2({}, multiState), {}, {
          originTypeEnv: originTypeEnv
        });
      }
    default:
      {
        var _cartAtomId3 = isActionWithCartAtomId(action) && action.cartAtomId in multiState ? action.cartAtomId : multiState.currentCartAtomId;
        var state = multiState[_cartAtomId3];
        var newState = innerBookingReducer(state, action, multiState.originTypeEnv);
        return _objectSpread2(_objectSpread2({}, multiState), {}, _defineProperty({}, _cartAtomId3, newState));
      }
  }
}

export { CART_RECEIVED, CART_WITH_ALL_FIELDS, CartItemQuantityInput, CartItemsList, CartProvider, CartSaverMiddleware, CouponModalButton, EmptyCart, MAX_QUANTITY, NO_STOCK_CONTINGENT, SELLING_DEVICE_DESK, SELLING_DEVICE_MINISITE, SHOPPING_CART, SidebarSummary, bookingReducer, cartEpic, createOrUpdateCart, discardCart, discardOrDeleteCart, eventDateType, getCIWOUSeat, getCartItemQuantityForAvailableSeat, getCartStatus, getCartType, getCurrentCart, getCurrentCartUpdating, getCurrentTicketPriceQuantities, getSellingDevice, getShoppingCart, i18n, offerType, setBookingOriginTypeEnv, splitCart, useAtomCart, useCartViewContext, useCartViewPlanContext, useChangeAvailableSeatTicketPrice, useChangeTicketPriceQuantity, useConvertCartToReservationOrOption, useCurrentCart, useCurrentCartAtomId, useCurrentCartBookingError, useCurrentCartHasOffers, useCurrentCartMapadoError, useCurrentCartUpdating, useCurrentTicketPriceQuantities, useDecrementTicketPriceListWithGroupKey, useDeleteSelectedCartItemWithOfferList, useDiscardCart, useDiscardOrDeleteCart, useDismissCartBookingError, useFreeCartId, useHasCartIdInStorage, useIncrementTicketPriceListWithGroupKeyList, useLoadCart, useLockSeatsForEventDate, useRemoveCartItemFromCurrentCart, useReplaceTicketPriceListWithGroupKey, useSelectedCartItemContext, useSellingDevice, useSetBookingOriginTypeEnv, useSetCartAsShoppingCart, useSetSellingDevice, useSetTicketPriceQuantity, useShoppingCart, useShoppingCartTicketPriceQuantities, useTicketPriceQuantityInCart, useUpdateComment, useUpdateCustomers, useUpdateExistingTicketPriceQuantity, useUpdateOwner };
//# sourceMappingURL=index.js.map
